import { ChangeDetectorRef, Component, EventEmitter, HostBinding, HostListener, OnInit, Output, TemplateRef, ViewChild, Input, DoCheck, KeyValueDiffers, Renderer2, ElementRef, ViewChildren, QueryList, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DndDropEvent, DropEffect } from 'ngx-drag-drop';
import { field, value } from '../global.model';
import { SettingService } from '../../settings/services/settingService/setting.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from '../services/forms.service';
import { Router } from '@angular/router';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormBuilder } from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import { AddSubFolderVM } from 'src/app/viewModels/core/add-sub-folder-vm';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { SignaturePad } from 'angular2-signaturepad';
import { ResizedEvent } from 'angular-resize-event';
import { saveAs } from 'file-saver';
import { I18nInterface } from 'ngx-image-drawing'
import { I } from '@angular/cdk/keycodes';
import { elementAt } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { image } from 'html2canvas/dist/types/css/types/image';
import { ModuleName } from '../services/form.enum';
import { log } from 'console';
import { CKEditorComponent } from 'ckeditor4-angular';
import { ImportMyDriveListComponent } from 'src/app/middleware/common/importMyDrive/importMyDrive.component';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { AddSignatureComponent } from 'src/app/middleware/common/addSignature/addSignature.component';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss'],
  //host: {"(window:resize)":"onWindowResize($event)"}
})
export class StepThreeComponent implements OnInit, DoCheck {
  public editorConfig = {
    versionCheck: false
  };
  
  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
      ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
      ['Link', 'Unlink', 'Anchor'],
      ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['TextColor', 'BGColor'],
      ['Maximize', 'ShowBlocks']
    ]
  };
  databaseId: string;
  organizationId: string;
  currentUser: any;
  getFieldsListResponseHolder: any;
  corefieldsList: any[] = [];
  corefieldsDragList: any[] = [];
  contactfieldsList: any[] = [];
  companyfieldsList: any[] = [];
  folderList: any[] = [];
  subFolderID: number = 0;
  participantAdded: boolean = true;

  openRight: boolean = false
  stepCompleted: number = 2;
  ControlForReplcaArray: any = [];
  autoFill: boolean;
  verifiedIconHasClass: any;
  multiSelectCurrentItem: any;
  coreContactCompanyType: any = "";
  SAItext: boolean;
  aiAnswer: string;
  AIDocuments: any;
  selectedAIDocs: any;
  showDocumentsToselectInPopup: any;
  Pagenumbers: string='';
  aiDocListWithDetailForOuter: any[];
  selectedAIDocsOUter: any;
  currentCkeditorId: any;
  heightArray: any=[];
  editorContent: any;
  isPasteEvent: boolean=false;
  aieditorLineCount: number=0;
  overflowfields: any=[];
  pageHeight: any=1188;
  currentPage: number=0;
  OldPage: any;
  aICoreFields: any[];
  corefieldsListAI: any;
  aifilterfieldSearch: string;
  expression: string="";
  isDollar: boolean;
  isShowChkLabel: any;

  openRightPanel() {
    this.openRight = !this.openRight;
  }

  typeSelected = 1;

  iconHoder = [
    { iconName: 'align_horizontal_left', value: 1 },
    { iconName: 'align_horizontal_center', value: 2 },
    { iconName: 'align_horizontal_right', value: 3 }
  ]

  selectedIcon = this.iconHoder[0].iconName;

  callAlignment() {
    if (this.typeSelected == 1) {
      this.selectedIcon = this.iconHoder[0].iconName;
      this.alignHorizontalLeft()
    }
    if (this.typeSelected == 2) {
      this.selectedIcon = this.iconHoder[1].iconName;
      this.alignHorizontalCenter()
    }
    if (this.typeSelected == 3) {
      this.selectedIcon = this.iconHoder[2].iconName;
      this.alignHorizontalRight()
    }
  }



  @Input() imagesWithFields: any = [];
  differ: any;
  objDiffer: any;
  value: value = {
    label: "",
    value: ""
  };
  success = false;
  projectParticipantsList: any = [];
  projectDocumentsList: any = [];
  selectedParticipant: any;
  locale: string = "en";
  public i18n: I18nInterface = {
    saveBtn: "Save as image as JPEG",
    sizes: { extra: "Extra" }
  }
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  dropdownlist: any = [];
  isSelectAll: boolean = false;
  fontSize = [
    { fontsize: 7 },
    { fontsize: 8 },
    { fontsize: 9 },
    { fontsize: 10 },
    { fontsize: 11 },
    { fontsize: 12 },
    { fontsize: 14 },
    { fontsize: 16 },
    { fontsize: 18 },
    { fontsize: 20 },
    { fontsize: 22 },
    { fontsize: 24 },
    { fontsize: 26 },
    { fontsize: 28 },
    { fontsize: 36 },
    { fontsize: 48 },
    { fontsize: 72 }
  ]

  fontfamilys = [
    { font: 'Arial' },
    { font: 'Calibri' },
    { font: 'Tahoma' },
    { font: 'Verdana' },
  ]

  uploadedDocument: boolean = false;
  allParticipant: boolean = false;
  TemplateName: boolean = false;
  showToolsLeft: boolean = false;
  ShowtoolDetail: boolean = false;
  Sdropdown: boolean = false;
  SURLL: boolean = false;
  Smuldropdown: boolean = false;
  Sbutton: boolean = false;
  Stext: boolean = false;
  SButtontext: boolean = false;
  SURL: boolean = false;
  Ssingleline: boolean = false;
  Sformat: boolean = true;
  Snumber: boolean = false;
  Sradio: boolean = false;
  Scheckbox: boolean = false;
  Scheckboxgroup: boolean = false;
  Stable: boolean = false;
  Sbullet: boolean = false;
  Sdraw: boolean = false;
  Sline: boolean = false;
  ShighLight: boolean = false;
  Sthrough: boolean = false;
  Smeasure: boolean = false;
  rotationByDegree: number = 0;
  Smultiline: boolean = false;
  Sapproval: boolean = false;
  SwhiteOut: boolean = false;
  Ssign: boolean = false;

  Ssignature: boolean = false;
  Sinitials: boolean = false;
  Sdate: boolean = false;
  Stime: boolean = false;
  Slocation: boolean = false;

  SbuttonLabel: boolean = false
  Simage: boolean = false
  Sfile: boolean = false
  coreSubFolderList: any = [] = [];
  contactSubFolderList: any = [] = [];
  companySubFolderList: any = [] = [];
  companyfieldsDragList: any[];
  contactfieldsDragList: any[];

  showSidePanel: boolean;
  clickEventsubscription: any;

  mainWithFields: any = [];
  singlLineWithFields: any = [];
  multiLineWithFields: any = [];
  numberWithFields: any = [];
  fileWithFields: any = [];
  imageWithFields: any = [];
  buttonWithFields: any = [];
  radioWithFields: any = [];
  checkboxgroupWithFields: any = [];
  dropdownWithFields: any = [];
  checkWithFields: any = [];
  bulletWithFields: any = [];
  tableWithFields: any = [];
  aiBoxWithFields: any = [];
  dateWithFields: any = [];
  strikeThroughWithFields: any = [];
  straightLineWithFields: any = [];
  MeasureWithFields: any = [];
  WhiteOutWithFields: any = [];
  HighlightFields: any = [];
  //autofill
  autofillvalues: any;
  groupRelationParticipantId: string = "";
  fieldFolders: any;
  particiantJsonListAutoFill: any = [];
  particiantJsonList: any = [];
  particiantJsonListAutoFillCore: any = [];
  waitPointer: boolean = false;
  selectedFieldToDrop: any;
  declineButtonShow: boolean = false;
  beforeFillForm: any;
  nonSelectedDocJsonList: any = [];
  openPanel: number = 0;
  IsSigningComplete: boolean = false;
  particiantJsonListAutoFillCom: any = [];
  isPageLoaded: boolean = false;
  UnChnagedparticipantJsonListArray: any = [];
  UnChnagedparticipantJsonList: any;
  SignButtonEnable: boolean = false;
  reasonToDecline: string = "";
  DrawButtonEnable: boolean = false;
  InitailButtonEnable: boolean = false;
  dialogueRef: any;
  // filenameForSign = "";
  penColor: string = "";
  particiantJsonListAutoFillBeforFill: any;
  particiantJsonListAutoFillCoreBeforFill: any;
  particiantJsonListAutoFillComBeforFill: any;
  innerhtmlvalue: string;
  initialSelectedDocumentId: any;


  rows: any = [];
  column: any = [];

  xx: number;
  yy: number;
  tblrowsnumber: any;
  tblclmnumber: any;
  tblid: any;
  tbldata: any;

  activeTab = 1;
  @Output() dateChange: EventEmitter<MatDatepickerInputEvent<any>>;

  bulletFieldArray: Array<any> = [];
  bulletFieldAttribute: any = {
    val: '',
  };

  dropdownFieldArray: Array<any> = [];
  dropdownFieldAttribute: any = {
    val: '',
  };

  checkboxFieldArray: Array<any> = [];
  checkboxFieldAttribute: any = {
    val: '',
  };

  checkboxGroupFieldArray: Array<any> = [];
  checkboxGroupFieldAttribute: any = {
    val: '',
  };

  radioButtonGroupFieldArray: Array<any> = [];
  radioButtonGroupFieldAttribute: any = {
    val: '',
  };

  Imageurl: any;
  text: string = "";
  isShowAllEditablePlaceHolders: boolean = false;
  ControlId: string = "";
  ControlData: any;

  isRequired: boolean = false;
  readonly: boolean = false;
  characterlimit: number;
  editFieldname: string;
  selectedFolderID: number = 0;
  textColor: any;
  fontsize: any;
  fontstyle: any;
  fontweight: any;
  textdecoration: any;
  timeWithFields: any = [];
  ApproveOrDeclineWithFields: any = [];
  fontfamily: any;
  textalign: any;
  highLightColor: any;
  brushColor: any;
  dropdownddisabled: boolean = false;
  points = [];
  signatureImage;
  signatureWithFields: any = [];
  drawWithFields: any = [];
  drawInPopUp: any = [];

  signOpt: string = 'draw';
  selected = 'option1';
  signName: string;
  //signaturePadOptions:any;
  signaturePadOptions: any = {
    'minWidth': 2,
    'canvasWidth': 0,
    'canvasHeight': 0,
    'penColor': "#000000f2"
  };
  signatureBase64: string;
  checkboxdisabled: boolean = false;
  drawImgBase64: string;

  colorselected: any;
  colorselectedAlpha: any;
  selectedColorCode: any;
  xposition: any;
  yposition: any;

  ImageWidth: any;
  ImageHeight: any;

  tblrows: any;
  tblcoloumn: any;
  initialsWithFields: any = [];
  signOrInitialImageObj: any[];
  signInitialFontFamily: any;
  link = [
    'https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Caveat&family=Cookie&family=Dancing+Script&family=Great+Vibes&family=Pacifico&family=Parisienne&family=Sacramento&family=Satisfy&family=Yellowtail&display=swap',
    'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Damion&family=Homemade+Apple&family=Leckerli+One&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Pinyon+Script&family=Tangerine&display=swap',
    'https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Grand+Hotel&family=Herr+Von+Muellerhoff&family=Italianno&family=Kristi&family=Mrs+Saint+Delafield&family=Niconne&family=Norican&family=Petit+Formal+Script&family=Rochester&display=swap',
    'https://fonts.googleapis.com/css2?family=Bilbo+Swash+Caps&family=Clicker+Script&family=Dawning+of+a+New+Day&family=Euphoria+Script&family=Ma+Shan+Zheng&family=Mr+De+Haviland&family=Qwigley&family=Sofia&family=The+Girl+Next+Door&family=Zeyada&display=swap',
    'https://fonts.googleapis.com/css2?family=Beth+Ellen&family=Charmonman&family=Devonshire&family=Dr+Sugiyama&family=Engagement&family=League+Script&family=Meie+Script&family=Mr+Bedfort&family=Romanesco&family=Stalemate&family=Zhi+Mang+Xing&display=swap'
  ];
  geolocationPosition: any;
  LocationWithFields: any = [];
  SreadOnly: boolean = false;
  Srequired: boolean;
  acceptOrdeclineText: string = 'Approve';
  controlAlignArray: any = [];
  buttonText: string = 'Button';
  buttonURL: string = "";
  fillListcontrolId: any;
  participantArray: any = [];
  projectDocuments: any = [];
  projectDocumentpageImages: any = [];
  ParticipantJsonList: any = [];
  selectedDocumentId: any;
  SubmitNextButtonDisabled: boolean = false;
  changesForUndo: any = [];
  changesForRedo: any = [];
  offsetWidth: number = 0;
  offsetHeight: number = 0;
  showAllRequiredControls: boolean = false;
  indexExpanded: number;
  CompanyName: string = "";
  CoreName: string = "";
  ContactName: string = "";
  Module: string = "";
  //participantEmailId:string="";
  addfont() {
    for (var i = 0; i < this.link.length; i++) {
      const cssURL = this.link[i];
      let node = document.createElement('link');
      node.href = cssURL;
      node.rel = 'stylesheet';
      const s = document.getElementsByTagName('link')[0]
      s.parentNode.insertBefore(node, s);
    }
  }
  OfficeIDList: any = [];
  myOfficeID: any;
  showAdd3CButton: boolean = true;
  LoggedInEmailId: string = '';

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);


  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
    
  constructor(private injector: Injector,private dialog: MatDialog,private elementRef: ElementRef,private renderer: Renderer2, private settingsService: SettingService, private formsService: FormsService,
    private loaderService: LoaderService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService, private formService: FormsService,
    private router: Router, private statusConstant: StatusConstant, private _dataSharingService: DataSharingService,
    private formBuilder: FormBuilder, private cdr: ChangeDetectorRef, private addSubFolderVM: AddSubFolderVM,
    private differs: KeyValueDiffers) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.LoggedInEmailId = sessionStorage.getItem('email');
    this.currentUser = jwt_decode(token);
    this.addfont();
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.differ = differs.find([]).create();
  }

  saveBtn($event) {
    saveAs($event, 'image.jpg');
  }


  family = [
    { font: 'Architects Daughter, cursive' },
    { font: 'Dancing Script, cursive' },
    { font: 'Pacifico, cursive' },
    { font: 'Satisfy, cursive' },
    { font: 'Caveat, cursive' },
    { font: 'Cookie, cursive' },
    { font: 'Great Vibes, cursive' },
    { font: 'Parisienne, cursive' },
    { font: 'Sacramento, cursive' },
    { font: 'Yellowtail, cursive' },
    { font: 'Alex Brush, cursive' },
    { font: 'Allura, cursive' },
    { font: 'Damion, cursive' },
    { font: 'Homemade Apple, cursive' },
    { font: 'Leckerli One, cursive' },
    { font: 'Mr Dafoe, cursive' },
    { font: 'Nothing You Could Do, cursive' },
    { font: 'Pinyon Script, cursive' },
    { font: 'Tangerine, cursive' },
    { font: 'Cedarville Cursive, cursive' },
    { font: 'Grand Hotel, cursive' },
    { font: 'Herr Von Muellerhoff, cursive' },
    { font: 'Italianno, cursive' },
    { font: 'Kristi, cursive' },
    { font: 'Niconne, cursive' },
    { font: 'Norican, cursive' },
    { font: 'Petit Formal Script, cursive' },
    { font: 'Rochester, cursive' },
    { font: 'Bilbo Swash Caps, cursive' },
    { font: 'Clicker Script, cursive' },
    { font: 'Dawning of a New Day, cursive' },
    { font: 'Euphoria Script, cursive' },
    { font: 'Ma Shan Zheng, cursive' },
    { font: 'Mr De Haviland, cursive' },
    { font: 'Qwigley, cursive' },
    { font: 'Sofia Script, cursive' },
    { font: 'The Girl Next Door, cursive' },
    { font: 'Zeyada, cursive' },
    { font: 'Beth Ellen, cursive' },
    { font: 'Charmonman, cursive' },
    { font: 'Devonshire, cursive' },
    { font: 'Dr Sugiyama, cursive' },
    { font: 'Engagement, cursive' },
    { font: 'League Script, cursive' },
    { font: 'Meie Script, cursive' },
    { font: 'Mr Bedfort, cursive' },
    { font: 'Romanesco, cursive' },
    { font: 'Stalemate, cursive' },
    { font: 'Zhi Mang Xing, cursive' },
  ]


  innerWidth: number = window.innerWidth;
  innerHeight: number = window.innerHeight;

  onWindowResize(event) {
    this.innerWidth = event.target.innerWidth;
    this.innerHeight = event.target.innerHeight;
  }

  ngOnInit(): void {
    
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var coreName = [];
    coreName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if (coreName.length > 0) {
      this.CoreName = coreName[0].orgModuleName;
    }

    var contName = [];
    contName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if (contName.length > 0) {
      this.ContactName = contName[0].orgModuleName;
    }

    var compName = [];
    compName = menuModulesList.filter(x => x.mainModuleName == ModuleName.Company);
    if (compName.length > 0) {
      this.CompanyName = compName[0].orgModuleName;
    }


    if (sessionStorage.getItem('stepCompleted') != undefined) {
      this.stepCompleted = Number(sessionStorage.getItem('stepCompleted'));
    }

    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.Ssignature = true;
    this.signaturePadOptions = {
      'minWidth': 5,
      'canvasWidth': this.innerWidth,
      'canvasHeight': this.innerHeight,
      'penColor': "#000000f2"
    }

    if (sessionStorage.getItem('ProjectName') !== null && sessionStorage.getItem('ProjectName') !== undefined && sessionStorage.getItem('ProjectName') !== '0') {
      this.clickEventsubscription = this._dataSharingService.GetProjectNameAlreadyExist().subscribe((result) => {
        if (result != undefined) {
          if (result == true) {
            this.SubmitNextButtonDisabled = false;
          } else {
            this.SubmitNextButtonDisabled = true;
          }
        }
      });
    }
    var projectID = sessionStorage.getItem('projectID');
    if (projectID == null || projectID == undefined) {
      this.router.navigate(['/esignature/first']);
      return;
    }

    if (sessionStorage.getItem('MasterTemplatePDFForm') == "true") {
      this.showAdd3CButton = false;
    } else {
      this.showAdd3CButton = true;
    }

    this.getParticipantAndDocumentDetails();

    this.bulletFieldArray.push(this.bulletFieldAttribute);
    this.dropdownFieldArray.push(this.dropdownFieldAttribute);
    this.checkboxFieldArray.push(this.checkboxFieldAttribute);
    this.checkboxGroupFieldArray.push(this.checkboxGroupFieldAttribute);
    this.radioButtonGroupFieldArray.push(this.radioButtonGroupFieldAttribute);
    this.highLightColor = this.hexToRGBA("#FFFF00", 0.2);
    this.GetAIDocuments();
    this.getAllCoreFields(this.subFolderID);
    this.GetAllCoreFieldsForOpenAI();
    this.getAllContactFields(this.subFolderID);
    this.getAllCompanyFields(this.subFolderID);
    this.getCoreSubFolderList();
    this.getCompanySubFolderList();
    this.getContactSubFolderList();

    this.AIboxControlControl();
    this.SingleLineControl();
    this.MultiLineControl();
    this.NumberControl();
    this.FileControl();
    this.ImageControl();
    this.ButtonControl();
    this.RadioControl();
    this.DropDownControl();
    this.CheckBoxControl();
    this.BulletListControl();
    this.TableListControl();
    this.CheckBoxGroupControl();
    this.DateControl();
    this.TimeControl();
    this.ApproveOrDecline();
    this.SignatureControl();
    this.DrawControl();
    this.DrawInPopUpControl();
    this.InitialsControl();
    this.GeoLocation();

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = []
    Module = menuModulesList.filter(x => x.mainModuleName == 'Forms');
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
    }

    sessionStorage.setItem('HeaderModuleName', this.Module);
    sessionStorage.setItem('edashboard', "true");

    this._dataSharingService.sendSelectedProjectName(sessionStorage.getItem('ProjectName'));
    if (sessionStorage.getItem('type') == "1") {
      sessionStorage.setItem('HeaderModuleName', this.Module);
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }
    if (sessionStorage.getItem('type') == "2") {
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }

    this.clickEventsubscription = this._dataSharingService.getClickEventforfieldsForms().subscribe(() => {
      this.getAllCoreFields(this.subFolderID);
      this.getAllContactFields(this.subFolderID);
      this.getAllCompanyFields(this.subFolderID);
    });

    this.StrikeThroughControl();
    this.StraightLineControl();
    this.MeasureControl();
    this.WhiteOutControl();
    this.HighlightControl();
    this.getStateDropdownList(231);

    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }
  onCkEditorReady(editor: any): boolean {
    const result = true;    
    return result;
  }
  getArray(field: any) {
    if (field.fieldTypeName === "MultiSelect") {
      if (field?.selectedValue !== undefined && field?.selectedValue !== '') {
        if (Array.isArray(field?.selectedValue)) {
          if (field.selectedValue.length == 0) {
            field.selectedValue = new Array(1);
          }
        }
        else if (field?.selectedValue !== undefined && field?.selectedValue !== '')
          field.selectedValue = field?.selectedValue?.replace(/\s/g, '').split(',');
      }
      else {
      }
      return field.selectedValue;
    }
  }

  ctrlImg: any;

  openMultiPopup(item: any, templateRef: TemplateRef<any>, img: any) {
    this.ctrlImg = img;
    this.multiSelectCurrentItem = item;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  FillDocImagesWithFields(docId: number = 0, isUpdateJson: boolean = false) {
    this.ExtractDocumentField=[];
    if (isUpdateJson) {
      let findPreviouslyparticipant = this.participantArray.find(m =>
        m.documentId == this.selectedDocumentId);
      if (findPreviouslyparticipant) {
        this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
        } else {
        this.participantArray.push({
          groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
          participantJson: JSON.stringify(this.imagesWithFields),
          documentId: this.selectedDocumentId,
          projectParticipantJsonID: 0
        })
      }
    }
    let doc: any;
    if (docId > 0) {
      doc = this.projectDocuments.find(m => m.projectDocumentID == docId);
      this.thumbsList = doc;
    } else {
      doc = this.projectDocuments[0];
      this.thumbsList = doc;
    }
    this.ImageHeight = doc.imageHeight + 'px';
    this.ImageWidth = doc.imageWidth + 'px';
    if (doc) {
      this.selectedDocumentId = doc.projectDocumentID;
      let selectedParticipantJson = this.participantArray.find(m => m.documentId == this.selectedDocumentId);
      if (selectedParticipantJson) {
        this.imagesWithFields = [];
        var blankfield = [];
        blankfield = JSON.parse(selectedParticipantJson.participantJson);       
        this.imagesWithFields = blankfield;
        this.imagesWithFields.forEach(element => {
          element.fields.forEach(field12 => {
            if (field12.fieldTypeName === "MultiSelect") {
              if (field12?.selectedValue !== undefined && field12?.selectedValue !== '') {
                let temp: any[];
                if (Array.isArray(field12?.selectedValue)) {
                  if (field12.selectedValue.length == 0) {
                    field12.selectedValue = new Array(1);
                  }
                }
                else if (field12?.selectedValue !== undefined && field12?.selectedValue !== '') {
                  temp = field12?.selectedValue?.replace(/\s/g, '').split(',');
                  field12.selectedValue = temp;
                }
              }
              else {
              }
            }
          });
        });
      } else {
        if (doc.editablePdfFields == null || doc.editablePdfFields == undefined || doc.editablePdfFields == "[]") {
          this.imagesWithFields = [];
          let images = this.projectDocumentpageImages.filter(m => m.documentID == doc.projectDocumentID);
          images = images.sort(function (a, b) { return a.pageNumber - b.pageNumber });
          images.forEach(e => {
            this.imagesWithFields.push({ img: e.pageImageUrl, fields: [], })
          });
        }
        else {
          this.imagesWithFields = [];
          let images = this.projectDocumentpageImages.filter(m => m.documentID == doc.projectDocumentID);
          images = images.sort(function (a, b) { return a.pageNumber - b.pageNumber });
          let editablePdfFieldsJson = JSON.parse(doc.editablePdfFields);
          images.forEach(e => {
            let imageObj = { img: e.pageImageUrl, fields: [] };
            let editableImageFields = editablePdfFieldsJson.filter(m => m.ImageName.toLowerCase() == e.pageImageUrl.toLowerCase())
            if (editableImageFields)
              editableImageFields.forEach(ele => {
                imageObj.fields.push(
                  this.getEdititablePdfDocumentField(ele)
                );
              });
            this.imagesWithFields.push(imageObj)
          });

          this.imagesWithFields.forEach(element => {
            element.fields.forEach(field => {
              if (field.fieldTypeName === "MultiSelect") {
                if (field?.selectedValue !== undefined && field?.selectedValue !== '') {
                  if (Array.isArray(field?.selectedValue)) {
                    if (field.selectedValue.length == 0) {
                      field.selectedValue = new Array(1);
                    }
                  }
                  else if (field?.selectedValue !== undefined && field?.selectedValue !== '')
                    field.selectedValue = field?.selectedValue?.replace(/\s/g, '').split(',');
                }
                else {
                }
              }
            });
          });
        }
        this.participantArray.push({
          groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
          participantJson: JSON.stringify(this.imagesWithFields),
          documentId: this.selectedDocumentId,
          projectParticipantJsonID: 0
        });
      }
    }

    this.ExtractDocumentField=[];
    if(this.imagesWithFields.length>0){   
     for (let i = 0; i < this.imagesWithFields.length; i++){
       var data=[];
       data = this.imagesWithFields[i].fields;
       if(data.length>0){       
         data.map(e => {
          e.imgUrl = this.imagesWithFields[i].img;
         // e.folderID= folderId;
         // e.folderName="Core";
        }); 
         this.ExtractDocumentField.push(data);
                 
       }else{
        this.showBindField=false;
       }
     }
     if(this.ExtractDocumentField.length>0){
       this.showBindField=true;
     }else{
       this.showBindField=false;
     }
    }else{
     this.showBindField=false;
    }
    document.getElementsByClassName('documentHolder')[0].scrollTop = 0;
    // setTimeout(() => {
      
    // this.setFinalExpressionsAsEmpty();
    // }, 3000);

    setTimeout(() => {
      this.imagesWithFields.forEach(imageData => {
        // Proceed if the fields array exists and is non-empty
        if (imageData.fields && imageData.fields.length > 0) {
            // Loop through all fields
       let expFields=     imageData.fields?.filter(field => 
        field.finalExpression != null && 
        field.finalExpression != undefined && 
        field.finalExpression != ''&&
        
        field.selectedValue !=null &&
        field.selectedValue !=undefined &&
        field.selectedValue !='' &&

        field.selectedValue !='$0.00' &&
        field.selectedValue !='0.00' &&
        field.selectedValue !='0.0' &&
        field.selectedValue !='0'

      ) || []
  
      expFields.forEach(field => {
                   let finalExpression = field.finalExpression;
                   finalExpression=this.ensureValueIsArray(finalExpression);
                   if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="" && finalExpression.length>0)
                    {
                      finalExpression.forEach(fex => {
                        let cleanedfex=this.removeAllWhitespace(fex);
                      let excontrols=this.splitExpression(cleanedfex);
                      this.evaluateExpression(cleanedfex, excontrols,imageData);
                      });
                    }
                });
            }
        });

      }, 2000);
    
  }

 setFinalExpressionsAsEmpty() {
    // Loop through all imagesWithFields
    this.imagesWithFields.forEach(imageData => {
        // Proceed if the fields array exists and is non-empty
        if (imageData.fields && imageData.fields.length > 0) {
            // Loop through all fields
            imageData.fields.forEach(field => {
                if (Array.isArray(field.finalExpression)) {
                    // Filter out expressions where the right-side field doesn't exist
                    field.finalExpression = [];
                }
            });
        }
    });
}

//  checkAndUpdateFinalExpressions(rightSideField) {
//   // Loop through all imagesWithFields
//   this.imagesWithFields.forEach(imageData => {
//       // Proceed if the fields array exists and is non-empty
//       if (imageData.fields && imageData.fields.length > 0) {
//           // Loop through all fields
//           imageData.fields.forEach(field => {
//               if (Array.isArray(field.finalExpression)) {
//                   // Filter out expressions where the right-side field matches the provided rightSideField
//                   field.finalExpression = field.finalExpression.filter(expression => {
//                       // Split the expression into parts based on '='
//                       const parts = expression.split('=');

//                       // Ensure the expression is in the correct format
//                       if (parts.length !== 2) {
//                           return true; // Keep malformed expressions
//                       }

//                       const expressionRightSideField = parts[1]; // Get the part after '='

//                       // Remove the expression if the right-side field matches the provided one
//                       return expressionRightSideField !== rightSideField;
//                   });
//               }
//           });
//       }
//   });
// }

checkAndUpdateFinalExpressions(rightSideField) {
  // Loop through all imagesWithFields
  this.imagesWithFields.forEach(imageData => {
      // Proceed if the fields array exists and is non-empty
      if (imageData.fields && imageData.fields.length > 0) {
          // Loop through all fields
          imageData.fields.forEach(field => {
              if (Array.isArray(field.finalExpression)) {
                  // Filter out expressions where the rightSideField is an exact match in the expression
                  field.finalExpression = field.finalExpression.filter(expression => {
                      // Check if the entire expression contains the exact rightSideField
                      return !expression.includes(rightSideField);
                  });
              }
          });
      }
  });
}


  FillParticipantArray(docId: number = 0, isUpdateJson: boolean = false) {
    let doc: any;
    if (docId > 0) {
      doc = this.projectDocuments.find(m => m.projectDocumentID == docId);
      this.thumbsList = doc;
    }
    if (doc) {
      let docelements = [];
      if (doc.editablePdfFields == null || doc.editablePdfFields == undefined || doc.editablePdfFields == "[]") {
        let images = this.projectDocumentpageImages.filter(m => m.documentID == doc.projectDocumentID);
        images = images.sort(function (a, b) { return a.pageNumber - b.pageNumber });
        images.forEach(e => {
          docelements.push({ img: e.pageImageUrl, fields: [], })
        });

        this.participantArray.push({
          groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
          participantJson: JSON.stringify(docelements),
          documentId: doc.projectDocumentID,
          projectParticipantJsonID: 0
        })
      }
      else {
        let images = this.projectDocumentpageImages.filter(m => m.documentID == doc.projectDocumentID);
        images = images.sort(function (a, b) { return a.pageNumber - b.pageNumber });

        let editablePdfFieldsJson = JSON.parse(doc.editablePdfFields);
        images.forEach(e => {
          let imageObj = { img: e.pageImageUrl, fields: [] };
          let editableImageFields = editablePdfFieldsJson.filter(m => m.ImageName.toLowerCase() == e.pageImageUrl.toLowerCase())
          if (editableImageFields)
            editableImageFields.forEach(ele => {
              imageObj.fields.push(
                this.getEdititablePdfDocumentField(ele)
              );
            });
          docelements.push(imageObj)
        });

        this.participantArray.push({
          groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
          participantJson: JSON.stringify(docelements),
          documentId: doc.projectDocumentID,
          projectParticipantJsonID: 0
        })
      }

    }
  }

  getEdititablePdfDocumentField(editableFiled: any) {
    let textaligns: string = "left";
    let fillList: any = [];
    if (editableFiled.Type === 'Checkbox') {
      fillList.push({
        id: 'ctrl-' + 0,
        val: "",
        offsetX: Number(editableFiled.Left) * 1.5,
        offsetY: Number(editableFiled.Top) * 1.5
      });
      this.offsetWidth = 15;
      this.offsetHeight = 15;
    }
    if (editableFiled.Type === 'Radio') {
      fillList.push({
        id: 'ctrl-' + 0,
        val: "",
        offsetX: Number(editableFiled.Left) * 1.5,
        offsetY: Number(editableFiled.Top) * 1.5
      });
      this.offsetWidth = 15;
      this.offsetHeight = 15;
    }
    let fieldObj = {
      "isEditable": true,
      "id": editableFiled.Name,
      "fieldID": 0,
      "fieldName": editableFiled.Name,
      "folderID": 0,
      "folderName": '',
      "subFolderName": '',
      "fieldTypeID": '',
      "fieldTypeName": editableFiled.Type,
      "placeholder": '',
      "defaultValue": '',
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "readonly": false,
      "charLimit": "100",
      "fontSize": editableFiled.FontSize + 'px',
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": Number(editableFiled.Left) * 1.5,
      "offsetY": Number(editableFiled.Top) * 1.5,
      "offsetHeight": Number(editableFiled.Height) * 1.5,
      "offsetWidth": Number(editableFiled.Width) * 1.5,
      // "offsetX": (editableFiled.Left/72)*200+10,
      // "offsetY": (editableFiled.Top/72)*200+10,
      // "offsetHeight": (editableFiled.Height/72)*200+10,
      // "offsetWidth": (editableFiled.Width/72)*200+10,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": [],
      "buttonText": 'Approve',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": '',
      "colorCodeAlpha": '',
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": {
        "participantName": "Any One"
        , "participantEmail": "",
        "groupName": "",
        "relationName": "Unassigned",
        "colourCode": "#d7f5ff",
        "groupRelationParticipantMappingID": 0,
        "groupID": 0,
        "roleID": 0,
        "contactEmail": ""
        , "selectedContactFieldEmailID": null,
        "roleName": "",
        "pariticipantId": 0,
        "contactID": 16,
        "coreID": 16,
        "relationID": 49,
        "isActive": false,
        "isDeleted": false,
        "participantImageURL": "https://ecmstorageaccount.blob.core.windows.net/ecm-userprofile-images/62ce841e-f5e6-4d7c-b42d-9b63eb3c394e1.jpg",
        "position": 1,
        "message": null,
        "hasCompleted": null,
        "isEmailSent": null,
        "signingToken": null,
        "userID": "",
        "organizationID": 0,
        "databaseID": 0
      },
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": false,
      "showRequiredControls": false
    };

    return fieldObj;
  }

  ngDoCheck() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;

    var data = this.ControlData;
    if (data != undefined && this.imagesWithFields.length > 1)
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        this.imagesWithFields.find(x => x.img == data.img).fields.forEach(elt => {
          var changes = this.differ.diff(elt);
          if (changes) {
            var s = changes;
          }
        });
      }

  }

  undoClickHandler() {
    if (this.changesForUndo.length > 0) {
      this.changesForRedo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields = this.changesForUndo[this.changesForUndo.length - 1];
      this.changesForUndo.pop();
      //this.changesForUndo = this.changesForUndo.splice(this.changesForUndo.length-1,0);
    }
  }

  redoClickHandler() {
    if (this.changesForRedo.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields = this.changesForRedo[this.changesForRedo.length - 1];
      this.changesForRedo.pop();
      //this.changesForRedo= this.changesForRedo.splice(this.changesForRedo.length-1,0);
    }
  }

  fetchLocation(data, id) {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
        position => {
          this.geolocationPosition = position
          if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
            this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).Lat
              = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.latitude : '';
            this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).Long
              = this.geolocationPosition !== undefined && this.geolocationPosition !== null && this.geolocationPosition !== '' ? this.geolocationPosition.coords.longitude : '';
          }
        },
        error => {
          switch (error.code) {
            case 1:

              break;
            case 2:

              break;
            case 3:

              break;
          }
        }
      );
    };
  }


  SaveSign(data) {
    this.signatureImage = data;
  }

  currentSign = {
    data: '',
    id: ''
  }


  OpenSignPopup(templateRef: TemplateRef<any>, data: any, item: any, event: any) {
    if (!event.shiftKey) {
      this.ControlData = data;
      this.ControlId = item.id;
      this.SignButtonEnable = false;
      this.InitailButtonEnable = false;
      if (this.ControlId == undefined) {
        this.ControlId = item;
      }
      this.filenameForSign = "";

      this.currentSign.data = data;
      this.currentSign.id = item.id;
      // if(item.signatureText==""|| item.signatureText==undefined || item.signatureText==null){
      //   this.signName=this.currentUser.Name;
      // }else{
      //   this.signName=item.signatureText;
      // }
      this.signName = "";
      this.selected = ''
      this.signOpt = 'draw';
      const dialogRef = this.dialog.open(templateRef, {
        panelClass: 'custom-modalbox'
      });

      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
          if (element.id != item.id)
            element.ShowtoolDetail = false;
        });

        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === item.id);
        if (getData.length > 0) {
          this.ControlData = FieldsDetails;
          this.ControlId = item.id;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          if (getData[0].brushColor != undefined)
            this.brushColor = getData[0].brushColor;
        }
        this.imgDrawStart();

        var sigContainer = document.querySelector(".allSCont") as HTMLElement;
        this.signaturePadOptions = {
          'minWidth': 5,
          'canvasWidth': sigContainer.clientWidth,
          'canvasHeight': sigContainer.clientHeight,
          'penColor': "#000000f2"
        }


        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }

  getAllSignatures: any = [] = [];
  hasSignature: boolean = false;
  fiveSignaturesLimitReached: boolean = true;
  signatureID: number = 0;

  OpenSignPopupNew(data: any, item: any, event: any) {
    if (!event.shiftKey) {
      this.ControlData = data;
      this.ControlId = item.id;
      this.SignButtonEnable = false;
      this.InitailButtonEnable = false;
      if (this.ControlId == undefined) {
        this.ControlId = item;
      }
      this.filenameForSign = "";

      this.currentSign.data = data;
      this.currentSign.id = item.id;
      // if(item.signatureText==""|| item.signatureText==undefined || item.signatureText==null){
      //   this.signName=this.currentUser.Name;
      // }else{
      //   this.signName=item.signatureText;
      // }
      this.signName = "";
      this.selected = ''
      this.signOpt = 'draw';
      // const dialogRef = this.dialog.open(templateRef, {
      //   panelClass: 'custom-modalbox'
      // });

      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
          if (element.id != item.id)
            element.ShowtoolDetail = false;
        });

        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === item.id);
        if (getData.length > 0) {
          this.ControlData = FieldsDetails;
          this.ControlId = item.id;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          if (getData[0].brushColor != undefined)
            this.brushColor = getData[0].brushColor;
        }
       // this.imgDrawStart();

        // var sigContainer = document.querySelector(".allSCont") as HTMLElement;
        // this.signaturePadOptions = {
        //   'minWidth': 5,
        //   'canvasWidth': sigContainer.clientWidth,
        //   'canvasHeight': sigContainer.clientHeight,
        //   'penColor': "#000000f2"
        // }

       if(this.LoggedInEmailId=="" || this.LoggedInEmailId==undefined || this.LoggedInEmailId==null){
          const dialogRef = this.dialog.open(AddSignatureComponent, {     
            data: {
              //moduleName:this.mainModulename,
              participantEmailId:this.LoggedInEmailId
            },
            panelClass: 'custom-modalboxSign'
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result!=null && result!=undefined){
              this.addSignatureNew(result)
              //this.addUpdateParticipantsNew(result);
            }      
         });
        }else{
          var rqModel={       
            email: this.LoggedInEmailId,       
           }
           this.loaderService.show();
           this.formsService.getSignaturesAndInitials(rqModel).subscribe(response => {
            if (response != undefined) {
               this.responseHolder = response;
               this.loaderService.hide();
               if(this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data!=null) {
                  this.getAllSignatures = this.responseHolder.data.signatures;         
                
                  if(this.getAllSignatures==null){
                    const dialogRef = this.dialog.open(AddSignatureComponent, {     
                      data: {
                        //moduleName:this.mainModulename,
                        participantEmailId:this.LoggedInEmailId
                      },
                      panelClass: 'custom-modalboxSign'
                    });
                    dialogRef.afterClosed().subscribe(result => {
                      if(result!=null && result!=undefined){
                        this.addSignatureNew(result)                       
                      }      
                   });
                   return;
                  }          
      
                  if(this.getAllSignatures.length>0){
                    this.hasSignature = true;
                    this.getAllSignatures.forEach(n => {                              
                      n.signature=JSON.parse(n.signature);
                    });
                  }else{
                    this.hasSignature = false;
                  }            
                
      
                  if(this.getAllSignatures.length == 5){
                    this.fiveSignaturesLimitReached=true;
                  }
                  else{
                    this.fiveSignaturesLimitReached=false;
                  }
                
      
                  if(item.signatureBase64!='' || item.ImageData.length!=0 || item.signatureText!=''){
                    const dialogRef = this.dialog.open(AddSignatureComponent, {     
                      data: {
                        //moduleName:this.mainModulename,
                        participantEmailId:this.LoggedInEmailId
                      },
                      panelClass: 'custom-modalboxSign'
                    });
                    dialogRef.afterClosed().subscribe(result => {
                      if(result!=null && result!=undefined){
                        this.addSignatureNew(result)                       
                      }      
                    });
                    return;
                  } 
      
                  var checkSignDefault=[];
                  checkSignDefault=this.responseHolder.data.signatures.filter(x=>x.isDefault==true);
                   if(checkSignDefault.length>0){
                     
                   // let data:any=datas;//this.ControlData;
                    this.signatureID = this.signatureID;
                    let sJson = checkSignDefault[0].signature;
                
                    if(sJson.type=='Draw'){
                      this.signatureBase64 = sJson.signatureBase64;
                      this.signName="";
                      this.signInitialFontFamily="";
                      this.signOrInitialImageObj=[];
                    }
                    if(sJson.type=='Upload'){
                      this.signatureBase64="";
                      this.signName="";
                      this.signInitialFontFamily="";
                      this.signOrInitialImageObj=sJson.ImageData;
                    }
                    if(sJson.type=='Type In'){
                      this.signatureBase64="";
                      this.signName=sJson.signatureText;
                      this.signInitialFontFamily=sJson.signInitialFontFamily;
                      this.signOrInitialImageObj=[];
                    }
                   // return;
                   if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
                    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
                    this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;
                    this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
                    this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
                    this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
              
                    this.imagesWithFields = this.imagesWithFields;
                  }
                    // if(this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
                    //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).participantEmailId = this.participantEmailId;
                    //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
                    //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
                    //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
                    //   this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
                    //   var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);
                      
                    //   if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant?.groupRelationParticipantMappingID==0){
                    //     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
                    //  }      
                    // this.particiantJsonList = this.particiantJsonList;          
                    // }
                  }else{
                      const dialogRef = this.dialog.open(AddSignatureComponent, {     
                      data: {
                        //moduleName:this.mainModulename,
                        participantEmailId:this.LoggedInEmailId
                      },
                      panelClass: 'custom-modalboxSign'
                    });
                    dialogRef.afterClosed().subscribe(result => {
                      if(result!=null && result!=undefined){
                        this.addSignatureNew(result)                       
                      }      
                    });
                  }  
                }else{                  
                  const dialogRef = this.dialog.open(AddSignatureComponent, {     
                    data: {
                      //moduleName:this.mainModulename,
                      participantEmailId:this.LoggedInEmailId
                    },
                    panelClass: 'custom-modalboxSign'
                  });
                  dialogRef.afterClosed().subscribe(result => {
                    if(result!=null && result!=undefined){
                      this.addSignatureNew(result)                       
                    }      
                  });
                  return;
                }
             }else{             
              const dialogRef = this.dialog.open(AddSignatureComponent, {     
                data: {
                  //moduleName:this.mainModulename,
                  participantEmailId:this.LoggedInEmailId
                },
                panelClass: 'custom-modalboxSign'
              });
              dialogRef.afterClosed().subscribe(result => {
                if(result!=null && result!=undefined){
                  this.addSignatureNew(result)                       
                }      
              });
              return;
             }
          });
        }
       

        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }

  drawnImg = {
    data: '',
    id: ''
  }

  // OpenDrawPopup(templateRef: TemplateRef<any>, data: any, id: any) {
  //   this.drawnImg.data = data;
  //   this.drawnImg.id = id;
  //   const dialogRef = this.dialog.open(templateRef, {
  //     panelClass: 'custom-modalbox'
  //   });  

  //   if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
  //     this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
  //       if (element.id != id)
  //         element.ShowtoolDetail = false;
  //     });

  //     var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
  //     var getData = FieldsDetails.fields.filter(x => x.id === id);
  //     if (getData.length > 0) {
  //       this.ControlData = FieldsDetails;
  //       this.ControlId = id;
  //       this.isRequired = getData[0].isRequired;
  //       this.readonly = getData[0].readonly;
  //       if (getData[0].brushColor != undefined)
  //         this.brushColor = getData[0].brushColor;
  //     }
  //     var sigContainer = document.querySelector(".allSCont") as HTMLElement;
  //     this.signaturePadOptions = {
  //       'minWidth': 2,
  //       'canvasWidth': sigContainer.clientWidth,
  //       'canvasHeight': sigContainer.clientHeight,
  //       'penColor': "#000000f2"
  //     }
  //     this.imgDrawStart();
  //     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  //   }

  // }

  checkIfEnabled(field, data): boolean {
    let fieldVal = false;
    if (this.isPageLoaded && this.IsSigningComplete) {
      return false;
    }
    //
    if (field.fieldTypeName == "Checkbox" || field.fieldTypeName == 'CheckBoxGroup') {
      if (field.chkSelectedValues != undefined && field.chkSelectedValues.length > 0)
        fieldVal = true;
    }
    if (field.fieldTypeName == "radio") {
      if (field.rbSelectedValues != undefined && field.rbSelectedValues.length > 0)
        fieldVal = true;

    }
    if (field.fieldTypeName === "MultiSelect") {
      if (field.selectedValue != "" && !Array.isArray(field.selectedValue) && field.selectedValue != undefined && field.selectedValue.split(',').length > 0)
        fieldVal = true;
      else if (field.selectedValue != "" && Array.isArray(field.selectedValue) && field.selectedValue != undefined && field.selectedValue.length > 0) {
        fieldVal = true;
      }
    }
    if (field.fieldTypeName == 'File') {
      if (field.FileData.length > 0) {
        fieldVal = true;
      }
    }
    if (field.fieldTypeName == 'Image') {
      if (field.ImageData.length > 0) {
        fieldVal = true;
      }
    }
    if (field.fieldTypeName == 'Location') {
      if (field.Lat != '' && field.Long != '') {
        fieldVal = true;
      }
    }

    else {
      if (field.selectedValue != "" && field.selectedValue != undefined)
        fieldVal = true;
    }

    //
    if (field.selectedParticipant?.groupRelationParticipantMappingID == 0) {
      if (fieldVal) {
        return false;
      }
      return true;
    }
    if (field.selectedParticipant?.groupRelationParticipantMappingID == undefined) {
      if (fieldVal) {
        return false;
      }
      return true;
    } else {
      let jsoFromArray = this.UnChnagedparticipantJsonListArray.find(n => n.documentID == this.selectedDocumentId).participantJson;

      this.UnChnagedparticipantJsonList = JSON.parse(jsoFromArray);
      if (this.UnChnagedparticipantJsonList.find(x => x.img == data.img) != undefined) {

        let unchnagedField = this.UnChnagedparticipantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id);
        if (unchnagedField != undefined) {

          if (this.findFieldValue(unchnagedField) && unchnagedField.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId) {
            return false;
          }
          return ((!this.IsSigningComplete) && (field.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId));
        }
      }
    }
  }

  findFieldValue(field) {
    let fieldVal = false;
    //
    if (field.fieldTypeName == "Checkbox" || field.fieldTypeName == 'CheckBoxGroup') {
      if (field.chkSelectedValues != undefined && field.chkSelectedValues.length > 0)
        fieldVal = true;
    }
    if (field.fieldTypeName == "radio") {
      if (field.rbSelectedValues != undefined && field.rbSelectedValues.length > 0)
        fieldVal = true;

    }
    if (field.fieldTypeName === "MultiSelect") {
      if (field.selectedValue != "" && !Array.isArray(field.selectedValue) && field.selectedValue != undefined && field.selectedValue.split(',').length > 0)
        fieldVal = true;
      else if (field.selectedValue != "" && Array.isArray(field.selectedValue) && field.selectedValue != undefined && field.selectedValue.length > 0) {
        fieldVal = true;
      }
    }
    else {
      if (field.selectedValue != "" && field.selectedValue != undefined)
        fieldVal = true;
    }
    //
    return fieldVal;
  }

  ifChkCheckedAutoFill(field, data, childCtrlId) {
    let id = field.id;

    let coretFolder: any = [];
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));

    let contactFolder: any = [];
    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));

    let comFolder: any = [];
    comFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Company));

    if (contactFolder[0].folderID == field.folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue = this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
      return selectedValue.includes(childCtrlId);
    }
    else if (coretFolder[0].folderID == field.folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue = this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
      return selectedValue.includes(childCtrlId);
    }
    else if (comFolder[0].folderID == field.folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue = this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
      return selectedValue.includes(childCtrlId);
    }
    return false;
  }

  OpenDrawPopup(templateRef: TemplateRef<any>, data: any, field: any, id: any) {
    this.drawnImg.data = data;
    this.drawnImg.id = id;
    this.DrawButtonEnable = false;
    this.dialogueRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });

    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
        if (element.id != id)
          element.ShowtoolDetail = false;
      });
      field.ShowtoolDetail = true;
      var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id === id);
      if (getData.length > 0) {
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        if (getData[0].brushColor != undefined)
          this.brushColor = getData[0].brushColor;
      }
      if (field.penColor == "" || field.penColor == undefined) {
        this.penColor = "#000000f2";
      } else {
        this.penColor = field.penColor;
      }
      var sigContainer = document.querySelector(".allSCont") as HTMLElement;
      this.signaturePadOptions = {
        'minWidth': 3,
        'canvasWidth': sigContainer.clientWidth,
        'canvasHeight': sigContainer.clientHeight,
        'penColor': this.penColor//"#000000f2"
      }
      //this.imgDrawStart();
    }

  }

  OpenDrawInPopup(templateRef: TemplateRef<any>, data: any, id: any) {
    // this.drawnImg.data=data;
    // this.drawnImg.id=id;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });


  }

// Helper function to wait for ngOnInit operations to complete
private initComplete() {
  this.initCompleted = true;
  if (this.initResolve) {
    this.initResolve(); // Resolve the waiting promise if it exists
  }
}

private initCompleted = false;
private initResolve: (() => void) | null = null;

private waitForInitToComplete(): Promise<void> {
  if (this.initCompleted) {
    return Promise.resolve(); // Initialization is already complete
  } else {
    return new Promise<void>((resolve) => {
      this.initResolve = resolve; // Store the resolve function for later
    });
  }
}
loadDisabledElements(): HTMLElement[] {
  let operationsFieldArray:any=[]
  this.imagesWithFields.forEach(element => {
    operationsFieldArray=[...operationsFieldArray, ...element.fields.filter(x => x.selectedParticipant?.groupRelationParticipantMappingID == 0 &&  x.selectedValue!='' && x.selectedValue!=undefined && x.selectedValue!=null)];
  });
  
  let allElements :any=[];
  operationsFieldArray.forEach(ef => {
    if(ef.fieldTypeName=='Date' || ef.fieldTypeName=='Textbox' || ef.fieldTypeName=='Textarea' || ef.fieldTypeName=='Currency' || ef.fieldTypeName=='URL' || ef.fieldTypeName=='Number')
    {
    allElements=[...allElements,...this.elementRef.nativeElement.querySelectorAll('#'+ef.id)];
    }
  });
  return Array.from(allElements);
} 
loadDisabledElementsDiv(): HTMLElement[] {
  let operationsFieldArray:any=[]
  this.imagesWithFields.forEach(element => {
    operationsFieldArray=[...operationsFieldArray, ...element.fields.filter(x => x.selectedParticipant?.groupRelationParticipantMappingID == 0)];
  });
  
  let allElements :any=[];
  operationsFieldArray.forEach(ef => {
    if(ef.fieldTypeName=='Image' && ef.ImageData.length>0)
    {
     allElements=[...allElements,...this.elementRef.nativeElement.querySelectorAll('#'+ef.id+'.customUpdate')];
    }
  });
  return Array.from(allElements);
} 

AddBlankPage(p:any): Promise<any>{
  return new Promise((resolve, reject) => {
  let pageNoForImageURL=this.imagesWithFields.length+1;
  let oldURl=this.imagesWithFields[0].img;
  let newURl=oldURl.replace('_page_1','_page_'+(pageNoForImageURL));
  let ReqModel = {
    projectID: sessionStorage.getItem('projectID'),
    userID: this.currentUser.UID,
    databaseID: Number(this.databaseId),
    organizationID: Number(this.organizationId),
    type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
    officeID: this.myOfficeID,
    BlankPageUrlToBeAdded:newURl,
    DocumentID: this.selectedDocumentId,
    pageNoTobeAdded:(p.pageNumber+1)
  }
  this.loaderService.show();
  this.formService.UploadBlankImageToFormOrProject(ReqModel).subscribe((response) => {
    if (response != undefined) {
      if (response.status == this.statusConstant.statusSuccess) {
        this.currentPage=(p.pageNumber+1);
        //this.imagesWithFields.push({ img: newURl, fields: [] });
        this.imagesWithFields.splice((p.pageNumber), 0, {isBlankPage:true, img: newURl, fields: [] });

        this.projectDocuments.forEach(pd => {  
          if(pd.projectDocumentID==this.selectedDocumentId){

           let imagesCurrentDoc= pd.images;
           if(imagesCurrentDoc==undefined || imagesCurrentDoc==null){
            imagesCurrentDoc=[];
           }
            // imagesCurrentDoc.push({ 
            //   documentID: this.selectedDocumentId,
            //   documentPageImageID: response.data,
            //   pageImageBase64: null,
            //   pageImageThumbnail:newURl,
            //   pageImageUrl:newURl,
            //   pageNumber: pageNoTobeAdded
            //  });
            imagesCurrentDoc.forEach(element => {
              if(element.pageNumber>=ReqModel.pageNoTobeAdded)
                 element.pageNumber=element.pageNumber+1;
            });

            imagesCurrentDoc.splice((p.pageNumber), 0, { 
              documentID: this.selectedDocumentId,
              documentPageImageID: response.data,
              pageImageBase64: null,
              pageImageThumbnail:newURl,
              pageImageUrl:newURl,
              pageNumber: (p.pageNumber+1)
             });
             pd.images=imagesCurrentDoc;
          }
        });

        if(this.projectDocumentpageImages!=undefined && this.projectDocumentpageImages!=null){
          this.projectDocumentpageImages.forEach(element => {
            if(element.projectDocumentID==this.selectedDocumentId)
            {
            if(element.pageNumber>=ReqModel.pageNoTobeAdded)
               element.pageNumber=element.pageNumber+1;
            }
          });
          this.projectDocumentpageImages.splice(0, 0, { 
            documentID: this.selectedDocumentId,
            documentPageImageID: response.data,
            pageImageBase64: null,
            pageImageThumbnail:newURl,
            pageImageUrl:newURl,
            pageNumber: (p.pageNumber+1)
           });
         }

         this.participantArray.forEach(ml => {
          if(ml.documentId==this.selectedDocumentId){
          
          let jsonelement = JSON.parse(ml.participantJson);
         
          if(jsonelement==undefined || jsonelement==null){
           jsonelement=[];
          }
          
         //jsonelement.push({ img: newURl, fields: [] });
         jsonelement.splice((p.pageNumber), 0, { img: newURl, fields: [] });
          ml.participantJson = JSON.stringify(jsonelement);
          }
        });
        //this.SaveRecord();
        this.toastr.success('Blank page added successfully', '', {
          timeOut: 5000,
        });
        resolve(response); // Resolve the promise on success
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
        reject('Error: Operation failed');
      }
    } else {
      this.loaderService.hide();
      reject('Error: Operation failed');
    }
  });
});
}

async PostWaitInitFunctionality(){
  setTimeout(() => {
  const disabledElements = this.loadDisabledElements();
  // Now you can safely work with the DOM elements  
  disabledElements.forEach(element => {
    this.applyStyles(element);
  });
  const disabledElementsDiv= this.loadDisabledElementsDiv();
  disabledElementsDiv.forEach(element => {
    this.applyStyles(element);
  });
   },100);
}

applyStyles(element: HTMLElement) {
  element.style.setProperty('background-color', 'white', 'important');
  element.style.setProperty('border', 'none', 'important');
  element.style.setProperty('border-color', 'white !important');
 }
 @ViewChildren(CKEditorComponent) editors: QueryList<CKEditorComponent>;

 
  async ngAfterViewInit() {
  //   setTimeout(() => {
  //   this.editors.forEach((editorComponent) => {
  //     editorComponent.instance.on('change', () => {
  //         this.adjustEditorHeight(editorComponent.instance,editorComponent.instance.id);
  //     });
  // });
  //    },6000);

    if (this.signaturePad != undefined) {
      this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
      this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
     // Wait for ngOnInit operations to complete
     await this.waitForInitToComplete();
     const disabledElements = this.loadDisabledElements();
     // Now you can safely work with the DOM elements  
     disabledElements.forEach(element => {
       this.applyStyles(element);
     });
     const disabledElementsDiv= this.loadDisabledElementsDiv();
     disabledElementsDiv.forEach(element => {
       this.applyStyles(element);
     });
  }

  clearSignature() {
    this.SignButtonEnable = false;
    this.signaturePad.clear();
  }

  drawComplete() {
    this.SignButtonEnable = true;
    this.DrawButtonEnable = true;
    this.InitailButtonEnable = true;
    // will be notified of szimek/signature_pad's onEnd event    
    //let canvas = document.getElementsByTagName("canvas")[0]; 
    // this.signatureBase64=canvas.toDataURL();
  }

  addSignature() {
    let data: any = this.ControlData;
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined) {
      this.signatureBase64 = canvas.toDataURL();
      this.signName = "";
      this.signOrInitialImageObj = [];
    }
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;

      this.imagesWithFields = this.imagesWithFields;
    }
    this.dialog.closeAll();
  }

  addSignatureNew(result) {
    let data: any = this.ControlData;
    this.signatureBase64="";
    this.signName="";
    this.signInitialFontFamily="";
    this.signOrInitialImageObj = [];

    if(result.from=='Canvas'){
      let canvas = result.data;//document.getElementsByTagName("canvas")[0];
      if (canvas != undefined) {
        this.signatureBase64 = canvas.toDataURL();
        this.signName = "";
        this.signOrInitialImageObj = [];
      }
    }
    
    if(result.from=='Adopt'){
      if (result.signatureBase64 !== undefined && result.signatureBase64 !== "") {
        this.signatureBase64 = result.signatureBase64;
      }
      if (result.signName !== undefined && result.signName !== "") {
        this.signName = result.signName;
      }
      if (result.signInitialFontFamily !== undefined && result.signInitialFontFamily !== "") {
        this.signInitialFontFamily = result.signInitialFontFamily;
      }
      if (result.signOrInitialImageObj !== undefined && result.signOrInitialImageObj !== "") {
        this.signOrInitialImageObj = result.signOrInitialImageObj;
      }      
    }
    
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;

      this.imagesWithFields = this.imagesWithFields;
    }
    this.dialog.closeAll();
  }

  addDrawnImg() {
    let data: any = this.drawnImg.data;
    let canvas = document.getElementsByTagName("canvas")[0];
    if (canvas != undefined)
      this.drawImgBase64 = canvas.toDataURL();
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).drawBase64 = this.drawImgBase64;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).brushColor = this.brushColor;

      this.imagesWithFields = this.imagesWithFields;
    }
    this.dialog.closeAll();
  }

  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event

  }

  imgDrawStart() {
    if (this.brushColor != "")
      this.signaturePadOptions.penColor = "RGB(" + this.hexToRGBA(this.brushColor, 1) + ")";
    else {
      this.brushColor = "#000000";
      this.signaturePadOptions.penColor = "RGB(" + this.hexToRGBA(this.brushColor, 1) + ")";
    }
  }

  scrollToPage(pageNo: any) {
    const elementToScroll: HTMLElement = document.getElementById("docHolding" + pageNo);
    document.getElementsByClassName('documentHolder')[0].scrollTop = elementToScroll.offsetTop - 100
  }

  thumbsList: any = []

  setPagesList(thumbslist: any) {
    this.thumbsList = thumbslist;
  }

  // removeDeletedParticipant(json: any) {
  //   // let participantIdsArray = json.data.projGrpRelationParticipantList.map(a => a.groupRelationParticipantMappingID);
  //    let participantIdsArray = json.data.projGrpRelationParticipantList.map(a => a.relationID);
  //    if (json.data.participantJsons) {
  //      json.data.participantJsons.forEach(jsonObj => {
  //        let jsonCtrl = JSON.parse(jsonObj.participantJson);
  //        jsonCtrl.forEach(jsonfield => {
  //          jsonfield.fields.forEach(j => {
  //            if (!participantIdsArray.find(m => m == j.selectedParticipant.relationID) && j.selectedParticipant.groupRelationParticipantMappingID !== 0) {
  //            //  if (!participantIdsArray.find(m => m == j.selectedParticipant.groupRelationParticipantMappingID) && j.selectedParticipant.groupRelationParticipantMappingID !== 0) {

  //            // if (!participantIdsArray.find(m => m == j.selectedParticipant.groupRelationParticipantMappingID) && j.selectedParticipant.groupRelationParticipantMappingID !== 0) {
  //              j.selectedParticipant = {
  //                "participantName": "Any One",
  //                "participantEmail": "",
  //                "groupName": "",
  //                "relationName": "Unassigned",
  //                "colourCode": "#d7f5ff",
  //                "groupRelationParticipantMappingID": 0,
  //                "groupID": 0,
  //                "roleID": 0,
  //                "contactEmail": "",
  //                "selectedContactFieldEmailID": null,
  //                "roleName": "",
  //                "pariticipantId": 0,
  //                "contactID": 16,
  //                "relationID": 49,
  //                "isActive": true,
  //                "isDeleted": false,
  //                "participantImageURL": "https://ecmstorageaccount.blob.core.windows.net/ecm-userprofile-images/62ce841e-f5e6-4d7c-b42d-9b63eb3c394e1.jpg",
  //                "position": 1,
  //                "message": null,
  //                "hasCompleted": null,
  //                "isEmailSent": null,
  //                "signingToken": null,
  //                "userID": "",
  //                "organizationID": 0,
  //                "databaseID": 0
  //              };

  //              j.signatureBase64='';
  //              j.signatureText='';
  //              j.drawBase64='';
  //              j.chkSelectedValues=[];
  //              j.rbSelectedValues=['ctrl-0'];
  //              j.selectedValue='';
  //              j.fillList=[];
  //              j.FileData=[];
  //              j.ImageData=[];

  //              if (j.fieldTypeName == "StrikeThrough") {
  //                j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.7) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.7);
  //                j.colorCodeAlpha = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);

  //              }
  //              if (j.fieldTypeName == "HighLight") {
  //                j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);
  //                j.colorCodeAlpha = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);

  //              }
  //              if (j.fieldTypeName == "WhiteOut") {
  //                j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.7) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.7);
  //              }
  //              else if ((j.fieldTypeName != "WhiteOut") && (j.fieldTypeName != "StrikeThrough") && (j.fieldTypeName != "HighLight")) {
  //                j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);
  //                j.colorCodeAlpha = this.hexToRGBA(j.selectedParticipant.colourCode, 0.7) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.7);

  //              }
  //            }else{
  //              j.selectedParticipant.groupRelationParticipantMappingID =json.data.projGrpRelationParticipantList.find(n=>n.relationID==j.selectedParticipant.relationID).groupRelationParticipantMappingID;     
  //            }
  //          });
  //        });
  //        jsonObj.participantJson = JSON.stringify(jsonCtrl);
  //      });
  //    }
  //    return json;
  //  }


  removeDeletedParticipant(json: any) {
    let participantIdsArray = json.data.projGrpRelationParticipantList.map(a => a.groupRelationParticipantMappingID);
    if (json.data.participantJsons) {
      json.data.participantJsons.forEach(jsonObj => {
        let jsonCtrl = JSON.parse(jsonObj.participantJson);
        jsonCtrl.forEach(jsonfield => {
          jsonfield.fields.forEach(j => {
            if(j.selectedParticipant!=null){
              if (!participantIdsArray.find(m => m == j.selectedParticipant.groupRelationParticipantMappingID) && j.selectedParticipant.groupRelationParticipantMappingID !== 0) {

                // if (!participantIdsArray.find(m => m == j.selectedParticipant.groupRelationParticipantMappingID) && j.selectedParticipant.groupRelationParticipantMappingID !== 0) {
                j.selectedParticipant = {
                  "participantName": "Any One",
                  "participantEmail": "",
                  "groupName": "",
                  "relationName": "Unassigned",
                  "colourCode": "#d7f5ff",
                  "groupRelationParticipantMappingID": 0,
                  "groupID": 0,
                  "roleID": 0,
                  "contactEmail": "",
                  "selectedContactFieldEmailID": null,
                  "roleName": "",
                  "pariticipantId": 0,
                  "contactID": 16,
                  "coreID": 16,
                  "relationID": 49,
                  "isActive": true,
                  "isDeleted": false,
                  "participantImageURL": "https://ecmstorageaccount.blob.core.windows.net/ecm-userprofile-images/62ce841e-f5e6-4d7c-b42d-9b63eb3c394e1.jpg",
                  "position": 1,
                  "message": null,
                  "hasCompleted": null,
                  "isEmailSent": null,
                  "signingToken": null,
                  "userID": "",
                  "organizationID": 0,
                  "databaseID": 0
                };
  
                j.signatureBase64 = '';
                j.signatureText = '';
                j.drawBase64 = '';
                j.chkSelectedValues = [];
                j.rbSelectedValues = ['ctrl-0'];
                if(j.isValueFixedFormDesignPage==false || j.isValueFixedFormDesignPage==undefined)
                {
                  j.selectedValue = '';
                }
                j.fillList = [];
                j.FileData = [];
                j.ImageData = [];
  
                if (j.fieldTypeName == "StrikeThrough") {
                  j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.7) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.7);
                  j.colorCodeAlpha = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);
  
                }
                if (j.fieldTypeName == "HighLight") {
                  j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);
                  j.colorCodeAlpha = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);
  
                }
                if (j.fieldTypeName == "WhiteOut") {
                  j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.7) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.7);
                }
                else if ((j.fieldTypeName != "WhiteOut") && (j.fieldTypeName != "StrikeThrough") && (j.fieldTypeName != "HighLight")) {
                  j.colorCode = this.hexToRGBA(j.selectedParticipant.colourCode, 0.3) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.3);
                  j.colorCodeAlpha = this.hexToRGBA(j.selectedParticipant.colourCode, 0.7) == undefined ? '' : this.hexToRGBA(j.selectedParticipant.colourCode, 0.7);
  
                }
              }
            }
            
          });
        });
        jsonObj.participantJson = JSON.stringify(jsonCtrl);
      });
    }
    return json;
  }

  getParticipantAndDocumentDetails() {
    let ReqModel = {
      step: 3,
      projectId: sessionStorage.getItem('projectID'),
      databaseID: this.databaseId,
      organizationID: this.organizationId,
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.formService.getProjectFormEditorDetails(ReqModel).subscribe(response => {
      if (response.data != null) {
        response = this.removeDeletedParticipant(response);
        this.fieldFolders = response.data.fieldFolders
        sessionStorage.setItem('ProjectName', response.data.project.projectName);
        this._dataSharingService.sendSelectedModuleName('Forms');  
        this.SubmitNextButtonDisabled = true;
        // if(response.data.participantJsons.length>0) {
        //  response.data.participantJsons.forEach(j => {
        //    let pJson= JSON.parse(j.participantJson);
        //    pJson.forEach(jf => {
        //      if (jf.fields.length>0){
        //        jf.fields=jf.fields.filter(m=>
        //          response.data.projGrpRelationParticipantList.map(a => a.groupRelationParticipantMappingID).includes( m.selectedParticipant.groupRelationParticipantMappingID)
        //          )
        //      }
        //    });
        //    j.participantJson=JSON.stringify(pJson);
        //  });
        // }

        // this.projectParticipantsList = response.data.projGrpRelationParticipantList;
        if (this.indexExpanded == undefined) {
          this.indexExpanded = 0;
        }
        this.indexExpanded = this.indexExpanded;

        this.projectParticipantsList = response.data.projGrpRelationParticipantList.filter((s) => s.groupName != "Send Final Copy");
        //this.projectParticipantsList = this.projectParticipantsList.filter((s) => s.groupName != "View Only");
        this.projectParticipantsList.push({
          "participantName": "Any One",
          "participantEmail": "",
          "groupName": "",
          "relationName": "Unassigned",
          "colourCode": "#d7f5ff",
          "groupRelationParticipantMappingID": 0,
          "groupID": 0,
          "roleID": 0,
          "contactEmail": "",
          "selectedContactFieldEmailID": null,
          "roleName": "",
          "pariticipantId": 0,
          "contactID": 16,
          "coreID": 16,
          "relationID": 49,
          "isActive": true,
          "isDeleted": false,
          "participantImageURL": "https://ecmstorageaccount.blob.core.windows.net/ecm-userprofile-images/62ce841e-f5e6-4d7c-b42d-9b63eb3c394e1.jpg",
          "position": 1,
          "message": null,
          "hasCompleted": null,
          "isEmailSent": null,
          "signingToken": null,
          "userID": "",
          "organizationID": 0,
          "databaseID": 0
        });
        if (response.data.participantJsons && response.data.participantJsons.length > 0) {
          response.data.participantJsons.forEach(j => {
            let pJson = JSON.parse(j.participantJson);
            pJson.forEach(jf => {
              if (jf.fields && jf.fields.length > 0) {
                jf.fields.forEach(jsf => {
                  if (jsf.charLimit == '' || jsf.charLimit == undefined) {
                    jsf.charLimit = 0;
                  }
                  if (jsf?.selectedParticipant?.groupRelationParticipantMappingID > 0) {
                    let changeParticipant = this.projectParticipantsList.find(n => n.groupRelationParticipantMappingID == jsf?.selectedParticipant?.groupRelationParticipantMappingID);
                    if (changeParticipant !== undefined) {
                      jsf.selectedParticipant.colourCode = changeParticipant.colourCode;
                      jsf.colorCode = this.hexToRGBA(changeParticipant.colourCode, 1);
                      jsf.colorCodeAlpha = this.hexToRGBA(changeParticipant.colourCode, 0.7);
                    }
                  }
                });
              }
            });
            j.participantJson = JSON.stringify(pJson);
          });
        }
        this.ParticipantJsonList = response.data.participantJsons;
        this.projectDocuments = response.data.documents;
        this.projectDocumentpageImages = response.data.pageImages;
        this.selectedParticipant = response.data.projGrpRelationParticipantList.filter((s) => s.groupName != "Send Final Copy");
       // this.selectedParticipant = this.selectedParticipant.filter((s) => s.groupName != "View Only");
        this.selectedParticipant = this.selectedParticipant[0];
        if (this.selectedParticipant != undefined) {
          this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          this.participantAdded = true;
          this.selectedColorCode = this.selectedParticipant?.colourCode;
          //this.participantEmailId = this.selectedParticipant?.participantEmail;
          this.colorselected = this.hexToRGBA(this.selectedParticipant?.colourCode, 1);
          this.colorselectedAlpha = this.hexToRGBA(this.selectedParticipant?.colourCode, 0.7);
        } else {
          this.participantAdded = false;
        }

        // this.projectParticipantsList = response.data.projGrpRelationParticipantList;
        // this.ParticipantJsonList=response.data.participantJsons;
        // this.projectDocuments=response.data.documents;
        // this.projectDocumentpageImages=response.data.pageImages;
        // this.selectedParticipant = response.data.projGrpRelationParticipantList[0];
        // this.selectedColorCode = this.selectedParticipant.colourCode;
        // this.colorselected=this.hexToRGBA(this.selectedParticipant.colourCode,1);
        // this.colorselectedAlpha=this.hexToRGBA(this.selectedParticipant.colourCode,0.7);


        if (this.projectDocuments && this.projectDocuments.length > 0) {
          this.projectDocuments.forEach(n => {
            //n.images = this.projectDocumentpageImages.filter(m => m.documentID == n.projectDocumentID)
            n.images = this.projectDocumentpageImages.filter(m => m.documentID == n.projectDocumentID)
            n.images = n.images.sort(function (a, b) { return a.pageNumber - b.pageNumber });
          });
        }
        if (this.ParticipantJsonList != undefined && this.ParticipantJsonList.length > 0) {
          this.ParticipantJsonList.forEach(e => {
            if (e.participantJson != null && e.participantJson != undefined && e.participantJson != '' && e.participantJson != '[]') {
              this.participantArray.push({
                groupRelationParticipantMappingID: e.groupRelationParticipantMappingID,
                participantJson: e.participantJson,
                documentId: e.documentID,
                projectParticipantJsonID: e.projectParticipantJsonID
              })
            }
          });
        }
        this.projectDocuments.forEach(doc => {
          if (this.participantArray.length == 0)
            this.FillParticipantArray(doc.projectDocumentID, false);
          else if (this.participantArray.length > 0 && this.participantArray.find(b => b.documentId == doc.projectDocumentID) === undefined) {
            this.FillParticipantArray(doc.projectDocumentID, false);
          }
        });
        this.FillDocImagesWithFields();
        setTimeout(() => {
          this.initComplete(); // Signal that initialization is complete
         },500);
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    });
  }

  // SubmitBackButton(){
  //   this._dataSharingService.sendProjectNameAlreadyExist(false); 
  //   this.router.navigate(['/esignature/second']);
  // }

  refreshJson() {
    this.loaderService.show();
    let findPreviouslyparticipant = this.participantArray.find(m =>
      m.documentId == this.selectedDocumentId);
    if (findPreviouslyparticipant) {
      this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
    } else {
      this.participantArray.push({
        groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
        participantJson: JSON.stringify(this.imagesWithFields),
        documentId: this.selectedDocumentId,
        projectParticipantJsonID: 0
      })
    }

    sessionStorage.setItem("projectJson", JSON.stringify(this.participantArray));
    let ReqModel = {
      step: 3,
      projectId: sessionStorage.getItem('projectID'),
      databaseID: this.databaseId,
      organizationID: this.organizationId,
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formService.getProjectFormEditorDetails(ReqModel).subscribe(response => {
      if (response.data != null) {
        let savedParticipantJson = JSON.parse(sessionStorage.getItem("projectJson"));
        if (response.data.participantJsons.length > 0) {
          response.data.participantJsons.forEach(j => {
            let pJson = JSON.parse(j.participantJson);
            pJson.forEach(jf => {
              if (jf.fields.length > 0) {
                jf.fields = jf.fields.filter(m =>
                  response.data.projGrpRelationParticipantList.map(a => a.groupRelationParticipantMappingID).includes(m.selectedParticipant.groupRelationParticipantMappingID)
                )
              }
            });
            j.participantJson = JSON.stringify(pJson);
          });
        }
        this.projectDocuments = response.data.documents;
        this.projectDocumentpageImages = response.data.pageImages;

        if (this.projectDocuments && this.projectDocuments.length > 0) {
          this.projectDocuments.forEach(n => {
            n.images = this.projectDocumentpageImages.filter(m => m.documentID == n.projectDocumentID)
          });
        }
        this.participantArray = savedParticipantJson;
        this.FillDocImagesWithFields();
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    });
  }


  SaveRecord(close:boolean) {
    if (sessionStorage.getItem('ProjectName') == null || sessionStorage.getItem('ProjectName') == undefined || sessionStorage.getItem('ProjectName') == '') {
      this.toastr.warning('Please enter project name.', '', {
        timeOut: 2000,
      });
      return;
    }

    //Prepare Json previously selected participant
    let findPreviouslyparticipant = this.participantArray.find(m =>
      m.documentId == this.selectedDocumentId);
    if (findPreviouslyparticipant) {
      this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
    } else {
      this.participantArray.push({
        groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
        participantJson: JSON.stringify(this.imagesWithFields),
        documentId: this.selectedDocumentId,
        projectParticipantJsonID: 0
      })
    }
    let ReqModel = {
      participantJsons: this.participantArray,
      ProjectName: sessionStorage.getItem('ProjectName'),
      projectID: sessionStorage.getItem('projectID'),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.formService.AddParticipantJsonStep3(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          if(close==true){
           // window.self.close(); 
           // window.top.close();
            this.router.navigate(['/dashboard']);
            // window.close();
          }          
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  SubmitBackButton() {
    if (sessionStorage.getItem('ProjectName') == null || sessionStorage.getItem('ProjectName') == undefined || sessionStorage.getItem('ProjectName') == '') {
      this.toastr.warning('Please enter project name.', '', {
        timeOut: 2000,
      });
      return;
    }

    //Prepare Json previously selected participant
    let findPreviouslyparticipant = this.participantArray.find(m =>
      m.documentId == this.selectedDocumentId);
    if (findPreviouslyparticipant) {
      this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
    } else {
      this.participantArray.push({
        groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
        participantJson: JSON.stringify(this.imagesWithFields),
        documentId: this.selectedDocumentId,
        projectParticipantJsonID: 0
      })
    }
    let ReqModel = {
      participantJsons: this.participantArray,
      ProjectName: sessionStorage.getItem('ProjectName'),
      projectID: sessionStorage.getItem('projectID'),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.formService.AddParticipantJsonStep3(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.router.navigate(['/esignature/second']);
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }


  SubmitNextButton() {
    if (sessionStorage.getItem('ProjectName') == null || sessionStorage.getItem('ProjectName') == undefined || sessionStorage.getItem('ProjectName') == '') {
      this.toastr.warning('Please enter project name.', '', {
        timeOut: 2000,
      });
      return;
    }
    this.SubmitNextButtonDisabled = false;
    if (Number(sessionStorage.getItem('stepCompleted')) < 3) {
      sessionStorage.setItem('stepCompleted', '3');
    }

    //Prepare Json previously selected participant
    let findPreviouslyparticipant = this.participantArray.find(m =>
      m.documentId == this.selectedDocumentId);
    if (findPreviouslyparticipant) {
      this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
    } else {
      this.participantArray.push({
        groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
        participantJson: JSON.stringify(this.imagesWithFields),
        documentId: this.selectedDocumentId,
        projectParticipantJsonID: 0
      })
    }
    this.participantArray.forEach(ml => {
      let jsonelement = JSON.parse(ml.participantJson);
      jsonelement.forEach(element => {
        element.fields.forEach(fe => {
          if (fe.fieldTypeName == 'MultiSelect') {
            if (fe?.selectedValue === undefined) {
              fe.selectedValue = "";
            }
            if (Array.isArray(fe?.selectedValue) && fe?.selectedValue.length > 0)
              fe.selectedValue = fe.selectedValue?.join(',');
            if (Array.isArray(fe?.selectedValue) && fe?.selectedValue.length == 0)
              fe.selectedValue = '';
          }
        });
      });
      ml.participantJson = JSON.stringify(jsonelement);

    });
    let thiredStepReqModel = {
      participantJsons: this.participantArray,
      ProjectName: sessionStorage.getItem('ProjectName'),
      projectID: sessionStorage.getItem('projectID'),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.loaderService.show();
    this.formService.AddParticipantJsonStep3(thiredStepReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.router.navigate(['/esignature/four']);
          this.loaderService.hide();
        } else {
          this.SubmitNextButtonDisabled = true;
          this.loaderService.hide();
        }
      } else {
        this.SubmitNextButtonDisabled = true;
        this.loaderService.hide();
      }
    });
  }

  SingleLineControl() {
    this.singlLineWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Single-Line",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Textbox",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  StraightLineControl() {
    this.straightLineWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Single-Line",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "StraightLine",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  MeasureControl() {
    this.MeasureWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "measure",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "measure",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  StrikeThroughControl() {
    this.strikeThroughWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Single-Line",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "StrikeThrough",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  WhiteOutControl() {
    this.WhiteOutWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Single-Line",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "WhiteOut",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  HighlightControl() {
    this.HighlightFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "High-Light",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "HighLight",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  MultiLineControl() {
    this.multiLineWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Multi-Line",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Textarea",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "250",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  NumberControl() {
    this.numberWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Number",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Number",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  AIboxControlControl() {
    this.aiBoxWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "AITextBox",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "AITextBox",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "aiQuestion":'',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": '100%',
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }
  FileControl() {
    this.fileWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "File",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  ImageControl() {
    this.imageWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Image",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  ButtonControl() {
    this.buttonWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Button",
        "placeholder": "",
        "defaultValue": "Button",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": "Button",
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  RadioControl() {
    this.radioWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Radio",
        "placeholder": "",
        "defaultValue": "'',''",//"Option 1,Option 2",  
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  CheckBoxGroupControl() {
    this.checkboxgroupWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "CheckBoxGroup",
        "placeholder": "",
        "defaultValue": "'',''",//"Option 1,Option 2",      
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  DropDownControl() {
    this.dropdownWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "Dropdown",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Dropdown",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  CheckBoxControl() {
    this.checkWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Checkbox",
        "placeholder": "",
        "defaultValue": "",//"Option 1,Option 2",      
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  BulletListControl() {
    this.bulletWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "BulletList",
        "placeholder": "",
        "defaultValue": "",//"Point 1,Point 2",       
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  TableListControl() {
    this.tableWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Table",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  DateControl() {
    this.dateWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Date",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  TimeControl() {
    this.timeWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Time",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  ApproveOrDecline() {
    this.ApproveOrDeclineWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "ApproveOrDecline",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  GeoLocation() {
    this.LocationWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Location",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  SignatureControl() {
    this.signatureWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Signature",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": true,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  DrawControl() {
    this.drawWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Draw",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  DrawInPopUpControl() {
    this.drawInPopUp.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Drawpopup",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  InitialsControl() {
    this.initialsWithFields.push(
      {
        "id": "",
        "fieldID": 0,
        "fieldName": "",
        "folderID": 0,
        "folderName": "",
        "fieldTypeID": 0,
        "fieldTypeName": "Initials",
        "placeholder": "",
        "defaultValue": "",
        "fillList": "",
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": true,
        "readonly": false,
        "charLimit": "100",
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": "",
        "offsetY": "",
        "height": 0,
        "width": 0,
        "textalign": "",
        "chkSelectedValues": [],
        "rbSelectedValues": "",
        "fieldNames": "",
        "buttonText": "",
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": "",
        "colorCodeAlpha": "",
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": "",
        "backgroundColor": "",
        "buttonName": "",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": 0
      })
  }

  onClickOutside() {
    if (!this.replaceIconHasClass) {
      document.getElementById("chkReplace").classList.remove('cdk-focused');
      document.getElementById("chkReplace").classList.remove('cdk-mouse-focused');
    }
    else {
      document.getElementById("chkReplace").classList.add('cdk-focused')
      document.getElementById("chkReplace").classList.add('cdk-mouse-focused')
    }
    if (!this.verifiedIconHasClass) {
      document.getElementById("chkverified").classList.remove('cdk-focused');
      document.getElementById("chkverified").classList.remove('cdk-mouse-focused');
    }
    else {
      document.getElementById("chkverified").classList.add('cdk-focused')
      document.getElementById("chkverified").classList.add('cdk-mouse-focused')
    }
    //this.hideTableAndBulletList(true,true);
    this.controlId2Paste = "";
    this.ControlId = "";
    this.isSelectAll = false;
    this.ShowtoolDetail = false;
    this.controlAlignArray = [];
    this.isControlKeyPressed = false;
    this.isShiftKeyPressed = false;
    // var data= this.ControlData;
    // if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
    //   this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ShowtoolDetail = false;
    //   this.imagesWithFields = this.imagesWithFields;   
    // }
    this.imagesWithFields.map(function (entry) {
      entry.fields.map(function (fieldentry) {
        fieldentry.ShowtoolDetail = false;
        return entry;
      });
    });

  }
  isShiftKeyPressed: boolean = false;

  onImageKeyPress(event) {
    if (event.ctrlKey) {
      this.isControlKeyPressed = true;
      this.isShiftKeyPressed = false;
      return;
    }
    if (event.shiftKey) {
      this.isControlKeyPressed = false;
      this.isShiftKeyPressed = true;
      return;
    }
    else {
      this.isControlKeyPressed = false;
      this.isShiftKeyPressed = false;
      return;
    }

  }

  SelectAllControls() {
    this.ShowtoolDetail = false;
    this.isSelectAll = !this.isSelectAll;
    this.controlAlignArray = [];
    this.imagesWithFields.map((entry) => {
      entry.fields.map((fieldentry) => {

        this.controlAlignArray.push({
          fieldTypeName: fieldentry.fieldTypeName,
          img: entry.img,
          id: fieldentry.id
        });
        fieldentry.ShowtoolDetail = this.isSelectAll;
        return entry;
      });
    });
  }

  isverifiedIconEnabled: any = false;
  highlightRequiredControls(isOn: any) {
    if (isOn) {
      this.isverifiedIconEnabled = true;
      this.verifiedIconHasClass = true;

      document.getElementById("chkverified").classList.add('cdk-focused')
      document.getElementById("chkverified").classList.add('cdk-mouse-focused')
    }
    else {
      document.getElementById("chkverified").classList.remove('cdk-focused');
      document.getElementById("chkverified").classList.remove('cdk-mouse-focused');
      this.isverifiedIconEnabled = false;
      this.verifiedIconHasClass = false;
    }

    this.showAllRequiredControls = !this.showAllRequiredControls;
    this.imagesWithFields.map((entry) => {
      entry.fields.map((fieldentry) => {
        if (this.showAllRequiredControls) {
          if (fieldentry.isRequired == true) {
            fieldentry.showRequiredControls = true;
          }
        }
        else {
          fieldentry.showRequiredControls = false;
        }
        return entry;
      });
    });
  }


  deleteControls() {
    this.closeDetail();
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    this.controlAlignArray.forEach(ctrl => {
      var data = ctrl;
      let ctrlId = ctrl.id;
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {

        var index = this.imagesWithFields.find(x => x.img == data.img).fields.map(x => {
          return x.id;
        }).indexOf(ctrlId);

        this.imagesWithFields.find(x => x.img == data.img).fields.splice(index, 1);
        this.ShowtoolDetail = false;
      }

    });
    this.controlAlignArray = [];
  }

  formatSubfolderName(subfolderName) {
    if ((subfolderName != null) || (subfolderName != undefined)) {
      let idx = subfolderName.indexOf(" (");
      return subfolderName.substr(0, idx);
    }
  }

  onChangeTexarea(value: any, data: any, field) {
    var widthTest = document.getElementById(field.id);
    var height = (widthTest.clientHeight + 25);
    let selectedCtrlFolderID = field.folderID;
    field.selectedValue = value;
    let fieldParticipantID = field.selectedParticipant?.groupRelationParticipantMappingID;
    fieldParticipantID = (fieldParticipantID == undefined ? 0 : fieldParticipantID);
    let contactFolder: any = []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {

      if (this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined) {
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      }

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
              }
            });
          });
        }
      });
      this.text = value;
    }

    let coretFolder: any = []; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined) {
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      }

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
              }
            });
          });
        }
      });
      this.text = value;
    }


    let comFolder: any = [];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Company));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined) {
        this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
        this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      }

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
              }
            });
          });
        }
      });
      this.text = value;
    }

    if (fieldParticipantID == this.groupRelationParticipantId && ((selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0)
    )) {
      if (this.imagesWithFields.find(x => x.img == data.img) !== undefined)
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID == 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
    }
  }

  addActiveClass(item: any, data, event) {
    if (event.shiftKey) {
      if (!this.controlAlignArray.find(m => m.id == item.id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == item.id).fieldTypeName,
          img: data.img,
          id: item.id
        });
        if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
          var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
          var getData = FieldsDetails.fields.filter(x => x.id === item.id);
          if (getData.length > 0) {
            this.text = getData[0].selectedValue;
            this.ControlData = FieldsDetails;
            this.ControlId = item.id;
            this.isRequired = getData[0].isRequired;
            this.readonly = getData[0].readonly;
            this.characterlimit = getData[0].charLimit;
            this.textColor = getData[0].fontColor;
            var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
            this.fontsize = Number(size);
            this.fontstyle = getData[0].fontstyle;
            this.fontweight = getData[0].fontweight;
            this.textdecoration = getData[0].textdecoration;
            this.fontfamily = getData[0].fontfamily;
            this.textalign = getData[0].textalign;
            this.selectedParticipant = getData[0].selectedParticipant;
            this.buttonText = getData[0].buttonName;
            this.buttonURL = getData[0].buttonURL;
            this.acceptOrdeclineText = getData[0].buttonText;
            this.brushColor = getData[0].penColor;


            if (this.acceptOrdeclineText == "Approve") {
              this.acceptchecked = true;
              this.declinechecked = false;
            }
            if (this.acceptOrdeclineText == "Decline") {
              this.declinechecked = true;
              this.acceptchecked = false;
            }

            if (this.buttonURL != "" && this.buttonURL != undefined && this.buttonURL != '') {
              const url = this.buttonURL;
              window.open(url, '_blank');
            }
            // this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
            //   if (element.id != item.id)
            //     element.ShowtoolDetail = false;
            // });
            this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
          }
          // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
        }
        return item.ShowtoolDetail = true;
      }
      else {
        let index = this.controlAlignArray.findIndex(m => m.id == item.id);
        this.controlAlignArray.splice(index, 1);
        this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == item.id).ShowtoolDetail = false;
        return item.ShowtoolDetail = false;
      }
    }
    else {
      this.imagesWithFields.map(function (entry) {
        entry.fields.map(function (fieldentry) {
          fieldentry.ShowtoolDetail = false;
          return entry;
        });
      });
      return item.ShowtoolDetail = true;
    }
  }


  OpentoolDetail(message: any) {
    if (this.isShiftKeyPressed) {
      this.ShowtoolDetail = false;
      this.isShiftKeyPressed = false;
    }
    else {
      this.ShowtoolDetail = true;
      if (message != 'Dropdown') {
        // this.controlAlignArray=[];
      }
    }
    //!this.ShowtoolDetail
    this.showToolsLeft = false;
    this.Sdropdown = false;
    this.Smuldropdown = false;
    this.Sbutton = false;
    this.Snumber = false;
    this.Sradio = false;
    this.Scheckbox = false;
    this.Scheckboxgroup = false;
    this.Stable = false;
    this.Sbullet = false;
    this.Sformat = false;
    this.Sdraw = false;
    this.Stext = false;
    this.SButtontext = false;
    this.SURL = false;
    this.Smeasure = false;
    this.Sline = false;
    this.Smultiline = false;
    this.Ssingleline = false;
    this.Sthrough = false;
    this.SwhiteOut = false;
    this.ShighLight = false;
    this.Ssignature = false;
    this.Sinitials = false;
    this.Sapproval = false;
    this.Sdate = false;
    this.Stime = false;
    this.Slocation = false;
    this.SAItext = false;
    this.SbuttonLabel = false;
    this.Simage = false;
    this.Sfile = false;
    this.SURLL = false;
    this.aiAnswer='';
    this.isRequired=false;
    if (message == 'Signature') {
      this.Ssignature = true;
      this.isRequired=true;
    }
    if (message == 'AITextBox') {
      this.SAItext = true;
    }

    if (message == 'Initials') {
      this.Sinitials = true;
      this.isRequired=true;
    }

    if (message == 'File') {
      this.Sfile = true;
    }

    if (message == 'Image') {
      this.Simage = true;
    }

    if (message == 'Location') {
      this.Slocation = true;
      this.Sformat = true;
    }

    if (message == 'Time') {
      this.Stime = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sdate = true;
      this.Sformat = true;
      this.isRequired=true;
    }

    if (message == 'ApproveOrDecline') {
      this.Sapproval = true;
      this.SreadOnly = false;
      // this.Srequired = true;
      this.Sbutton = true;
      this.Sformat = true;
    }

    if (message == 'Textbox') {
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'BulletList') {
      this.Sformat = true;
      this.Sbullet = true;
    }

    if (message == 'Textarea') {
      this.Smultiline = true;
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sformat = true;
    }

    if (message == 'line' || message == 'StraightLine') {
      this.Sline = true;
    }

    if (message == 'measure') {
      this.Smeasure = true;
    }

    if (message == 'Draw') {
      this.Sdraw = true;
    }


    if (message == 'format') {
      this.Sformat = true;
    }

    if (message == 'Table') {
      this.Stable = true;
      this.Stext = false;
    }

    if (message == 'text') {
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Radio') {
      this.Sradio = true;
      this.Sformat = true;
    }

    if (message == 'Checkbox') {
      this.Scheckbox = true;
      this.Sformat = true;
    }

    if (message == 'CheckBoxGroup') {
      this.Scheckboxgroup = true;
      this.Sformat = true;
    }

    if (message == 'MultiSelect') {
      this.Smuldropdown = true;
      this.Sformat = true;
    }

    if (message == 'Dropdown') {
      this.Sdropdown = true;
      this.Sformat = true;
    }

    if (message == 'Button') {
      this.SbuttonLabel = true;
      this.SButtontext = true;
      this.SURL = true;
      this.Sformat = true;
    }

    if (message == 'Number') {
      this.Snumber = true;
      this.Sformat = true;
    }
    if (message == 'StrikeThrough') {
      this.Sthrough = true;
    }
    if (message == "WhiteOut") {
      this.SwhiteOut = true;
    }

    if (message == "HighLight") {
      this.ShighLight = true;
    }
    if (message == "URL") {
      this.SURLL = true;
      this.Sformat = true;
    }   

  }

  createField(value: any) {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    if (value == "Core") {
      var data = [];
      data = menuModulesList.filter(x => x.mainModuleName === "Core");
      if (data.length > 0) {
        var folderId = data[0].folderID;
      }
    }
    if (value == "Contact") {
      var data = [];
      data = menuModulesList.filter(x => x.mainModuleName === "Contact");
      if (data.length > 0) {
        var folderId = data[0].folderID;
      }
      // var data = this.folderList.filter(x => x.folderName === "Contact");
      // var folderId = data[0].folderID;
    }
    if (value == "Company") {
      var data = [];
      data = menuModulesList.filter(x => x.mainModuleName === "Company");
      if (data.length > 0) {
        var folderId = data[0].folderID;
      }
      //var data = this.folderList.filter(x => x.folderName === "Company");
      // var folderId = data[0].folderID;
    }
    this.showSidePanel = true;
    this._dataSharingService.sendSelectedFolderIdInSetting(folderId);
  }

  OnAcceptOrDecline(e: any, isAccecpt: boolean) {
    let ctrl = this.ControlData;
    let ctrlId = this.ControlId;

    if (this.imagesWithFields.find(x => x.img == ctrl.img) && this.imagesWithFields.find(x => x.img == ctrl.img).fields.length > 0) {
      if (isAccecpt) {
        this.imagesWithFields.find(x => x.img == ctrl.img).fields.find(m => m.id == ctrlId).buttonText = 'Approve';
        this.acceptOrdeclineText = 'Approve';
      } else {
        this.imagesWithFields.find(x => x.img == ctrl.img).fields.find(m => m.id == ctrlId).buttonText = 'Decline';
        this.acceptOrdeclineText = 'Decline';
      }
    }
  }

  closecreateField(message: boolean) {
    this.showSidePanel = false;
  }

  
  GetAllCoreFieldsForOpenAI() {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.GetAllFieldsForOpenAI(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          let corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.corefieldsListAI = corefieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.corefieldsListAI.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              //  List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.corefieldsListAI.push(req);
              }
            }
          }
          this.corefieldsListAI = this.corefieldsListAI.filter((s) => s.fieldID != 0);
          this.aICoreFields=  this.corefieldsListAI;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }
  
  getAllCoreFields(subFolderID) {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          var corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.corefieldsList = corefieldsListData.filter((s) => s.availableOn != 1);
          var FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              //  List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: List[i1].defaultValue,
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.corefieldsList.push(req);
              }
            }
          }
          this.corefieldsList = this.corefieldsList.filter((s) => s.fieldID != 0);
          this.corefieldsDragList = this.corefieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllCoreSubfolderFields(subFolderID) {
    // var data = this.folderList.filter(x => x.folderName === "Core");
    // var folderId = data[0].folderID;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    let SubFolderName = this.coreSubFolderList.find(x => x.subFolderID == subFolderID).folderName;
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          let corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.corefieldsList = corefieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          //var FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);
          // let corefieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // corefieldsListData = corefieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.corefieldsList = corefieldsListData.filter((s) => s.availableOn != 1);
          // let FieldsListData = this.corefieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              // List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.corefieldsList.push(req);
              }
            }
          }
          this.corefieldsList = this.corefieldsList.filter((s) => s.fieldID != 0);
          this.corefieldsList.map(function (entry) {
            entry["subFolderName"] = SubFolderName;
          });
          this.corefieldsDragList = this.corefieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllCompanySubfolderFields(subFolderID) {
    // var data = this.folderList.filter(x => x.folderName === "Company");
    // var folderId = data[0].folderID;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Company");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    let SubFolderName = this.companySubFolderList.find(x => x.subFolderID == subFolderID).folderName;
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.companyfieldsList = companyfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.companyfieldsList.filter((s) => s.fieldID == 0);
          let companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.companyfieldsList = companyfieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.companyfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              // List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.companyfieldsList.push(req);
              }
            }
          }

          this.companyfieldsList.map(function (entry) {
            entry["subFolderName"] = SubFolderName;
          });
          this.companyfieldsList = this.companyfieldsList.filter((s) => s.fieldID != 0);
          this.companyfieldsDragList = this.companyfieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllContactSubfolderFields(subFolderID) {
    //var data = this.folderList.filter(x => x.folderName === "Contact");
    //var folderId = data[0].folderID;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Contact");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    let SubFolderName = this.contactSubFolderList.find(x => x.subFolderID == subFolderID).folderName;
    this.coreContactCompanyType = SubFolderName;
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.contactfieldsList = contactfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.contactfieldsList.filter((s) => s.fieldID == 0);
          let contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.contactfieldsList = contactfieldsListData.filter((s) => s.availableOn != 1);
          let FieldsListData = this.contactfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              // List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.contactfieldsList.push(req);
              }
            }
          }

          this.contactfieldsList.map(function (entry) {
            entry["subFolderName"] = SubFolderName;
          });
          // this.contactfieldsList.map
          this.contactfieldsList = this.contactfieldsList.filter((s) => s.fieldID != 0);
          this.contactfieldsDragList = this.contactfieldsList;
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getCoreSubFolderList() {
    //var data = this.folderList.filter(x => x.folderName === "Core");
    // let folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    this.addSubFolderVM.folderID = folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.addSubFolderVM.OfficeIDList = this.OfficeIDList;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        let getSubFolderListResponseHolder: any;
        getSubFolderListResponseHolder = response;
        if (getSubFolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.coreSubFolderList = getSubFolderListResponseHolder.data;
          if (this.coreSubFolderList.length > 0) {
            this.coreSubFolderList = getSubFolderListResponseHolder.data.filter(x => x.isActive == true);
          }
          // if (this.coreSubFolderList) {
          //   this.coreSubFolderList.forEach(e => {
          //     if (e.isActive) {
          //       e.folderName = e.folderName + ' (Active)';
          //     } else {
          //       e.folderName = e.folderName + ' (InActive)';
          //     }
          //   });
          // }
        }
      }
    });
  }

  getContactSubFolderList() {
    // var data = this.folderList.filter(x => x.folderName === "Contact");
    // let folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Contact");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    this.addSubFolderVM.folderID = folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.addSubFolderVM.OfficeIDList = this.OfficeIDList;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        let getSubFolderListResponseHolder: any;
        getSubFolderListResponseHolder = response;
        if (getSubFolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.contactSubFolderList = getSubFolderListResponseHolder.data;
          if (this.contactSubFolderList.length > 0) {
            this.contactSubFolderList = getSubFolderListResponseHolder.data.filter(x => x.isActive == true);
          }
          // if (this.contactSubFolderList) {
          //   this.contactSubFolderList.forEach(e => {
          //     if (e.isActive) {
          //       e.folderName = e.folderName + ' (Active)';
          //     } else {
          //       e.folderName = e.folderName + ' (InActive)';
          //     }
          //   });
          // }
        }
      }
    });
  }

  getCompanySubFolderList() {
    // var data = this.folderList.filter(x => x.folderName === "Company");
    // let folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Company");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    this.addSubFolderVM.folderID = folderId;
    this.addSubFolderVM.userID = this.currentUser.UID;
    this.addSubFolderVM.databaseID = Number(this.databaseId);
    this.addSubFolderVM.organizationId = Number(this.organizationId);
    this.addSubFolderVM.officeID = this.myOfficeID;
    this.addSubFolderVM.OfficeIDList = this.OfficeIDList;
    this.settingsService.getSubFolderList(this.addSubFolderVM).subscribe(response => {
      if (response != undefined) {
        let getSubFolderListResponseHolder: any;
        getSubFolderListResponseHolder = response;
        if (getSubFolderListResponseHolder.status == this.statusConstant.statusSuccess) {
          this.companySubFolderList = getSubFolderListResponseHolder.data;
          if (this.companySubFolderList.length > 0) {
            this.companySubFolderList = getSubFolderListResponseHolder.data.filter(x => x.isActive == true);
          }
          // if (this.companySubFolderList) {
          //   this.companySubFolderList.forEach(e => {
          //     if (e.isActive) {
          //       e.folderName = e.folderName + ' (Active)';
          //     } else {
          //       e.folderName = e.folderName + ' (InActive)';
          //     }
          //   });
          // }
        }
      }
    });
  }

  getAllCompanyFields(subFolderID) {
    //  var data = this.folderList.filter(x => x.folderName === "Company");
    // var folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Company");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.companyfieldsList = companyfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.companyfieldsList.filter((s) => s.fieldID == 0);
          var companyfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          companyfieldsListData = companyfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.companyfieldsList = companyfieldsListData.filter((s) => s.availableOn != 1);
          var FieldsListData = this.companyfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              //List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.companyfieldsList.push(req);
              }
            }
          }
          this.companyfieldsList = this.companyfieldsList.filter((s) => s.fieldID != 0);
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getAllContactFields(subFolderID) {
    // var data = this.folderList.filter(x => x.folderName === "Contact");
    // var folderId = data[0].folderID;
    var folderId;
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Contact");
    if (data.length > 0) {
      folderId = data[0].folderID;
    }
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderID: folderId,
      subFolderID: subFolderID,
      fieldID: 0,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getFieldsListResponseHolder = response;
        if (this.getFieldsListResponseHolder.status == this.statusConstant.statusSuccess) {
          // var contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          // contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          // this.contactfieldsList = contactfieldsListData;//corefieldsListData.filter((s) => s.availableOn != 1);
          // var FieldsListData = this.contactfieldsList.filter((s) => s.fieldID == 0);
          var contactfieldsListData = this.getFieldsListResponseHolder.data.activeFields;
          contactfieldsListData = contactfieldsListData.filter(s => s.fieldTypeName != 'Image');
          this.contactfieldsList = contactfieldsListData.filter((s) => s.availableOn != 1);
          var FieldsListData = this.contactfieldsList.filter((s) => s.availableOn != 1 && s.fieldID == 0);

          if (FieldsListData.length > 0) {
            for (var i = 0, len = FieldsListData.length; i < len; ++i) {
              var List = [];
              // List = FieldsListData[i].data.filter((s) => s.fieldID != 0);
              List = FieldsListData[i].data.filter((s) => s.availableOn != 1 && s.fieldID != 0);
              for (var i1 = 0, len1 = List.length; i1 < len1; ++i1) {
                var req = {
                  fieldIcon: List[i1].fieldIcon,
                  fieldName: List[i1].fieldName,
                  fieldTypeName: List[i1].fieldTypeName,
                  position: List[i1].position,
                  defaultValue: '',
                  folderID: folderId,
                  fieldID: List[i1].fieldID
                }
                this.contactfieldsList.push(req);
              }
            }
          }
          this.contactfieldsList = this.contactfieldsList.filter((s) => s.fieldID != 0);
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  onDragStart(event: DragEvent) {
  }

  onDragEnd(event: DragEvent) {

  }

  onDraggableCopied(event: DragEvent) {

  }

  onDraggableLinked(event: DragEvent) {

  }

  onDragged(item: any, list: any[], effect: DropEffect) {
    if (effect === "move") {
      const index = list.indexOf(item);
      list.splice(index, 1);
    }
  }


  onDragCanceled(event: DragEvent) {

  }

  onDragover(event: DragEvent) {

  }

  transferDataSuccess(event) {
  }
  showAllPlaceHolderNames() {
    if (this.imagesWithFields[0].fields.length > 0)
      this.isShowAllEditablePlaceHolders = this.imagesWithFields[0].fields[0].isShowAllEditablePlaceHolders != undefined ? !this.imagesWithFields[0].fields[0].isShowAllEditablePlaceHolders : true;
    else
      this.isShowAllEditablePlaceHolders = !this.isShowAllEditablePlaceHolders;
    this.imagesWithFields.forEach(element => {
      element.fields.forEach(fe => {
        fe.isShowAllEditablePlaceHolders = this.isShowAllEditablePlaceHolders;
      });
    });
    this.participantArray.forEach(ml => {
      let jsonelement = JSON.parse(ml.participantJson);
      jsonelement.forEach(element => {
        element.fields.forEach(fe => {
          fe.isShowAllEditablePlaceHolders = this.isShowAllEditablePlaceHolders;
        });
      });
      ml.participantJson = JSON.stringify(jsonelement);
    });
  }

  toLocalISOString(date: Date): string {
    const tzOffset = date.getTimezoneOffset() * 60000; // Offset in milliseconds
    const localISOTime = new Date(date.getTime() - tzOffset).toISOString().slice(0, 10);
    return localISOTime;
  }

    onSetWidth(item: any) {

      if(item.fieldName === 'Address'){
        return
      }

    // Find the parent div using item.id
    const divElement = document.getElementById('Outer_'+item.id);  // Assuming the div has the same id as the item
    
    if (divElement) {
      // Calculate the new width based on input value (or other logic)
      const newWidth = this.getInputWidth(item.selectedValue, item);
      
      // Set the new width on the div element
      divElement.style.width = `${newWidth}px`;  // Apply the new width in px

      // Optionally, update the item object with the new width for persistence
      item.offsetWidth = newWidth;
    }
  }

  // getInputWidth(value: string, item: any): number {
  //   const baseCharWidth = 7.78;  // Width per character
  //   const minWidth = 150;  // Minimum width
  //   const padding = 5.2;  // Padding value
  //   const length = value?.length || 0;  // Length of the value in input
  //   const width = length * baseCharWidth + padding;  // Calculate width based on length
  //   const maxWidth = item.charLimit ? item.charLimit * baseCharWidth + padding : 800;  // Maximum width
    
  //   // Return the constrained width
  //   return Math.min(Math.max(width, minWidth), maxWidth);
  // }


  getInputWidth(value: string, item: any): number {
  const minWidth = 150;
  const padding = 5.2; // Add some buffer for cursor + spacing
  const maxWidth = item?.charLimit ? item.charLimit * 5 + padding : 800;

  // Create canvas context for measurement
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  // Use the same font as your input box
  context.font = "16px Arial"; // Change this to match your input font

  const textWidth = context.measureText(value || "").width;
  const finalWidth = textWidth + padding;

  return Math.min(Math.max(finalWidth, minWidth), maxWidth);
}

onChange(value: any, data: any, field) {
  if(field.isDollar==true && value!=null && value !=undefined && value!="" && !value.includes("$"))
  {
    value="$"+value
  }
    if(field.fieldTypeName=='Date')
    {
      if (value) {
        const date = new Date(value);
        // Convert date to local ISO string
        field.selectedValue = this.toLocalISOString(date);
        // Now you can send `field.selectedValue` to the API
      }
    }
    else
    {
    field.selectedValue=value;
    }
    this.text = value;
    let selectedCtrlFolderID = field.folderID;
    //field.selectedValue = value;
    let fieldParticipantID = field.selectedParticipant?.groupRelationParticipantMappingID;
    fieldParticipantID = (fieldParticipantID == undefined ? 0 : fieldParticipantID);
    let contactFolder: any = []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined)
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = field.selectedValue == undefined ? '' : field.selectedValue;

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
        }
      });
      this.text = value;
    }

    let coretFolder: any = []; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined)
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = field.selectedValue == undefined ? '' : field.selectedValue;

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
        }
      });
      this.text = value;
    }


    let comFolder: any = [];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Company));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined)
        this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = field.selectedValue == undefined ? '' : field.selectedValue;

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
        }
      });
      this.text = value;
    }
    if (value != '' && value != undefined) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).isValueFixedFormDesignPage = true;
    }
    else {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).isValueFixedFormDesignPage = false;
    }
    if (fieldParticipantID == this.groupRelationParticipantId && ((selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0)
    )) {
      if (this.imagesWithFields.find(x => x.img == data.img) !== undefined)
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID == 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = field.selectedValue == undefined ? '' : field.selectedValue;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = field.selectedValue == undefined ? '' : field.selectedValue;
    }

   let finalExpression = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).finalExpression;
  //  if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="" && finalExpression.length>0)
  //   {
  //     let finalExpressionvalue=this.removeAllWhitespace(finalExpression);
   
  //    let excontrols=this.splitExpression(finalExpressionvalue);
  //    this.evaluateExpression(finalExpressionvalue, excontrols,data);
  //  }
   finalExpression=this.ensureValueIsArray(finalExpression);
   if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="" && finalExpression.length>0)
    {
      finalExpression.forEach(fex => {
        let cleanedfex=this.removeAllWhitespace(fex);
      let excontrols=this.splitExpression(cleanedfex);
      this.evaluateExpression(cleanedfex, excontrols,data);
      });
    }
  }

  onChangeCkeditor(value: any, data: any, field) {
    //this.aiAnswer = value;  
    if (value != '' && value != undefined) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).isValueFixedFormDesignPage = true;
    }
    else {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).isValueFixedFormDesignPage = false;
    }
     if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID == 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
    }

  }
 
  // Angular Component Class
ckeditorPosition: number = null;
ckeditorInitialHeight: number = null;

// Call this function to set up the observer
setupCKEditorObserver(ckeditorInstance,data): void {
  const editorElement = ckeditorInstance.editable().$; // Get the DOM element of CKEditor

  // Find and store the position and initial height of CKEditor
  //for (const item of this.imagesWithFields[0].fields) {
    // for (const item of data.fields) {
    // if (item.fieldTypeName === "AITextBox" && item.id==this.currentCkeditorId) {
      this.ckeditorPosition = data.fields.find(n=>n.id==this.currentCkeditorId).offsetY;
      this.ckeditorInitialHeight = editorElement.offsetHeight;
      //break;
    //}
  //}

  this.adjustControlPositions(editorElement.offsetHeight,data);
  // const observer = new MutationObserver(mutations => {
  //   for (const mutation of mutations) {
  //     if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
  //       this.adjustControlPositions(editorElement.offsetHeight);
  //     }
  //   }
  // });

  //observer.observe(editorElement, { attributes: true });
}

adjustControlPositions(newHeight: number,data): void {
  let lastItem = this.heightArray[this.heightArray.length - 1];
let secondLastItem = this.heightArray.length > 1 ? this.heightArray[this.heightArray.length - 2] : {id:this.currentCkeditorId,height:200};
let heightDifference = lastItem.height - secondLastItem.height;
  if (heightDifference > 0 && lastItem.height>200) {

    //let ckeditorHeightChangeDetected = false;
   if(this.isPasteEvent && this.aieditorLineCount==0)
   {
     heightDifference=this.calculateEditorHeightOnpaste();
   }
   else if(this.isPasteEvent && this.aieditorLineCount>0)
   {
    this.aieditorLineCount=this.aieditorLineCount-10;
    heightDifference=this.aieditorLineCount * 10;
    if(heightDifference<0)
    {
      heightDifference=10;
    }
   }
   else
   {
    heightDifference=10;
   }
   this.overflowfields=[];
    //for (const item of this.imagesWithFields[0].fields) {
      for (const item of this.imagesWithFields.find(m=>m.img==data.img).fields) {
      // if (item.fieldTypeName === "AITextBox") {
      //   ckeditorHeightChangeDetected = true;
      //} else
      if(!item.offsetYNextPage||item.offsetYNextPage==0)
      {
        item.offsetYNextPage=item.offsetY;
      }
       if (item.offsetY > this.ckeditorPosition) {
        if (item.fieldTypeName === "Radio" || item.fieldTypeName === "Checkbox" || item.fieldTypeName === "CheckBoxGroup") {
          
            item.fillList.forEach(cc => {
              cc.offsetY += heightDifference;
            });
            this.overflowfields.push(item);
          }
        else if(this.currentCkeditorId!=item.id) 
        {
               item.offsetY += heightDifference; // Adjust the position for controls below CKEditor
               this.overflowfields.push(item);
        }
      }
    }

    this.ckeditorInitialHeight = newHeight; // Update the stored height
  }
  this.isPasteEvent=false;
  this.aieditorLineCount=0;
  this.checkOverflowAndAdjust(data);
}
async checkOverflowAndAdjust(data:any) {
  let overflow = false;
  this.overflowfields.forEach(field => {
    if (field.fieldTypeName === "Radio" || field.fieldTypeName === "Checkbox" || field.fieldTypeName === "CheckBoxGroup") {
        field.fillList.forEach(cc => {
          if (cc.offsetY + (cc.offsetHeight==undefined?0: cc.offsetHeight) > this.pageHeight) 
              overflow = true;
        });
    }
    else
    {
     if (field.offsetY + field.offsetHeight > this.pageHeight) {
         overflow = true;
    }
  }
  });

  if (overflow) {
   await this.handleOverflow(data);
  }
}
async handleOverflow(data:any) {
  this.overflowfields.sort((a, b) => a.offsetY - b.offsetY);

  let isNewPageNeeded = false;
  let firstOverflowFieldOffsetY = 0;
  let pageOffset = 0; // This will be the offsetY of the first field on the new page
  let currentDocument= this.projectDocuments.find(k=>k.projectDocumentID==this.selectedDocumentId);
  let currentdocImages=currentDocument.images;
  let currentIMG=currentdocImages.find(m=>m.pageImageUrl==data.img);
  this.OldPage=currentIMG.pageNumber;
  if( this.currentPage==0)
  {
   this.currentPage=currentIMG.pageNumber;
  }
  let overflowfieldsForNewPage=[]
  let actualOverFlow=false;
  this.overflowfields.forEach(async field => {
     // if (field.page === this.currentPage) {
      if (field.fieldTypeName === "Radio" || field.fieldTypeName === "Checkbox" || field.fieldTypeName === "CheckBoxGroup") {
        //let isIncludeInnerField=false;
        // Step 1: Check if any element overflows
let isPageHieightgreater = field.fillList.some(cc => {
  const fieldBottom = cc.offsetY + (cc.offsetHeight == undefined ? 0 : cc.offsetHeight);
  return fieldBottom > this.pageHeight;
});

// Step 2: If there is an overflow, adjust offsetY for each element
if (isPageHieightgreater) {
  let overflowCounter = 0;
  field.fillList.forEach(cc => {
     // const fieldBottom = cc.offsetY + (cc.offsetHeight == undefined ? 0 : cc.offsetHeight);

      //if (fieldBottom > this.pageHeight) {
          if (!isNewPageNeeded) {
              // const result = await this.AddBlankPage(currentIMG);
              isNewPageNeeded = true;
              firstOverflowFieldOffsetY = cc.offsetY; // Record the offsetY of the first overflowing field
          }

          cc.offsetY = pageOffset + (cc.offsetY - firstOverflowFieldOffsetY) + ((overflowCounter + 1) * 10);
          overflowCounter++;
      //}
  });
}
        // field.fillList.forEach(cc => {
        //   const fieldBottom = cc.offsetY + (cc.offsetHeight==undefined?0:cc.offsetHeight);

        //   if (fieldBottom > this.pageHeight) {
        //       isIncludeInnerField=true;
        //       if (!isNewPageNeeded) {
        //        // const result = await this.AddBlankPage(currentIMG);
        //           isNewPageNeeded = true;
        //           firstOverflowFieldOffsetY = cc.offsetY; // Record the offsetY of the first overflowing field
        //       }
        //       actualOverFlow=true;
        //       //field.page = this.currentPage;
        //       // Calculate the new offsetY relative to the first overflowing field's original position
        //       //field.offsetYNextPage=field.offsetY
              
        //         cc.offsetY = pageOffset + (cc.offsetY - firstOverflowFieldOffsetY)+10;
        //   }
        // });
        if(isPageHieightgreater)
        {
          overflowfieldsForNewPage.push(field);
        }
    }
    else
    {
          const fieldBottom = field.offsetY + field.offsetHeight;

          if (fieldBottom > this.pageHeight) {
              if (!isNewPageNeeded) {
               // const result = await this.AddBlankPage(currentIMG);
                  isNewPageNeeded = true;
                  firstOverflowFieldOffsetY = field.offsetY; // Record the offsetY of the first overflowing field
              }
              actualOverFlow=true;
              //field.page = this.currentPage;
              // Calculate the new offsetY relative to the first overflowing field's original position
              //field.offsetYNextPage=field.offsetY
              if (field.fieldTypeName === "AITextBox") {
              field.offsetY = pageOffset + (field.offsetY - firstOverflowFieldOffsetY)+170;
              }
              else{
                field.offsetY = pageOffset + (field.offsetY - firstOverflowFieldOffsetY)+10;
              }

              overflowfieldsForNewPage.push(field);
          }
    }
     // }
  });
  let isSpaceAvailable= this.getMaxoffsetY();
  if(actualOverFlow && this.currentPage==this.OldPage)
  {
    const result = await this.AddBlankPage(currentIMG);
  }
if(overflowfieldsForNewPage.length>0 && this.currentPage>this.OldPage)
{
  // let currentIMG=currentdocImages.find(m=>m.pageImageUrl==data.img);
  // this.OldPage=currentIMG.pageNumber;
  let newDocument= this.projectDocuments.find(k=>k.projectDocumentID==this.selectedDocumentId);
  let newDocImages=newDocument.images;
  let newDocImage=newDocImages.find(m=>m.pageNumber==this.currentPage);
  let newdocImageURL=newDocImage.pageImageUrl;
  overflowfieldsForNewPage.forEach(ofnf => {
    ofnf.imgUrl=newdocImageURL;
  });
  

    
// if(this.imagesWithFields.find(m=>m.img==newdocImageURL).fields.length==0 && overflowfieldsForNewPage.length>0)
// {
//   let highestOffsetYControl1 = overflowfieldsForNewPage.reduce((prev, current) => 
//     (prev.offsetY > current.offsetY) ? prev : current);
//     overflowfieldsForNewPage.find(m=>m.id==highestOffsetYControl1.id).offsetY=10;
// }
if(this.imagesWithFields.find(m=>m.img==newdocImageURL).fields.length>0)
{
  
let imageObj = this.imagesWithFields.find(m => m.img == newdocImageURL);
  let highestOffsetYControl = imageObj.fields.reduce((prev, current) => 
  (prev.offsetY < current.offsetY) ? prev : current);
  // Find the image object with the matching URL

// Initialize a variable to keep track of the lowest offsetY
let lowestOffsetYControl = null;
let lowestOffsetYinner=null;
// Iterate over the fields of the found image object
imageObj.fields.forEach(field => {
    // Check if the field type is one of the specified types
    if (field.fieldTypeName === "Radio" || field.fieldTypeName === "Checkbox" || field.fieldTypeName === "CheckBoxGroup") {
        // Iterate over the fillList of the field
        field.fillList.forEach(fillItem => {
          let fillListinner:any;
            // Check if lowestOffsetYControl is null or fillItem has a lower offsetY
            if (!lowestOffsetYControl || fillItem.offsetY < lowestOffsetYControl.offsetY) {
              lowestOffsetYControl=field;
              lowestOffsetYinner  = fillItem; // Update the lowest offsetY control
                lowestOffsetYinner= fillItem.offsetY
            }
        });
    }
});
if(lowestOffsetYinner!=null&&lowestOffsetYinner<highestOffsetYControl.offsetY)
{
  highestOffsetYControl=lowestOffsetYControl;
}
// lowestOffsetYControl now holds the field with the lowest offsetY in the fillList of the specified types

  if(highestOffsetYControl)
  {
    let yOffsetDifference=highestOffsetYControl.offsetYNextPage- overflowfieldsForNewPage[0].offsetYNextPage;
    yOffsetDifference= Math.abs(yOffsetDifference);
    if (overflowfieldsForNewPage[0].fieldTypeName === "AITextBox") {
      yOffsetDifference+=160;
    }
    // overflowfieldsForNewPage.forEach(hoc => {
    //   hoc.offsetY+=highestOffsetYControl.offsetY;
    // });
    this.imagesWithFields.find(m=>m.img==newdocImageURL).fields.forEach(hoc => {
      if (hoc.fieldTypeName === "Radio" || hoc.fieldTypeName === "Checkbox" || hoc.fieldTypeName === "CheckBoxGroup") {
        hoc.fillList.forEach(dd => {
          dd.offsetY+=yOffsetDifference;
        });
      }
      else
        hoc.offsetY+=yOffsetDifference;
      });
  }
}
  this.imagesWithFields.find(m=>m.img==newdocImageURL).fields.push(...overflowfieldsForNewPage);
  const idArray: string[] = overflowfieldsForNewPage.map(item => item.id);
  this.imagesWithFields.find(m=>m.img==data.img).fields=this.imagesWithFields.find(m=>m.img==data.img).fields.filter(n=>!idArray.includes(n.id));
}
  // If no new page was needed and fields were moved, adjust the offsetY of the rest of the fields
  // if (isNewPageNeeded && firstOverflowFieldOffsetY !== 0) {
  //     this.overflowfields.forEach(field => {
  //         if (field.page === this.currentPage && field.offsetY >= pageOffset) {
  //             field.offsetY += firstOverflowFieldOffsetY - pageOffset;
  //         }
  //     });
  // }
}

getMaxoffsetY()
{
  let newdocImageURL="";
  if(this.imagesWithFields.length>this.OldPage && this.imagesWithFields[this.OldPage].isBlankPage==true)
   {
    newdocImageURL=this.imagesWithFields[this.OldPage].img
   
    let imageObj = this.imagesWithFields.find(m => m.img == newdocImageURL);
    let highestOffsetYControl = imageObj.fields.reduce((prev, current) => 
    (prev.offsetY > current.offsetY) ? prev : current);
    // Find the image object with the matching URL
    
    // Initialize a variable to keep track of the lowest offsetY
    let lowestOffsetYControl = null;
    let lowestOffsetYinner=null;
    // Iterate over the fields of the found image object
    imageObj.fields.forEach(field => {
  // Check if the field type is one of the specified types
  if (field.fieldTypeName === "Radio" || field.fieldTypeName === "Checkbox" || field.fieldTypeName === "CheckBoxGroup") {
      // Iterate over the fillList of the field
      field.fillList.forEach(fillItem => {
        let fillListinner:any;
          // Check if lowestOffsetYControl is null or fillItem has a lower offsetY
          if (!lowestOffsetYControl || fillItem.offsetY > lowestOffsetYControl.offsetY) {
            lowestOffsetYControl=field;
            lowestOffsetYinner  = fillItem; // Update the lowest offsetY control
              lowestOffsetYinner= fillItem.offsetY
          }
      });
  }
    });
    if(lowestOffsetYinner!=null&&lowestOffsetYinner>highestOffsetYControl.offsetY)
    {
    highestOffsetYControl=lowestOffsetYControl;
    }
   if ((this.pageHeight-highestOffsetYControl.offsetY)>=200)
   {
    this.currentPage=this.OldPage+1;
    return true;
   }
   else
   {
    this.currentPage=this.OldPage;
    return false;
   }
   }
   else
   {
    this.currentPage=this.OldPage;
    return false;
   }
}

onPaste(e:any)
{
  this.isPasteEvent=true;
}

calculateEditorHeightOnpaste() {
  // Assuming each line is approximately 20px, adjust as needed
  let lines = this.editorContent.split('\n').length;
  const lineHeight = 10; // adjust based on your styling
  lines=lines-10;
  return lines * lineHeight;
}


  adjustEditorHeight(editorInstance:any,id,data) {
      // const contentArea = editorInstance.ui.view.editable.element;
      // const newHeight = contentArea.scrollHeight;
      // editorInstance.container.setStyle('height', newHeight + 'px');
      
      //
        // Check for Mac or Windows
        const isMac = /Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.userAgent);


    // Detect paste event
     //this.isPasteEvent=false;
    // this.isPasteEvent = (editorInstance.ctrlKey && !isMac) || (editorInstance.metaKey && isMac);
     //this.isPasteEvent=true;
    if (this.isPasteEvent) {
      this.editorContent = editorInstance.editor.getData();
    }
      editorInstance= editorInstance.editor;
      this.currentCkeditorId=id;
// Access the iframe document
var iframeDocument = editorInstance.document.$;
    
// Create a style element
var styleElement = iframeDocument.createElement('style');
styleElement.type = 'text/css';

// CSS rules
var cssRules = 'body.cke_editable { overflow: hidden !important; }';

if (styleElement.styleSheet){
    // For IE
    styleElement.styleSheet.cssText = cssRules;
} else {
    // For other browsers
    styleElement.appendChild(iframeDocument.createTextNode(cssRules));
}

// Append the style element to the head of the iframe document
iframeDocument.head.appendChild(styleElement);
      //

      if (editorInstance && editorInstance.editable()) {
        // Get the CKEditor's editable content area
        const contentArea = editorInstance.editable().$;

        // Use scrollHeight to determine the height of the content
        const newHeight = contentArea.scrollHeight;
if(newHeight>150)
{
  if(this.heightArray.length==0){
    this.heightArray.push({id:this.currentCkeditorId,height:newHeight});
  }
  else if(this.heightArray[0].id==this.currentCkeditorId)
  {
    this.heightArray.push({id:this.currentCkeditorId,height:newHeight});
  }
  else if(this.heightArray[0].id!=this.currentCkeditorId)
  {
    this.heightArray=[];
    this.heightArray.push({id:this.currentCkeditorId,height:newHeight});
  }

        // Apply the new height to the editor's UI container
        editorInstance.ui.space('contents').setStyle('height', newHeight + 'px');
        
this.setupCKEditorObserver(editorInstance,data);
}
    }

  }


  onChangeText(value: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedValue = value == undefined ? '' : value;
      //this.characterlimit;
      this.cdr.detectChanges();
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }
  removeAllWhitespace(input) {
    return input
        .replace(/\s+/g, '')  // Remove all whitespace characters (spaces, new lines, tabs)
        .trim();              // Trim any leading or trailing spaces (just in case)
}

 updateArrayExpression(arr, ctrl, newValue) {
  // Check if the array is empty
  if (arr.length === 0) {
      // If empty, add the new value
      arr.push(newValue);
      return arr;
  }
  
  // Look for the index where the element ends with '=' + ctrl
  let index = arr.findIndex(item => item.endsWith(`=${ctrl}`));

  // If found, replace the value at the index
  if (index !== -1) {
      arr[index] = newValue;
  } else {
      // If not found, add the new value to the array
      arr.push(newValue);
  }

  return arr;
}

removeArrayExpression(arr, ctrl) {
  // Check if the array is empty
          // Look for the index where the element ends with '=' + ctrl
     let index = arr.findIndex(item => item.endsWith(`=${ctrl}`));
   
     // If found, replace the value at the index
     if (index !== -1) {
      arr.splice(index, 1);
     } 
  
  return arr;
}

  onChangeExpression(value: any) {
    let newValue=this.removeAllWhitespace(value);
    var data = this.ControlData;
    const oldexp=this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).expression;
    
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).expression = value == undefined ? '' : value;
      //this.characterlimit;
      this.cdr.detectChanges();
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }

    if(newValue!="")
    {
       let finalExpression=newValue+"="+this.ControlId;
       let excontrols=this.splitExpression(finalExpression);
       if(excontrols.componentsArray && excontrols.componentsArray.length>0)
          excontrols.componentsArray.forEach(elex => {
           if (elex.includes("Number") || elex.includes("Currency") || elex.includes("Dropdown")) {
           if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
             // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
            // let fexpArray=this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == elex).finalExpression;

           let foundItem = null;
            for (const image of this.imagesWithFields) {
            const foundField = image.fields.find(field => field.id == elex);
            
            // If a field was found in the current image's `fields` array
            if (foundField) {
              foundItem = {
                img: image.img,       // The parent image
                field: foundField     // The specific field object that matched
              };
              break; // Exit the loop since we found what we needed
            }
          }
         if (foundItem) {
             let fexpArray = foundItem.field?.finalExpression;
             fexpArray=this.ensureValueIsArray(fexpArray);
             fexpArray=  this.updateArrayExpression(fexpArray,this.ControlId,finalExpression);
             this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == elex).finalExpression = fexpArray;
              //this.characterlimit;
              this.cdr.detectChanges();
            }
              // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
            }
          }
        });
      }
      else
      {
        let oldexpTosend=this.removeAllWhitespace(oldexp);
        if(oldexpTosend!="")
        {
         let finalExpression=oldexpTosend+"="+this.ControlId;
         let excontrols=this.splitExpression(finalExpression);
         if(excontrols.componentsArray && excontrols.componentsArray.length>0)
          excontrols.componentsArray.forEach(elex => {
           if (elex.includes("Number")) {
           if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
             // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
            // let fexpArray=this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == elex).finalExpression;
            let foundItem = null;
            for (const image of this.imagesWithFields) {
            const foundField = image.fields.find(field => field.id == elex);
            
            // If a field was found in the current image's `fields` array
            if (foundField) {
              foundItem = {
                img: image.img,       // The parent image
                field: foundField     // The specific field object that matched
              };
              break; // Exit the loop since we found what we needed
            }
          }

          if (foundItem) {
             let fexpArray = foundItem.field?.finalExpression;
             fexpArray=this.ensureValueIsArray(fexpArray);
             fexpArray=this.removeArrayExpression(fexpArray,this.ControlId);
              this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == elex).finalExpression = fexpArray;
              this.cdr.detectChanges();
            }
             
            }
           }
         });
        }
        
      }
  }
	ensureValueIsArray(value) {
    // Check if the value is not an array
    if (!Array.isArray(value)) {
        // Change the value to an empty array
        return [];
    }
    // Return the original value if it is already an array
    return value;
}
  splitExpression(expression) {
    
    // Split the expression by '=' to separate the variable part and the rest
    let [leftSide, variableValue] = expression.split('=');
  
    // If '=' is at the extreme right or missing
    if (variableValue === undefined) {
      variableValue = null; // Set to null if no right-hand value exists
    }
  
    // Replace 'Textbox-' and 'Number-' temporarily to avoid splitting at those hyphens
    let modifiedExpression = leftSide
      .replace(/Textbox-/g, 'TextboxPLACEHOLDER')
      .replace(/Number-/g, 'NumberPLACEHOLDER')
      .replace(/Currency-/g, 'CurrencyPLACEHOLDER')
      .replace(/Dropdown-/g, 'DropdownPLACEHOLDER');
  
    // Now split by +, *, %, and - without affecting the Textbox- or Number- parts
    let components = modifiedExpression.split(/[+\*\/\-]/);
  
    // Restore 'Textbox-' and 'Number-' in the split components
    components = components.map(component => 
      component.replace(/TextboxPLACEHOLDER/g, 'Textbox-').replace(/NumberPLACEHOLDER/g, 'Number-').replace(/CurrencyPLACEHOLDER/g, 'Currency-').replace(/DropdownPLACEHOLDER/g, 'Dropdown-')
    );
  
    // Return the results as an object
    return {
      componentsArray: components,
      variableValue: variableValue
    };
  }
  removeDollarAndComma(input) {
    return input.replace(/\$|,/g, '');
  }
  removeEqualsAndAfter(input) {
    return input.split('=')[0]; // Splits the string at '=' and takes the first part
  }
  getSymbolNextToNumber(expression, targetNumber) {
    const regex = new RegExp(`${targetNumber}(.)`);  // Create a regex pattern that finds the target number and captures the next character
    const match = expression.match(regex);  // Execute the regex on the expression
    
    if (match && match[1]) {
        return match[1];  // Return the next character after the number
    }
    return null;  // If no match is found, return null
}
  evaluateExpression(expression, exResult,data) {
    // Reconstruct the mathematical expression using the control values fetched from the DOM
    //let data = this.ControlData;
    let reconstructedExpression = expression;
    let componentsArray=exResult.componentsArray;
    // Replace each control name in the expression with its corresponding value
    componentsArray.forEach(component => {
      if (component.includes("Number") || component.includes("Currency") || component.includes("Dropdown")) {
      // Fetch the element by ID from the DOM
      let element:any;
      element = document.getElementById(component);
      let value;
  
      if (element && element.value !== "" && element.value !== undefined) {
        value = this.removeDollarAndComma(element.value);
      }
      // If element exists and has a valid value, use its value; otherwise, set a default value
      if (value && value !== "" && value !== undefined) {
        //value = this.removeDollarAndComma(element.value);
      } else {
        // Determine the default value based on the operation before or after the component
        // Find the position of the component in the expression
        const index = reconstructedExpression.indexOf(component);
  
        // Check the operator before the component (if available)
        const prevChar = index > 0 ? reconstructedExpression[index - 1] : (index==0?this.getSymbolNextToNumber(reconstructedExpression,component):null);
  
        if (prevChar === '*') {
          value = 0;  // Default for multiplication //1;
        } else if (prevChar === '+' || prevChar === '-' || prevChar === '%') {
          value = 0;  // Default for addition, subtraction, and modulus
        } else {
          value = 0;  // General default value
        }
  
        console.warn(`Element with id '${component}' not found or has an invalid value. Using default value: ${value}`);
      }
  
      // Replace the control name with its determined value
      reconstructedExpression = reconstructedExpression.replace(component, value);
      }
    });
  
    // Use eval() to calculate the result (caution: eval can be dangerous with untrusted input)
    let result;
    try {
      reconstructedExpression=this.removeEqualsAndAfter(reconstructedExpression);
      result = eval(reconstructedExpression);
      if(result)
         result = Number(result.toFixed(2));
      if (isNaN(result)) {
          result=0;
      }
    } catch (e) {
      console.error('Error evaluating expression:', e);
      result = null;
    }
  
    //document.getElementById(exResult.variableValue).value=result;

    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {

      //
       let foundItem = null;
            for (const image of this.imagesWithFields) {
            const foundField = image.fields.find(field => field.id == exResult.variableValue);
            
            // If a field was found in the current image's `fields` array
            if (foundField) {
              foundItem = {
                img: image.img,       // The parent image
                field: foundField     // The specific field object that matched
              };
              break; // Exit the loop since we found what we needed
            }
          }

      //
  if(foundItem)
  {
      // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      let isDollar=this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == exResult.variableValue).isDollar;
       this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == exResult.variableValue).selectedValue = result == undefined ? '' : ((isDollar==undefined || isDollar==null || isDollar=="" || isDollar==false)? result: this.formatMoney(result));
       //this.characterlimit;
       this.cdr.detectChanges();
       
       //********* */
       //  let finalExpression=this.removeAllWhitespace(finalExpressionvalue);
      //  if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="")
      //  {
      //    let excontrols=this.splitExpression(finalExpression);
      //    this.evaluateExpression(finalExpression, excontrols,data);
      //  }
      if(this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == exResult.variableValue).finalExpression=="")
      {
        this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == exResult.variableValue).finalExpression=[];
      }
      let finalExpression = this.imagesWithFields.find(x => x.img == foundItem.img).fields.find(m => m.id == exResult.variableValue).finalExpression;
      
       finalExpression=this.ensureValueIsArray(finalExpression);
       if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="" && finalExpression.length>0)
        {
          finalExpression.forEach(fex => {
            let cleanedfex=this.removeAllWhitespace(fex);
          let excontrols=this.splitExpression(cleanedfex);
          this.evaluateExpression(cleanedfex, excontrols,data);
          });
        }
       //********** */
       // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  }
    
    }
  }
  
 formatMoney(amount) {
  // Convert the input to a number
  const num = parseFloat(amount);
  
  // Check if the number is valid
  if (isNaN(num)) {
    return null; // or you can return an error message or a default value
  }
  
  // Split the number into integer and decimal parts
  const parts = num.toFixed(2).split('.');
  const integerPart = parts[0];
  const decimalPart = parts[1];
  
  // Format the integer part with commas as thousands separators
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // Return formatted with dollar sign and exactly two decimal places
  return `$${formattedInteger}.${decimalPart}`;
}

  // // Example usage 2 (when `=` is at the end)
  // let expression2 = "Textbox-1724835083056*Textbox-1727249371790+sfsdfds-Number-12345%Number-6789=dfsdfsdfsdf";
  // let result2 = splitExpression(expression2);  
  
  onChangeTextAIAnswer(value: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
     // this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedValue = value == undefined ? '' : value;
      //this.characterlimit;
      this.cdr.detectChanges();
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeTextAIQestion(value: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).aiQuestion = value == undefined ? '' : value;
      //this.characterlimit;
      this.cdr.detectChanges();
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeTextButton(value: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).buttonName = value == undefined ? '' : value;
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeUrlButton(value: any) {
    var data = this.ControlData;
    var url = this.addAnchorsToText(value);
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).buttonURL = url == undefined ? '' : url;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  insertIntoString(str: string, pos: number, fragment: string) {
    return str.slice(0, pos) + fragment + str.slice(pos + 1, str.length);
  }

  addAnchorsToText(text) {
    // https://www.regextester.com/94502
    const regexp = /((?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+%,;=.]+)/igm;
    const map = {};
    return text.replace(regexp, (_, match, __, pos) => {
      // This map helps us to keep a count of the duplicate matches.
      if (map[match] !== undefined) map[match]++;
      else map[match] = 0;

      // These next few lines handle duplicates. We want to handle cases like this: 
      // <a href="myurl.com">foo</a> bar baz myurl.com.
      let testString = text.replace(new RegExp(escapeRegExp(match), 'ig'), '$');
      let newPos = pos - map[match] * (match.length - 1);
      testString = this.insertIntoString(testString, newPos, match);

      // Detect if the url was found here -> <a href="#here#">
      const hrefRegex = new RegExp(`<a[^>]*href="${escapeRegExp(match)}"[^>]*>[^<]*<\/a>`, 'ig');
      const isHref = hrefRegex.test(testString);

      // Detect if the url was found here -> <a href="...">#here#</a>
      const anchoredRegex = new RegExp(`<a[^>]*>[^<]*${escapeRegExp(match)}[^<]*<\/a>`, 'ig');
      const isAnchored = anchoredRegex.test(testString);


      // If the url is found in href or anchor, then do nothing with it, it needs no further treatment.
      if (isAnchored || isHref) return match;
      const hasProtocol = /^http[s]?:\/\/.*$/igm.test(match);
      //var data = "http://'}${match}";
      return `${hasProtocol ? '' : 'http://'}${match}`;
    });
    function escapeRegExp(text) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }
  }

  onTableChange(e: any, data: any, id) {
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.find(m => m.id == e.target.id).val = e.target.value == undefined ? '' : e.target.value;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  OnChangeRadio($event: any, rb: any, id: any, data: any, childCtrlID: any) {
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      if ($event.target.checked) {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues = [];
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.push(childCtrlID);
      } else {
        if (this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.find((s) => s == childCtrlID)) {
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues =
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
  }

  // OnChangeCheckBox($event: any, chk: any, id: any, data: any, childCtrlID: any) {
  //   if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
  //     this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
  //     if ($event.target.checked && !$event.shiftKey) {
  //       this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.push(childCtrlID);
  //       this.imagesWithFields = this.imagesWithFields;
  //     } else {
  //       if (
  //         this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.find((s) => s == childCtrlID)
  //       ) {
  //         this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues =
  //           this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.filter((s) => s !== childCtrlID)
  //       }
  //     }

  //   }
  //   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  // }

  // OnChangeCheckBoxGroup($event: any, chk: any, id: any, data: any, childCtrlID: any) {
  //   if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
  //     if ($event.target.checked && !$event.shiftKey) {
  //       this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
  //       this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.push(childCtrlID);

  //       this.imagesWithFields = this.imagesWithFields;
  //     } else {
  //       if (
  //         this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.find((s) => s == childCtrlID)
  //       ) {
  //         this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues =
  //           this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.filter((s) => s !== childCtrlID)
  //       }
  //     }
  //     if ($event.target.checked && $event.shiftKey) {
  //       (document.getElementById(id + childCtrlID) as HTMLInputElement).checked = false;
  //     }
  //     else if ($event.shiftKey) {
  //       (document.getElementById(id + childCtrlID) as HTMLInputElement).checked = true;
  //     }
  //   }
  //   // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  // }

  // setDdlValue(e: any, data: any, id) {
  //   if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
  //     this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
  //     this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = e.value;
  //     this.imagesWithFields = this.imagesWithFields;
  //     // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
  //   }
  // }

  OnChangeCheckBox($event: any, chk: any, field: any, data: any, childCtrlID: any) {
    if (this.selectedParticipant != undefined) {
      this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
    }
    let selectedCtrlFolderID = field.folderID;
    let fieldParticipantID = field.selectedParticipant?.groupRelationParticipantMappingID;
    fieldParticipantID = (fieldParticipantID == undefined ? 0 : fieldParticipantID);

    let contactFolder: any = []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined) {
        if ($event.target.checked) {
          this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);
          this.particiantJsonListAutoFill = this.particiantJsonListAutoFill;
        } else {
          if (this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.find((s) => s == childCtrlID)) {
            this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
          }
        }
      }

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                if ($event.target.checked) {
                  fe.chkSelectedValues.push(childCtrlID);
                } else {
                  fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                if ($event.target.checked) {
                  fe.chkSelectedValues.push(childCtrlID);
                } else {
                  fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                }
              }
            });
          });
        }
      });
    }
    let coretFolder: any = []; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined) {
        if ($event.target.checked) {
          this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);
        } else {
          if (this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.find((s) => s == childCtrlID)) {
            this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
              this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
          }
        }
      }
      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                if ($event.target.checked) {
                  fe.chkSelectedValues.push(childCtrlID);
                } else {
                  fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                if ($event.target.checked) {
                  fe.chkSelectedValues.push(childCtrlID);
                } else {
                  fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                }
              }
            });
          });
        }
      });
    }

    let comFolder: any = [];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Company));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined) {
        if ($event.target.checked) {
          this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);
        } else {
          if (this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.find((s) => s == childCtrlID)) {
            this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
              this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
          }
        }
      }
      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                if ($event.target.checked) {
                  fe.chkSelectedValues.push(childCtrlID);
                } else {
                  fe.chkSelectedValues =
                    fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                if ($event.target.checked) {
                  fe.chkSelectedValues.push(childCtrlID);
                } else {
                  fe.chkSelectedValues =
                    fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                }
              }
            });
          });
        }
      });
    }

    if (fieldParticipantID == this.groupRelationParticipantId && ((selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0))) {
      if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && $event.target.checked)
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID == 0) {
      //this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
      if ($event.target.checked) {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);
      } else {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
      }
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID > 0) {
      if ($event.target.checked) {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);
      } else {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
      }
    }
  }

  OnChangeCheckBoxGroup($event: any, chk: any, id: any, data: any, childCtrlID: any) {
    if (this.selectedParticipant != undefined) {
      this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
    }
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      if ($event.target.checked) {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id.id).chkSelectedValues.push(childCtrlID);
        this.imagesWithFields = this.imagesWithFields;
      } else {
        if (this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id.id).chkSelectedValues.find((s) => s == childCtrlID)) {
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id.id).chkSelectedValues =
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id.id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
    if (this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id.id).selectedParticipant?.groupRelationParticipantMappingID == 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
  }

  setDdlValue(e: any, data: any, field) {
    if (Array.isArray(e.value)) {
      // e.value=e.value.join(",");
    }

    let selectedCtrlFolderID = field.folderID;
    field.selectedValue = e.value;
    let fieldParticipantID = field.selectedParticipant?.groupRelationParticipantMappingID;
    fieldParticipantID = (fieldParticipantID == undefined ? 0 : fieldParticipantID);

    let contactFolder: any = []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined)
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;

      //let field =  this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id);

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  if(field.selectedValue!='State')
                     fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  if(field.selectedValue!='State')
                     fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
        }
      });
    }

    let coretFolder: any = []; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined)
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;

      //let field =  this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id);
      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  if(field.selectedValue!='State')
                     fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {

                   if(field.selectedValue!='State')
                     fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
        }
      });
    }

    let comFolder: any = [];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Company));
    if (fieldParticipantID == this.groupRelationParticipantId && selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if (this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id) !== undefined)
        this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;

      //let field =  this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id);

      this.participantArray.forEach(ml => {
        if (this.selectedDocumentId !== ml.documentId) {
          let jsonelement = JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                    if(field.selectedValue!='State')
                     fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
        else {
          this.imagesWithFields.forEach(element => {
            element.fields.forEach(fe => {
              if (fe.fieldName == field.fieldName && fe.folderID == field.folderID && this.groupRelationParticipantId == fe.selectedParticipant?.groupRelationParticipantMappingID) {
                fe.selectedValue = field.selectedValue;
                if (field.selectedValue != '' && field.selectedValue != undefined) {
                  if(field.selectedValue!='State')
                     fe.isValueFixedFormDesignPage = true;
                }
                else {
                  fe.isValueFixedFormDesignPage = false;
                }
              }
            });
          });
        }
      });
    }
    if (e.value != '' && value != undefined && e.value!='State') {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).isValueFixedFormDesignPage = true;
    }
    else {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).isValueFixedFormDesignPage = false;
    }
    if (fieldParticipantID == this.groupRelationParticipantId && ((selectedCtrlFolderID == contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID == comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0))) {
      if (this.imagesWithFields.find(x => x.img == data.img) !== undefined)
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;

    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID == 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID = this.groupRelationParticipantId;
    }
    else if (this.imagesWithFields.find(x => x.img == data.img) !== undefined && this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID > 0) {
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
    }

    
let finalExpression = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == field.id).finalExpression;

finalExpression=this.ensureValueIsArray(finalExpression);
if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="" && finalExpression.length>0)
 {
   finalExpression.forEach(fex => {
     let cleanedfex=this.removeAllWhitespace(fex);
   let excontrols=this.splitExpression(cleanedfex);
   this.evaluateExpression(cleanedfex, excontrols,data);
   });
 }
  }

  AddControlRadioButon(id, data) {
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      let fillList = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.push({
        id: "ctrl-" + (fillList.length + 1),
        val: "",
        offsetX: fillList[fillList.length - 1].offsetX,
        offsetY: fillList[fillList.length - 1].offsetY + 37
      });
      this.imagesWithFields = this.imagesWithFields;
      this.radioButtonGroupFieldArray = fillList;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  ifChkChecked(id, data, childCtrlId) {
    if (id == 'Check Box43') {
      let sdfsd = 0;
    }
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
      return selectedValue.includes(childCtrlId);
    }
    return false;
  }

  ifRadioChecked(id, data, childCtrlId) {
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues;
      return selectedValue.includes(childCtrlId);
    }
    return false;
  }

  AddControlCheckBoxGroup(id, data) {
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      let fillList = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.push({
        id: "ctrl-" + (fillList.length + 1),
        val: "",
        offsetX: fillList[fillList.length - 1].offsetX,
        offsetY: fillList[fillList.length - 1].offsetY + 37
      });
      this.imagesWithFields = this.imagesWithFields;
      this.checkboxGroupFieldArray = fillList;
    }
  }

  onClickonImage(eventComing: any, list: any) {
    if (this.waitPointer) {
      let eventCurrent = { dropEffect: "copy", data: this.selectedFieldToDrop, event: { offsetX: eventComing.offsetX, offsetY: eventComing.offsetY } }
      this.onDrop(eventCurrent, list);
      this.waitPointer = false;
    }
  }

  onDrop(event: any, list: any) {

    this.controlAlignArray = [];
    this.rotationByDegree = 0;
    if (list && (event.dropEffect === "copy" || event.dropEffect === "move")) {
    
      var x = event.event.offsetX;
      var y = event.event.offsetY;
      this.xposition = x;
      this.yposition = y;

      this.characterlimit = 100;
      this.fontsize = 14;
      this.fontfamily = 'Arial';
      event.data.name = event.data.fieldTypeName + '-' + new Date().getTime();
      let fillListArray: any = [];
      let fillList: any = [];
      this.buttonText = "Button";
      this.acceptOrdeclineText = 'Approve';
      this.buttonURL = "";
      this.acceptchecked = true;
      this.declinechecked = false;
      var textaligns: string = "left";
      var addressGrp: string = "";
      var isRequired=false;


      if (event.data.fieldTypeName == 'Textarea') {
        this.characterlimit = 250;
      }
      else {
        this.characterlimit = 100;
      }

      if (event.data.fieldTypeName == 'Signature' || event.data.fieldTypeName == 'Initials' 
       || event.data.fieldTypeName == 'Date') {       
        isRequired = true;
      }

      
      this.OpentoolDetail(event.data.fieldTypeName);

      if (event.data.fieldTypeName == 'MultiSelect' || event.data.fieldTypeName == 'Dropdown' ||
        event.data.fieldTypeName == 'Checkbox' || event.data.fieldTypeName == 'Radio' ||
        event.data.fieldTypeName == 'BulletList' || event.data.fieldTypeName == 'CheckBoxGroup' ||
        event.data.fieldTypeName == 'File' || event.data.fieldTypeName == 'Image' ||
        event.data.fieldTypeName == 'Date' || event.data.fieldTypeName == 'Currency') {

        let drpValue = event.data.defaultValue.replace(/,\s*$/, "");
        fillListArray = drpValue.split(',');

        if (event.data.fieldTypeName == 'BulletList') {
          this.bulletFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.bulletFieldArray.push(copyModel);
          });
          this.offsetWidth = 60;
          this.offsetHeight = 35;
        }

        if (event.data.fieldTypeName == 'Dropdown') {
          if (event.data.fieldID > 0) {
            this.dropdownddisabled = true;
          } else {
            this.dropdownddisabled = false;
          }
          this.dropdownFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.dropdownFieldArray.push(copyModel);
          });
          this.offsetWidth = 115;
          this.offsetHeight = 28;
        }

        if (event.data.fieldTypeName == 'Checkbox') {
          if (event.data.fieldID > 0) {
            this.checkboxdisabled = true;
          } else {
            this.checkboxdisabled = false;
          }
          this.checkboxFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.checkboxFieldArray.push(copyModel);
          });
          this.offsetWidth = 15;
          this.offsetHeight = 15;
        }

        if (event.data.fieldTypeName == 'Radio') {

          this.offsetWidth = 15;
          this.offsetHeight = 15;
        }

        for (let index = 0; index < fillListArray.length; index++) {
          var elementt = fillListArray[index];
          if (elementt == "''") {
            elementt = "";
          }
          if (index !== 0)
            y = y + 37;
          fillList.push({
            id: 'ctrl-' + index,
            val: elementt,
            offsetX: x,
            offsetY: y
          });
        }
      }

      if (event.data.fieldTypeName == 'Table') {
        this.tblid = undefined;
        this.tblrowsnumber = 2;
        this.tblclmnumber = 2;
        this.GettableWithFields(2, 2);
        this.offsetWidth = 375;
        this.offsetHeight = 60;

        for (let r = 0; r < this.rows.length; r++) {
          for (let c = 0; c < this.column.length; c++) {
            fillList.push({
              val: '',
              id: 'txt-' + (r + 1) + '' + (c + 1)
            });
          }
        }
      }

      if (event.data.fieldTypeName == "Textbox" || event.data.fieldTypeName == "Number"
        || event.data.fieldTypeName == "Single-Line" || event.data.fieldTypeName == "Currency" ||
        event.data.fieldTypeName == "URL") {
        this.offsetWidth = 150;
        this.offsetHeight = 30;
      }

      if (event.data.fieldName == 'Address' || event.data.fieldTypeName == 'Address') {
        this.filledJsonForCity(event);
        this.filledJsonForState(event);
        this.filledJsonForZip(event);
      }

      if (event.data.fieldTypeName == 'Textarea') {
        this.offsetWidth = 170;
        this.offsetHeight = 100;

      }

      if (event.data.fieldTypeName == 'StrikeThrough' || event.data.fieldTypeName == 'StraightLine') {
        this.offsetWidth = 60;
        this.offsetHeight = 35;
      }

      if (event.data.fieldTypeName == 'measure') {
        this.offsetWidth = 40;
        this.offsetHeight = 40;
      }

      if (event.data.fieldTypeName == 'WhiteOut' || event.data.fieldTypeName == 'HighLight') {
        this.offsetWidth = 60;
        this.offsetHeight = 35;
      }

      if (event.data.fieldTypeName == 'Draw') {
        this.offsetWidth = 80;
        this.offsetHeight = 55;
      }

      if (event.data.fieldTypeName == 'Signature') {
        this.offsetWidth = 135;
        this.offsetHeight = 45;
        isRequired = true;
      }

      if (event.data.fieldTypeName == 'Initials') {
        this.offsetWidth = 45;
        this.offsetHeight = 45;
        isRequired = true;
      }
      if (event.data.fieldTypeName == 'Date'){
        isRequired = true;
      }

      if (event.data.fieldTypeName == 'ApproveOrDecline' || event.data.fieldTypeName == 'Button') {
        this.offsetWidth = 75;
        this.offsetHeight = 35;
        textaligns = "Center";
      }

      if (event.data.fieldTypeName == 'Date' || event.data.fieldTypeName == 'Time') {
        this.offsetWidth = 170;
        this.offsetHeight = 30;
        if (event.data.fieldTypeName == 'Date') {
          if (event.data.fieldName == "" || event.data.fieldName == undefined || event.data.fieldName == null) {
            event.data.fieldName = "Select Date";
          }
        }

        if (event.data.fieldTypeName == 'Time') {
          if (event.data.fieldName == "" || event.data.fieldName == undefined || event.data.fieldName == null) {
            event.data.fieldName = "Select Time";
          }
        }
      }

      if (event.data.fieldTypeName == 'Location') {
        this.offsetWidth = 90;
        this.offsetHeight = 50;
      }

      if (event.data.fieldTypeName == 'File' || event.data.fieldTypeName == 'Image') {
        this.offsetWidth = 100;
        this.offsetHeight = 60;
      }
      if (event.data.fieldTypeName == 'Image') {
        this.offsetWidth = 100;
        this.offsetHeight = 35;
      }
      if (event.data.fieldTypeName == 'MultiSelect') {
        this.offsetWidth = 115;
        this.offsetHeight = 28;
      }
      this.editFieldname = event.data.fieldName;
      this.selectedFolderID = event.data.folderID;

       if (event.data.fieldName == 'Address' || event.data.fieldTypeName == 'Address') {

        this.offsetWidth = 337;
         this.offsetHeight = 30;
       }
      

      let fieldJson = {
        "childFieldType": 0,
        "isEditable": false,
        "id": event.data.name,
        "finalExpression":[],
        "isDollar":false,
        "expression":"",
        "isShowChkLabel":false,
        "isFieldNameChanged": false,
        "fieldID": event.data.fieldID,
        "fieldName": event.data.fieldName,
        "folderID": event.data.folderID,
        "folderName": event.data.folderName,
        "subFolderName": event.data.subFolderName,
        "fieldTypeID": event.data.fieldTypeID,
        "fieldTypeName": event.data.fieldTypeName,
        "placeholder": event.data.placeholder,
        "defaultValue": event.data.defaultValue,
        "fillList": fillList,
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": isRequired,
        "readonly": false,
        "charLimit": this.characterlimit,
        "fontSize": "14px",
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": "Arial",
        "offsetX": event.event.offsetX,
        "offsetY": event.event.offsetY,
        "height": 0,
        "width": 0,
        "Imageheight": "100px",
        "Imagewidth": "100px",
        "textalign": textaligns,//"left",       
        "chkSelectedValues": [],
        "rbSelectedValues": ['ctrl-0'],
        "fieldNames": event.data.fieldNames,
        "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": this.colorselected,
        "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": this.selectedParticipant,
        "backgroundColor": "",
        "buttonName": "Button",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": this.rotationByDegree,
        "ShowtoolDetail": true,
        "offsetWidth": this.offsetWidth,
        "offsetHeight": this.offsetHeight,
        "showRequiredControls": false,
        "AddressGroup": event.data.name,
        "penColor": "#000000f2",
        "coreContactCompanyType": this.coreContactCompanyType,
        "aiFieldArray":[]
        // "participantEmailId":this.participantEmailId
      }

      if (event.data.fieldTypeName == 'Image') {
        fieldJson.Imageheight = '65px';
      }

      if (event.data.fieldTypeName == "WhiteOut") {
        fieldJson.colorCodeAlpha = this.hexToRGBA("#FFFFFF", 1);
      }


      if (event.data.fieldTypeName == 'Radio') {
        this.radioButtonGroupFieldArray = fieldJson.fillList;
      }

      if (event.data.fieldTypeName == "HighLight") {
        fieldJson.colorCodeAlpha = this.highLightColor;
        fieldJson.backgroundColor = this.highLightColor;
      }

      if (event.data.fieldTypeName == 'CheckBoxGroup') {
        if (event.data.fieldID > 0) {
          this.checkboxdisabled = true;
        } else {
          this.checkboxdisabled = false;
        }
        this.checkboxGroupFieldArray = [];
        this.checkboxGroupFieldArray = fillList;
      }

      if (event.data.fieldTypeName == 'Draw') {
        this.brushColor = "";
      }

      if (event.data.fieldTypeName == 'Table') {
        this.tblid = event.data.name;
      }

      if (event.dropEffect === "copy")
        event.data.offsetX = x;
      event.data.offsetY = y;
      let index = event.index;
      if (typeof index === "undefined") {
        index = list.length;
      }
      this.imagesWithFields.forEach(ctr => {
        ctr.fields.filter(v => v.ShowtoolDetail = false);
      });

      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));

      if (this.imagesWithFields.find(x => x.img == list.img)) {
        this.imagesWithFields.find(x => x.img == list.img).fields.push(fieldJson);
        if (event.data.fieldName == 'Address' || event.data.fieldTypeName == 'Address') {
          this.imagesWithFields.find(x => x.img == list.img).fields.push(this.fieldJsonForCity);
          this.imagesWithFields.find(x => x.img == list.img).fields.push(this.fieldJsonForState);
          this.imagesWithFields.find(x => x.img == list.img).fields.push(this.fieldJsonForZip);
        }
        this.imagesWithFields = this.imagesWithFields;
      }

      this.text = "";
      this.ControlId = event.data.name;
      this.expression="";
      this.isDollar=false;
      this.ControlData = list;
      this.isRequired = false;
      this.readonly = false;
      this.textColor = "";
      this.fontstyle = "";
      this.textdecoration = "";
      this.fontweight = "";
      this.textalign = "";
      this.brushColor = "";

      this.xx = x;
      this.yy = y;

      if (!this.controlAlignArray.find(m => m.id == event.data.name)) {

        this.controlAlignArray.push({
          fieldTypeName: event.data.fieldTypeName,
          img: list.img,
          id: event.data.name
        });
      }

      if (event.data.fieldTypeName == 'Signature' || event.data.fieldTypeName == 'Initials' 
       || event.data.fieldTypeName == 'Date') {       
        this.isRequired = true;
      }
      //  sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  fieldJsonForCity: any = [] = [];
  fieldJsonForState: any = [] = [];
  fieldJsonForZip: any = [] = [];

  filledJsonForCity(event) {
    let fillList: any = [];
    var textaligns: string = "left";
    this.fieldJsonForCity = [];

    this.offsetWidth = 150;
    this.offsetHeight = 30;


    this.fieldJsonForCity = {
      "childFieldType": 3,
      "isEditable": false,
      "id": 'City' + '-' + new Date().getTime(),//event.data.name,
      "fieldID": event.data.fieldID,
      "fieldName": 'City',//event.data.fieldName,
      "folderID": event.data.folderID,
      "folderName": event.data.folderName,
      "subFolderName": event.data.subFolderName,
      "fieldTypeID": event.data.fieldTypeID,
      "fieldTypeName": "City",//event.data.fieldTypeName,
      "placeholder": "City",
      "defaultValue": event.data.defaultValue,
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "readonly": false,
      "charLimit": "100",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": event.event.offsetX,
      "offsetY": event.event.offsetY + 38,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": event.data.fieldNames,
      "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": this.colorselected,
      "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": this.selectedParticipant,
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": true,
      "offsetWidth": this.offsetWidth,
      "offsetHeight": this.offsetHeight,
      "showRequiredControls": false,
      "AddressGroup": event.data.name,
      "coreContactCompanyType": this.coreContactCompanyType,
    }
  }

  filledJsonForState(event) {
    let fillList: any = [];
    var textaligns: string = "left";
    this.fieldJsonForState = [];

    this.offsetWidth = 150;
    this.offsetHeight = 30;
    this.fieldJsonForState = {
      "childFieldType": 2,
      "isEditable": false,
      "id": 'State' + '-' + new Date().getTime(),//event.data.name,
      "fieldID": event.data.fieldID,
      "fieldName": 'State',//event.data.fieldName,
      "folderID": event.data.folderID,
      "folderName": event.data.folderName,
      "subFolderName": event.data.subFolderName,
      "fieldTypeID": event.data.fieldTypeID,
      "fieldTypeName": "State",//event.data.fieldTypeName,
      "placeholder": "State",
      "defaultValue": event.data.defaultValue,
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "readonly": false,
      "charLimit": "100",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": event.event.offsetX + 152,
      "offsetY": event.event.offsetY + 38,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": event.data.fieldNames,
      "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": this.colorselected,
      "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": this.selectedParticipant,
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": true,
      "offsetWidth": this.offsetWidth,
      "offsetHeight": this.offsetHeight,
      "showRequiredControls": false,
      "AddressGroup": event.data.name,
      "coreContactCompanyType": this.coreContactCompanyType,
    }
  }

  filledJsonForZip(event) {
    let fillList: any = [];
    var textaligns: string = "left";
    this.fieldJsonForZip = [];

    this.offsetWidth = 150;
    this.offsetHeight = 30;

    this.fieldJsonForZip = {
      "childFieldType": 4,
      "isEditable": false,
      "id": 'Zip' + '-' + new Date().getTime(),//event.data.name,
      "fieldID": event.data.fieldID,
      "fieldName": 'Zip',//event.data.fieldName,
      "folderID": event.data.folderID,
      "folderName": event.data.folderName,
      "subFolderName": event.data.subFolderName,
      "fieldTypeID": event.data.fieldTypeID,
      "fieldTypeName": "Zip",//event.data.fieldTypeName,
      "placeholder": "Zip Code",
      "defaultValue": event.data.defaultValue,
      "fillList": fillList,
      "FileData": [],
      "ImageData": [],
      "rows": this.rows,
      "column": this.column,
      "selectedValue": '',
      "isRequired": false,
      "readonly": false,
      "charLimit": "100",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle": "",
      "fontweight": "",
      "textdecoration": "",
      "fontColor": "",
      "fontfamily": "Arial",
      "offsetX": event.event.offsetX + 187,
      "offsetY": event.event.offsetY + 38,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign": textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": ['ctrl-0'],
      "fieldNames": event.data.fieldNames,
      "buttonText": event.data.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
      "signatureBase64": "",
      "signatureText": '',
      "drawBase64": "",
      "colorCode": this.colorselected,
      "colorCodeAlpha": event.data.fieldTypeName == "StrikeThrough" ? this.hexToRGBA(this.selectedColorCode, 0.3) : this.colorselectedAlpha,
      'signInitialFontFamily': '',
      'Lat': '',
      'Long': '',
      "selectedParticipant": this.selectedParticipant,
      "backgroundColor": "",
      "buttonName": "Button",
      "buttonURL": "",
      "brushColor": undefined,
      "rotation": this.rotationByDegree,
      "ShowtoolDetail": true,
      "offsetWidth": this.offsetWidth,
      "offsetHeight": this.offsetHeight,
      "showRequiredControls": false,
      "AddressGroup": event.data.name,
      "coreContactCompanyType": this.coreContactCompanyType,
    }
  }


  cityselected(event: MatAutocompleteSelectedEvent, data: any, id) {
    var value = event.option.value;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields = this.imagesWithFields;

      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      this.text = value;
    }
  }


  zipselected(event: MatAutocompleteSelectedEvent, data: any, id) {
    var value = event.option.value;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      this.text = value;
    }
  }

  replacecount: any = 0;
  replaceIconHasClass: any = false;
  isClickReplaceEnabled: any;

  hideTableAndBulletList(event: any, isOn: any) {
    if (!isOn) {
      document.getElementById("chkReplace").classList.remove('cdk-focused');
      document.getElementById("chkReplace").classList.remove('cdk-mouse-focused');
      this.replaceIconHasClass = false;
    }
    else {
      this.replaceIconHasClass = true;
      this.replacecount++;
      document.getElementById("chkReplace").classList.add('cdk-focused')
      document.getElementById("chkReplace").classList.add('cdk-mouse-focused')
    }
    this.controlAlignArray = [];
    if (document.getElementById('format_list_bulletedleftpanel') != null) {
      if (event == false) {
        (document.getElementById('format_list_bulletedleftpanel') as HTMLInputElement).style.display = 'none';
        (document.getElementById('table_chartleftpanel') as HTMLInputElement).style.display = 'none';
        this.isClickReplaceEnabled = true;
      }
      else {
        (document.getElementById('format_list_bulletedleftpanel') as HTMLInputElement).style.removeProperty('display');
        (document.getElementById('table_chartleftpanel') as HTMLInputElement).style.removeProperty('display');
        this.isClickReplaceEnabled = false;
      }
    }
    else {
      if (event == false) {
        this.isClickReplaceEnabled = true;
      }
      else {
        this.isClickReplaceEnabled = false;
      }
    }
  }

  putControlForReplcae(data, item) {
    //this.onclickMenu(this.selectedParticipant?.colourCode,this.selectedParticipant);  
    if (this.isClickReplaceEnabled == true) {
      document.getElementById("chkReplace").classList.add('cdk-focused');
      document.getElementById("chkReplace").classList.add('cdk-mouse-focused');
      if (!this.ControlForReplcaArray.find(m => m.item.id == item.id))
        this.ControlForReplcaArray.push({ data: data, item: item });
      else {
        this.ControlForReplcaArray = this.ControlForReplcaArray.filter(m => m.item.id !== item.id);
        this.ControlForReplcaArray.push({ data: data, item: item });
      }
    }
  }

  replaceControl(event: any) {
    if (!this.isClickReplaceEnabled) {
      this.selectedFieldToDrop = event;
      this.waitPointer = true;
    }
    if (this.replaceIconHasClass && this.isClickReplaceEnabled) {
      document.getElementById("chkReplace").classList.remove('cdk-focused');
      document.getElementById("chkReplace").classList.remove('cdk-mouse-focused');
      this.replaceIconHasClass = false;
    }
    else if (this.isClickReplaceEnabled) {
      this.replaceIconHasClass = true;
      this.replacecount++;
      document.getElementById("chkReplace").classList.add('cdk-focused')
      document.getElementById("chkReplace").classList.add('cdk-mouse-focused')
    }
    this.controlAlignArray = [];
    this.rotationByDegree = 0;
    this.ControlForReplcaArray.forEach(element => {
      let list: any = element.data;
      this.imagesWithFields.find(x => x.img == list.img).fields =
        this.imagesWithFields.find(x => x.img == list.img).fields.filter(m => m.id !== element.item.id);
      var x = element.item.offsetX;
      var y = element.item.offsetY;
      if (element.item.fieldTypeName == 'Checkbox' || element.item.fieldTypeName == 'CheckBoxGroup' || element.item.fieldTypeName == 'Radio') {
        x = element.item.fillList[0].offsetX
        y = element.item.fillList[0].offsetY
      }
      this.xposition = x;
      this.yposition = y;
      if (event.fieldTypeName == 'Textarea') {
        this.characterlimit = 250;
      }
      else {
        this.characterlimit = 100;
      }
      this.fontsize = 14;
      this.fontfamily = 'Roboto';

      event.name = event.fieldTypeName + '-' + new Date().getTime() + Math.random();;
      let fillListArray: any = [];
      let fillList: any = [];
      this.buttonText = "Button";
      this.acceptOrdeclineText = 'Approve';
      this.buttonURL = "";
      this.acceptchecked = true;
      this.declinechecked = false;
      var textaligns: string = "left";

      if (event.fieldTypeName == 'Textarea') {
        this.characterlimit = 250;
      }
      //this.OpentoolDetail(event.fieldTypeName);

      if (event.fieldTypeName == 'MultiSelect' || event.fieldTypeName == 'Dropdown' ||
        event.fieldTypeName == 'Checkbox' || event.fieldTypeName == 'Radio' ||
        event.fieldTypeName == 'BulletList' || event.fieldTypeName == 'CheckBoxGroup' ||
        event.fieldTypeName == 'File' || event.fieldTypeName == 'Image' ||
        event.fieldTypeName == 'Date') {

        let drpValue = event.defaultValue.replace(/,\s*$/, "");
        fillListArray = drpValue.split(',');

        if (event.fieldTypeName == 'BulletList') {
          this.bulletFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.bulletFieldArray.push(copyModel);
          });
          this.offsetWidth = 60;
          this.offsetHeight = 35;
        }

        if (event.fieldTypeName == 'Dropdown') {
          if (event.fieldID > 0) {
            this.dropdownddisabled = true;
          } else {
            this.dropdownddisabled = false;
          }
          this.dropdownFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.dropdownFieldArray.push(copyModel);
          });
          this.offsetWidth = 115;
          this.offsetHeight = 28;
        }

        if (event.fieldTypeName == 'Checkbox') {
          if (event.fieldID > 0) {
            this.checkboxdisabled = true;
          } else {
            this.checkboxdisabled = false;
          }
          this.checkboxFieldArray = [];
          fillListArray.forEach((element) => {
            let copyModel = Object.assign({});
            copyModel.val = element;
            this.checkboxFieldArray.push(copyModel);
          });
          this.offsetWidth = 15;
          this.offsetHeight = 15;
        }

        if (event.fieldTypeName == 'Radio') {

          this.offsetWidth = 15;
          this.offsetHeight = 15;
        }

        for (let index = 0; index < fillListArray.length; index++) {
          var elementt = fillListArray[index];
          if (elementt == "''") {
            elementt = "";
          }
          if (index !== 0)
            y = y + 37;
          fillList.push({
            id: 'ctrl-' + index,
            val: elementt,
            offsetX: x,
            offsetY: y
          });
        }
      }

      if (event.fieldTypeName == 'Table') {
        this.tblid = undefined;
        this.tblrowsnumber = 2;
        this.tblclmnumber = 2;
        this.GettableWithFields(2, 2);
        this.offsetWidth = 375;
        this.offsetHeight = 60;

        for (let r = 0; r < this.rows.length; r++) {
          for (let c = 0; c < this.column.length; c++) {
            fillList.push({
              val: '',
              id: 'txt-' + (r + 1) + '' + (c + 1)
            });
          }
        }
      }

      if (event.fieldTypeName == "Textbox" || event.fieldTypeName == "Number"
        || event.fieldTypeName == "Single-Line" || event.fieldTypeName == "Currency" ||
        event.fieldTypeName == "URL" || event.fieldTypeName == "Address") {
        this.offsetWidth = 150;
        this.offsetHeight = 30;
      }

      if (event.fieldTypeName == 'Textarea') {
        this.offsetWidth = 170;
        this.offsetHeight = 40;
      }

      if (event.fieldTypeName == 'StrikeThrough' || event.fieldTypeName == 'StraightLine') {
        this.offsetWidth = 60;
        this.offsetHeight = 35;
      }

      if (event.fieldTypeName == 'measure') {
        this.offsetWidth = 40;
        this.offsetHeight = 40;
      }

      if (event.fieldTypeName == 'WhiteOut' || event.fieldTypeName == 'HighLight') {
        this.offsetWidth = 60;
        this.offsetHeight = 35;
      }

      if (event.fieldTypeName == 'Draw') {
        this.offsetWidth = 45;
        this.offsetHeight = 45;
      }

      if (event.fieldTypeName == 'Signature') {
        this.offsetWidth = 79;
        this.offsetHeight = 52;
      }

      if (event.fieldTypeName == 'Initials') {
        this.offsetWidth = 45;
        this.offsetHeight = 45;
      }

      if (event.fieldTypeName == 'ApproveOrDecline' || event.fieldTypeName == 'Button') {
        this.offsetWidth = 75;
        this.offsetHeight = 35;
        textaligns = "Center";
      }

      if (event.fieldTypeName == 'Date' || event.fieldTypeName == 'Time') {
        this.offsetWidth = 170;
        this.offsetHeight = 33;
      }

      if (event.fieldTypeName == 'Location') {
        this.offsetWidth = 90;
        this.offsetHeight = 50;
      }

      if (event.fieldTypeName == 'File' || event.fieldTypeName == 'Image') {
        this.offsetWidth = 100;
        this.offsetHeight = 60;
      }

      if (event.fieldTypeName == 'MultiSelect') {
        this.offsetWidth = 115;
        this.offsetHeight = 28;
      }

      let fieldJson = {
        "isEditable": false,
        "id": event.name,
        "fieldID": event.fieldID,
        "fieldName": event.fieldName,
        "folderID": event.folderID,
        "folderName": event.folderName,
        "subFolderName": event.subFolderName,
        "fieldTypeID": event.fieldTypeID,
        "fieldTypeName": event.fieldTypeName,
        "placeholder": event.placeholder,
        "defaultValue": event.defaultValue,
        "fillList": fillList,
        "FileData": [],
        "ImageData": [],
        "rows": this.rows,
        "column": this.column,
        "selectedValue": '',
        "isRequired": false,
        "readonly": false,
        "charLimit": this.characterlimit,
        "fontSize": element.item.fontSize,
        "fontName": "",
        "fontstyle": "",
        "fontweight": "",
        "textdecoration": "",
        "fontColor": "",
        "fontfamily": element.item.fontfamily,
        "offsetX": this.xposition,
        "offsetY": this.yposition,
        "height": 0,
        "width": 0,
        "Imageheight": "100px",
        "Imagewidth": "100px",
        "textalign": textaligns,//"left",       
        "chkSelectedValues": [],
        "rbSelectedValues": ['ctrl-0'],
        "fieldNames": event.fieldNames,
        "buttonText": event.fieldTypeName == 'ApproveOrDecline' ? 'Approve' : '',
        "signatureBase64": "",
        "signatureText": '',
        "drawBase64": "",
        "colorCode": element.item.colorCode,
        "colorCodeAlpha": element.item.colorCodeAlpha,
        'signInitialFontFamily': '',
        'Lat': '',
        'Long': '',
        "selectedParticipant": element.item.selectedParticipant,
        "backgroundColor": "",
        "buttonName": "Button",
        "buttonURL": "",
        "brushColor": undefined,
        "rotation": this.rotationByDegree,
        "ShowtoolDetail": true,
        "offsetWidth": element.item.offsetWidth,
        "offsetHeight": element.item.offsetHeight,
        "showRequiredControls": false,
        "coreContactCompanyType": this.coreContactCompanyType,
      }

      if (event.fieldTypeName == "WhiteOut") {
        fieldJson.colorCodeAlpha = this.hexToRGBA("#FFFFFF", 1);
      }


      if (event.fieldTypeName == 'Radio') {
        this.radioButtonGroupFieldArray = fieldJson.fillList;
      }

      if (event.fieldTypeName == "HighLight") {
        fieldJson.colorCodeAlpha = this.highLightColor;
        fieldJson.backgroundColor = this.highLightColor;
      }

      if (event.fieldTypeName == 'CheckBoxGroup') {
        if (event.fieldID > 0) {
          this.checkboxdisabled = true;
        } else {
          this.checkboxdisabled = false;
        }
        this.checkboxGroupFieldArray = [];
        this.checkboxGroupFieldArray = fillList;
      }

      if (event.fieldTypeName == 'Draw') {
        this.brushColor = "";
      }

      if (event.fieldTypeName == 'Table') {
        this.tblid = event.name;
      }

      this.imagesWithFields.forEach(ctr => {
        ctr.fields.filter(v => v.ShowtoolDetail = false);
      });

      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));

      if (this.imagesWithFields.find(x => x.img == list.img)) {
        this.imagesWithFields.find(x => x.img == list.img).fields.push(fieldJson);
        this.imagesWithFields = this.imagesWithFields;
      }

      this.text = "";
      this.ControlId = event.name;
      this.ControlData = list;
      this.isRequired = false;
      this.readonly = false;
      this.textColor = "";
      this.fontstyle = "";
      this.textdecoration = "";
      this.fontweight = "";
      this.textalign = "";
      this.brushColor = "";

      this.xx = x;
      this.yy = y;

      if (!this.controlAlignArray.find(m => m.id == event.name)) {

        this.controlAlignArray.push({
          fieldTypeName: event.fieldTypeName,
          img: list.img,
          id: event.name
        });
      }
      //  sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    });
    this.isClickReplaceEnabled = false;
    if (document.getElementById('format_list_bulletedleftpanel') !== null) {
      (document.getElementById('format_list_bulletedleftpanel') as HTMLInputElement).style.removeProperty('display');
      (document.getElementById('table_chartleftpanel') as HTMLInputElement).style.removeProperty('display');
    }
    this.ControlForReplcaArray = [];
    this.controlAlignArray = [];
    this.onClickOutside();
  }

  movingOffset = { x: 0, y: 0 };
  endOffset = { x: 0, y: 0 };


  onclickMenu(color: any, selectedParticipant: any, isUpdateJson: boolean = false) {
    this.selectedParticipant = selectedParticipant;
    this.selectedColorCode = color;
    //this.participantEmailId = selectedParticipant?.participantEmail;
    this.colorselected = this.hexToRGBA(color, 1);
    this.colorselectedAlpha = this.hexToRGBA(color, 0.7);

    if (this.ShowtoolDetail) {
      if (this.ControlData != undefined) {
        this.onParticipantChangeForControl(color);
      }
    }
    else { 
      if(this.ControlId!=""){
        this.onParticipantChangeForControl(color);
      }
      this.onParticipantCHangeForMultipleControls(color);
    }

    if (isUpdateJson) {
      //Prepare Json previously selected participant
      let findPreviouslyparticipant = this.participantArray.find(m => m.documentId == this.selectedDocumentId);
      if (findPreviouslyparticipant) {
        this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
      } else {
        this.participantArray.push({
          groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
          participantJson: JSON.stringify(this.imagesWithFields),
          documentId: this.selectedDocumentId,
          projectParticipantJsonID: 0
        })
      }

      //Prepare Json Currently selected participant
      let findCurrentparticipant = this.participantArray.find(m => m.documentId == this.selectedDocumentId);
      if (findCurrentparticipant) {
        this.imagesWithFields = JSON.parse(findCurrentparticipant.participantJson);
      }
      else {
        this.imagesWithFields.forEach(e => { e.fields = []; });
      }
    }
  }

  openConvertPdfPopup(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      // panelClass: 'custom-modalbox'
    });
  }
  openAIPdfPopup(templateRef: TemplateRef<any>) {
    this.aiDocListWithDetailForOuter=[];
    this.selectedAIDocsOUter=[];
    this.imagesWithFields.forEach(element => {
      element.fields.forEach(fe => {
           if(fe.fieldTypeName=="AITextBox")
           {
            if(fe.aiQuestion!="" && fe.aiQuestion!=undefined && fe.aiQuestion!=null)
            this.aiDocListWithDetailForOuter.push({
                id:fe.id,
                question:fe.aiQuestion,
                img:element.img
                });
           }
      });
    });
    const dialogRef = this.dialog.open(templateRef, {
       panelClass: 'custom-modalbox'
    });
  }
  ConvertPdf(isCompleteProject: boolean) {
    if (this.projectParticipantsList.length === 0 || this.projectParticipantsList.find(m => m.groupRelationParticipantMappingID > 0) === undefined) {
      this.toastr.warning("Select or add a participant.");
      return;
    }
    this.dialog.closeAll();
    this.initialSelectedDocumentId = Number(this.selectedDocumentId);
    this.projectDocuments.forEach(doc => {
      this.FillDocImagesWithFields(doc.projectDocumentID, true);
    });
    this.loaderService.show();
    var allPdfHTML = [];

    for (var i = 0; i < this.projectDocuments.length; i++) {
      let Current = this.participantArray.find(m => m.documentId == this.projectDocuments[i].projectDocumentID);
      this.imagesWithFields = JSON.parse(Current.participantJson);

      this.cdr.detectChanges();
      var height = document.getElementById("docHolding1") as HTMLImageElement;
      var newimgHeight = (height.offsetHeight) + 'px'.toString();
      var newimgwidth = (height.offsetWidth) + 'px'.toString();
      var html = '';
      //this.wait(i*1000);
      this.innerhtmlvalue = document.getElementById("docSign").innerHTML;      
      html = "<html lang=&quot;en&quot;><head> <link href='https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap' rel='stylesheet'><meta charset=&quot;utf-8&quot;><meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1&quot;><style> @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'; .next {display:none; } .docHolding {position:relative;} #imageDrawContainer {vertical-align:top;display:block;left:auto!important;} .iframe-drag-handle { background-color: transparent !important;border: none !important } input, textarea, .customUpdate, .Dtime { background-color: transparent !important; border: none !important; resize: none !important } div.customUpdate {border:none !important}.mat-icon-button, ngx-material-timepicker-toggle, input[type='file']{ display: none !important } table{ border: none !important;border-spacing: 0 !important } mat-select{border:none !important} #loc_Icon,#cloud_upload,#draw_brush,#border_color,#initial_gesture{display:none !important} @font-face {font-family: 'Roboto'; src: 'url'+'('+'https://ecmuiprod-staging.azurewebsites.net/src/assets/font/Roboto/Roboto-Regular.ttf'+')' } @font-face {font-family: 'Calibri'; src: 'url'+'('+'https://ecmuiprod-staging.azurewebsites.net/src/assets/font/calibri/calibri-regular.ttf'+')'} .sig-chrome { border-left: 2px solid #005cb9; border-radius: 8px; display: block; height: 80px; padding:0; overflow: visible; position: relative; } .sig-chrome::before { border-top-left-radius: 8px; border-top-width: 2px; top: -2px; } .sig-chrome::after, .sig-chrome::before { border: 0 solid #005cb9; content: ''; display: block; height: 38px; left: -1px; position: absolute; width: 20px; } .sig-chrome::after { border-bottom-left-radius: 8px; border-bottom-width: 2px; bottom: -2px; } .sig-chrome::before { border-top-left-radius: 8px; border-top-width: 2px; top: -2px; } .sig-chrome-title-top { font-weight: 700; top: -8px; font-family:'Arial, Helvetica, sans-serif' } .sig-chrome-title-bottom, .sig-chrome-title-top { font-size: 12px; left: 21px; position: absolute; white-space: nowrap; } .sig-chrome .sig-container { height: 70px; //overflow: hidden; position: absolute; white-space: nowrap; width: 100%; padding:0 10px; display: flex; justify-content: flex-start; align-items: center; } .sig-container img{ width:100%; height:100%; object-fit:contain;} .sig-chrome .sig-container h3{ padding: 0; font-size: 20px; } .sig-chrome .sig { float: left; max-height: 100%; max-width: 100%; position: relative; top: 50%; -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); transform: translateY(-50%); } .sig-chrome-title-bottom { bottom: -7px; } </style></head><body style=&quot;background: #979797;&quot; > <div style='width:" + newimgwidth + "; margin: auto; height: auto;'>  " + this.innerhtmlvalue + "</div>  </body> </html>";

      var imgHeight = document.getElementById("imgSrc" + 0) as HTMLImageElement;
      var req = {
        documentName: this.projectDocuments[i].documentName,
        projectDocumentId: this.projectDocuments[i].projectDocumentID,
        documentHtml: html,
        pageWidth: (height.offsetWidth).toString(),
        pageHeight: (imgHeight.offsetHeight).toString()
      }
      req.documentHtml = req.documentHtml as any;
      allPdfHTML.push(req);
    }

    this.FillDocImagesWithFields(this.initialSelectedDocumentId, true);

    let reqPayload = {
      //token:encodeURIComponent(decodeURIComponent(this.token)),
      groupRelationParticipantMappingID: this.projectParticipantsList.find(m => m.groupRelationParticipantMappingID > 0).groupRelationParticipantMappingID,
      participantJsonList: this.participantArray,
      documentHtmls: allPdfHTML,
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      IsCompleteProject: isCompleteProject,
      IsProject:(Number(sessionStorage.getItem('type'))==1?true:false)
    };

    this.formService.GeneratePDF(reqPayload).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.toastr.success("Document converted and saved successfully.");
          this.loaderService.hide();
          if (isCompleteProject) {
            this.router.navigate(['/esignature']);
          }
        }
        else {
          this.loaderService.hide();
        }
      }
    });

  }


  hexToRGBA(hex, opacity) {
    if (hex == undefined || (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')) == null || (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')) == undefined) {
      return;
    }
    return (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g')).map(function (l) { return parseInt(hex.length % 2 ? l + l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',');
  }


  RGBToHex(rgb) {
    // Choose correct separator
    let sep = rgb.indexOf(",") > -1 ? "," : " ";
    // Turn "rgb(r,g,b)" into [r,g,b]
    rgb = rgb.substr(4).split(")")[0].split(sep);

    let r = (+rgb[0]).toString(16),
      g = (+rgb[1]).toString(16),
      b = (+rgb[2]).toString(16);

    if (r.length == 1)
      r = "0" + r;
    if (g.length == 1)
      g = "0" + g;
    if (b.length == 1)
      b = "0" + b;

    return "#" + r + g + b;
  }

  onStart(event) {

  }

  onStop(event) {

  }

  onMoving(event, parentCtrl, data, childCtrl) {
    this.movingOffset.x = event.x;
    this.movingOffset.y = event.y;
  }

  onMoveEnd(event, data, parentCtrl, childCtrl) {
    this.ControlData=data;
    this.ControlId = parentCtrl.id;
    this.endOffset.x = event.x;
    this.endOffset.y = event.y;
    this.xposition = this.endOffset.x;
    this.yposition = this.endOffset.y;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    this.isControlKeyPressed = true;
    if (this.controlAlignArray.length <= 1) {
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        let fieldType = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).fieldTypeName;
        if (fieldType == 'Checkbox' || fieldType == 'Radio' || fieldType == 'CheckBoxGroup') {
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).fillList.forEach(ee => {
            if (ee.id == childCtrl.id) {
              ee.offsetX = event.x;
              ee.offsetY = event.y;
            }
          });
        } else {
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetX = event.x;
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetY = event.y;
        }
        this.imagesWithFields = this.imagesWithFields;
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
    else if (this.controlAlignArray.length > 1) {
      if (this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).fieldTypeName=="AITextBox")
      {

        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetX = event.x;
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetY = event.y;
        return;
      }
      this.controlAlignArray=this.controlAlignArray.filter(m=>m.fieldTypeName!="AITextBox");
      let previousXpos = 0;
      let previousYpos = 0;
      if (parentCtrl.fieldTypeName == 'Checkbox' || parentCtrl.fieldTypeName == 'Radio' || parentCtrl.fieldTypeName == 'CheckBoxGroup') {
        previousXpos = childCtrl.offsetX;
        previousYpos = childCtrl.offsetY;
      }
      else {
        previousXpos = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetX;
        previousYpos = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetY;

      }
      var deltaxpos = 0;
      var deltaYpos = 0;
      if (previousXpos > this.xposition) {
        deltaxpos = -1 * (previousXpos - this.xposition);
      }
      if (previousXpos < this.xposition) {
        deltaxpos = (this.xposition - previousXpos);
      }
      if (previousYpos > this.yposition) {
        deltaYpos = -1 * (previousYpos - this.yposition);
      }
      if (previousYpos < this.yposition) {
        deltaYpos = (this.yposition - previousYpos);
      }
      this.controlAlignArray.forEach(ctrl => {
        if (this.imagesWithFields.find(x => x.img == ctrl.img) && this.imagesWithFields.find(x => x.img == ctrl.img).fields.length > 0) {
          let fieldType = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).fieldTypeName;
          let showtooldetails = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).ShowtoolDetail;
          if (showtooldetails) {
            let previousXPosition = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).offsetX;
            let previousYPosition = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).offsetY;

            if (showtooldetails && parentCtrl.id !== ctrl.id) {
              if (fieldType == 'Checkbox' || fieldType == 'Radio' || fieldType == 'CheckBoxGroup') {
                this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).fillList.forEach(ee => {

                  if (showtooldetails) {
                    ee.offsetX = ee.offsetX + deltaxpos;
                    ee.offsetY = ee.offsetY + deltaYpos;
                  }
                });
              }
              else {
                this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).offsetX = (previousXPosition) + (deltaxpos);
                this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrl.id).offsetY = (previousYPosition) + (deltaYpos);
              }
              this.imagesWithFields = this.imagesWithFields;
            }
            else {
              if (fieldType == 'Checkbox' || fieldType == 'Radio' || fieldType == 'CheckBoxGroup') {
                this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).fillList.forEach(ee => {

                  if (showtooldetails && ee.id == childCtrl.id) {
                    ee.offsetX = this.xposition;
                    ee.offsetY = this.yposition;
                  }
                  else if (showtooldetails && ee.id != childCtrl.id) {
                    ee.offsetX = ee.offsetX + deltaxpos;
                    ee.offsetY = ee.offsetY + deltaYpos;
                  }
                });
              }
              else {
                this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetX = this.xposition;
                this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetY = this.yposition;
              }
              this.imagesWithFields = this.imagesWithFields;
            }
          }
        }
      });

      this.isControlKeyPressed = false;
      this.isShiftKeyPressed = false;
    }
    //  else if((!this.isControlKeyPressed && this.controlAlignArray.length>1 && !this.isShiftKeyPressed)){
    //   //if(this.controlAlignArray.length>1 && !this.ShowtoolDetail ){
    //     this.toastr.info("Press control key to move the selected controls at once.");
    //   //}
    // }
    // else if((!this.isControlKeyPressed && this.controlAlignArray.length>1 && this.isShiftKeyPressed)){
    //   //if(this.controlAlignArray.length>1 && !this.ShowtoolDetail ){
    //     this.toastr.info("Press control key to move the selected controls at once.");
    //   //}
    // }
  }





  onResizeStart(event, data, id) { 
    // var data= data;//this.ControlData; 
    // if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
    //  var cntrol = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id);
    //  this.changesForUndo.push(JSON.parse(JSON.stringify( this.imagesWithFields)));
    //  if(cntrol.fieldTypeName=="Signature" || cntrol.fieldTypeName=="Initials"){
    //    if(event.size.height > 70){
    //     return;
    //    }
    //    //this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetWidth = event.size.width; 
    //   // this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetHeight = 70; 
    //   // this.imagesWithFields = this.imagesWithFields;
    //  } 
    // }
    //this.state = 'Resize Started';
    // this.size = event.size;
    // this.position = event.position;
  }

  // onResizing(event) {
  //      if(event.size.height > 70){
  //       return;
  //      }
  //   // this.state = 'Resizing';
  //   // this.size = event.size;
  //   // this.position = event.position;
  // }

  onResizeStop(event, data, id) {
    this.ControlData = data;
    this.ControlId = id;
    var data = data;//this.ControlData; 
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      var cntrol = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id);
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetWidth = event.size.width;
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetHeight = event.size.height;
      this.imagesWithFields = this.imagesWithFields;
      // if(cntrol.fieldTypeName=="Signature" || cntrol.fieldTypeName=="Initials"){
      //   this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetWidth = event.size.width; 
      //   this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetHeight = event.size.height; 
      //   this.imagesWithFields = this.imagesWithFields;      
      // }else{
      //   this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetWidth = event.size.width; 
      //   this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).offsetHeight = event.size.height; 
      //   this.imagesWithFields = this.imagesWithFields;
      // }     

      if (cntrol.fieldTypeName == "measure") {
        let measurewidthinCM = 0.027 * event.size.width + " cm";
        this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).width = measurewidthinCM;
        this.imagesWithFields = this.imagesWithFields;
      }
    }
  }

  contolToPaste = undefined;
  controlId2Paste = "";

  CopyCntrl() {
    if (this.ControlData != undefined)
    this.contolToPaste = JSON.parse(JSON.stringify(this.ControlData));
    this.controlId2Paste = this.ControlId;
  }

  pasterCtrl() {
    let pasted = [];
    for (let i = 0; i < this.controlAlignArray.length; i++) {
      var ctrl2Paste = this.contolToPaste.fields.find(x =>
        x.id == this.controlAlignArray[i].id,
        this.ShowtoolDetail = false
      );
      ctrl2Paste.id = ctrl2Paste.id + Math.random();
      ctrl2Paste.offsetY = ctrl2Paste.offsetY + ctrl2Paste.offsetHeight + 5;
      pasted.push(ctrl2Paste);
      this.imagesWithFields.find(x => x.img == this.contolToPaste.img).fields.push(ctrl2Paste);
      this.contolToPaste = JSON.parse(JSON.stringify(this.ControlData));
      this.controlAlignArray[i].id
    }
    for (let i = 0; i < this.controlAlignArray.length; i++) {
      this.imagesWithFields.find(x => x.img == this.contolToPaste.img).fields.find(m => m.id == this.controlAlignArray[i].id).ShowtoolDetail = false;
    }
    this.controlAlignArray = pasted;

    // var ctrl2Paste = this.contolToPaste.fields.find(x => x.id == this.controlId2Paste);
    // ctrl2Paste.id = ctrl2Paste.id + Math.random();
    // ctrl2Paste.offsetX = ctrl2Paste.offsetX + 15;
    // ctrl2Paste.offsetY = ctrl2Paste.offsetY + 15;
    // this.imagesWithFields.find(x => x.img == this.contolToPaste.img).fields.push(ctrl2Paste);
    // this.contolToPaste = JSON.parse(JSON.stringify(this.ControlData));
  }

  GettableWithFields(rows: any, coloumn: any) {
    this.rows = [];
    this.column = [];
    for (var i = 0, len = rows; i < len; ++i) {
      var req = {
      }
      this.rows.push(req)
    }
    for (var i = 0, len = coloumn; i < len; ++i) {
      var req = {
      }
      this.column.push(req)
    }

    if (this.tblid != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.tbldata.img) && this.imagesWithFields.find(x => x.img == this.tbldata.img).fields.length > 0) {
        let length = this.rows * this.column;
        let oldFillList = this.imagesWithFields.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).fillList;
        let fillList = [];
        for (let r = 0; r < this.rows.length; r++) {
          for (let c = 0; c < this.column.length; c++) {
            if (oldFillList.some(m => m.id == 'txt-' + (r + 1) + '' + (c + 1))) {
              fillList.push({
                val: oldFillList.find(m => m.id == 'txt-' + (r + 1) + '' + (c + 1)).val,
                id: 'txt-' + (r + 1) + '' + (c + 1)
              });
            } else {
              fillList.push({
                val: '',
                id: 'txt-' + (r + 1) + '' + (c + 1)
              });
            }
          }
        }
        this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
        this.imagesWithFields.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).rows = this.rows;//.push(this.rows);
        this.imagesWithFields.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).column = this.column;//.push(this.column)
        this.imagesWithFields.find(x => x.img == this.tbldata.img).fields.find(m => m.id == this.tblid).fillList = fillList;//.push(this.column)
        this.imagesWithFields = this.imagesWithFields;
      }
    }
  }



  onChangetblrows(rows: any) {
    if (isNaN(rows)) {
      this.toastr.warning('String not allowed.');
    } else {
      this.tblcoloumn = (<HTMLInputElement>document.getElementById('txt-tbl-column')).value;
      if ((rows > 0 && rows <= 10) && (this.tblcoloumn > 0 && this.tblcoloumn <= 10)) {
        if (rows == '' || rows == 0 || this.tblcoloumn == '' || this.tblcoloumn == 0) {
          return;
        }
        this.rows = [];
        this.column = [];
        this.tblrows = Number(rows);
        if (this.tblcoloumn == undefined) {
          this.tblcoloumn = 2;
        }
        this.GettableWithFields(Number(rows), Number(this.tblcoloumn));
      } else {
        if ((rows < 1 && rows != "") && (this.tblcoloumn > 0 || this.tblcoloumn <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows are allowed.');
        } else if (rows == "" && (this.tblcoloumn > 0 || this.tblcoloumn <= 10)) {
          return;
        } else if (rows >= 10 && (this.tblcoloumn > 0 && this.tblcoloumn <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows are allowed.');
        } else if ((rows >= 10 || rows < 1) && (this.tblcoloumn < 0 || this.tblcoloumn > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows and 10 Columns are allowed.');
        } else if ((rows <= 10 || rows > 0) && (this.tblcoloumn < 0 || this.tblcoloumn > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Rows are allowed.');
        } else {
          return;
        }
      }
    }

  }

  onChangetblclm(clm: any) {
    if (isNaN(clm)) {
      this.toastr.warning('String not allowed.');
    } else {
      this.tblrows = (<HTMLInputElement>document.getElementById('txt-tbl-row')).value;
      if ((clm > 0 && clm <= 10) && (this.tblrows > 0 && this.tblrows <= 10)) {

        if (clm == '' || clm == 0 || this.tblrows == '' || this.tblrows == 0) {
          return;
        }
        this.rows = [];
        this.column = [];
        this.tblcoloumn = Number(clm);
        if (this.tblrows == undefined) {
          this.tblrows = 2;
        }
        this.GettableWithFields(Number(this.tblrows), Number(clm));
      } else {
        if ((clm < 1 && clm != "") && (this.tblrows > 0 || this.tblrows <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns are allowed.');
        } else if (clm == "" && (this.tblrows > 0 || this.tblrows <= 10)) {
          return;
        } else if (clm >= 10 && (this.tblrows > 0 && this.tblrows <= 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns are allowed.');
        } else if ((clm < 1 || clm >= 10) && (this.tblrows < 0 || this.tblrows > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns and 10 Rows are allowed. ');
        } else if ((clm > 0 || clm <= 10) && (this.tblrows < 0 || this.tblrows > 10)) {
          this.toastr.clear();
          this.toastr.warning('Only upto 10 Columns are allowed.');
        } else {
          return;
        }
      }
    }

  }

  getColumnValue(data: any, tblId: any, row: any, col: any) {
    let id = 'txt-' + row + col;
    let val = '';
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      val = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == tblId).fillList.find(m => m.id == id).val;
    }
    return val;
  }

  OpentoolDetailtbl(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      this.tbldata = data;
      this.tblid = id;

      var check = data.fields.filter((s) => s.id == id);
      if (check.length > 0) {
        this.tblrowsnumber = check[0].rows.length;
        this.tblclmnumber = check[0].column.length;
      }
    }
  }


  alignHorizontalLeft() {
    let minX = 0;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            if (ele.offsetX < minX) {
              minX = ele.offsetX;
            }
          });
        }
        else
          if (this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX < minX || minX == 0) {
            minX = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX;
          }
      });
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetX = minX;
          });
        }
        else
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX = minX;
      });
    }
  }

  alignHorizontalRight() {
    let maxX = 0;
    let maxId = "";
    let maxWidth = 0;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            if (ele.offsetX > maxX) {
              //maxX=ele.offsetX;
              // maxId= e.id;
            }
          });
        }
        else
          if (this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth > maxWidth || maxWidth == 0) {
            maxWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth;
            maxX = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX;
            maxId = e.id;
          }
      });
      let offsetCntrlMaxxWidth = maxWidth;
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth;
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetX = maxX + maxWidth - ((maxX + maxWidth) * 5 / 100);
          });
        }
        if (e.fieldTypeName == "Radio") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetX = maxX + maxWidth - ((maxX + maxWidth) * 6 / 100);
          });
        }
        else
          if (e.id != maxId) {
            let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth;
            if (((offsetCntrlMaxxWidth - currentControlWidth) + maxX) > 0)
              this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX = (offsetCntrlMaxxWidth - currentControlWidth) + maxX - ((offsetCntrlMaxxWidth - currentControlWidth) * 2 / 100);
          }
      });
    }
  }

  alignHorizontalCenter() {
    let maxX = 0;
    let maxId = "";
    let maxWidth = 0;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
          });
        }
        else
          if (this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth > maxWidth || maxWidth == 0) {
            maxWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth;
            maxX = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX;
            maxId = e.id;
          }
      });
      let offsetCntrlMaxxWidth = maxWidth;
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth;
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetX = (maxWidth / 2) + maxX - ((maxWidth * 5) / 100);
          });
        }
        else
          if (e.id != maxId) {
            let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetWidth;
            this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetX = (offsetCntrlMaxxWidth - currentControlWidth) / 2 + maxX;
          }
      });
    }
  }


  alignVerticalTop() {
    let minY = 0;
    let maxId = 0;
    let maxHeight = 0;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            // if(ele.offsetY<minY){
            //   minY=ele.offsetY;
            //   minX = ele.offsetX;
            // }
          });
        }
        else
          if (this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight < maxHeight || maxHeight == 0) {
            maxHeight = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight;
            maxId = e.id;
            minY = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetY;
          }
      });
      this.controlAlignArray.forEach(e => {
        if (e.id != maxId) {
          if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
            this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
              ele.offsetY = minY;
              //ele.offsetX = minX;
            });
          }
          else
            this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetY = minY;
        }
      });
    }
  }


  alignVerticalCenter() {
    let maxY = 0;
    let maxId = "";
    let maxHeight = 0;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            // if(ele.offsetY<maxY) {
            //   maxY=ele.offsetY;
            //   maxX= ele.offsetX;
            //   maxId= e.id;
            // }
          });
        }
        else
          if (this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight > maxHeight || maxHeight == 0) {
            maxY = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetY;
            maxHeight = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight;
            maxId = e.id;
          }
      });
      let offsetCntrlMaxxWidth = maxHeight;
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          //let currentControlWidth =this.imagesWithFields.find(x => x.img == e.img).fields.find(x=>x.id==e.id).offsetHeight;
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetY = (maxHeight / 2) + maxY;//-((maxHeight*9)/100);
          });
        }
        else
          if (e.id != maxId) {
            this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetY = (maxHeight) / 2 + maxY;
          }
      });
    }
  }

  alignVerticalBottom() {
    let maxY = 0;
    let maxHeight = 0;
    let maxId = "";
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.controlAlignArray.length > 0) {
      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup" || e.fieldTypeName == "Checkbox") {
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            if (ele.offsetY > maxY) {
              //maxX=ele.offsetX;
              // maxId= e.id;
            }
          });
        }
        else
          if (this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight > maxHeight || maxHeight == 0) {
            maxY = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetY;
            maxId = e.id;
            maxHeight = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight;
          }
      });

      this.controlAlignArray.forEach(e => {
        if (e.fieldTypeName == "Radio" || e.fieldTypeName == "CheckBoxGroup") {
          let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight;
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetY = maxY + (maxHeight - currentControlWidth);
            // ele.offsetX=maxX;
          });

        }
        if (e.fieldTypeName == "Checkbox") {
          let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight;
          this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).fillList.forEach(ele => {
            ele.offsetY = maxY + (maxHeight - currentControlWidth);
          });
        }
        else
          if (e.id != maxId) {
            let currentControlWidth = this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetHeight;
            this.imagesWithFields.find(x => x.img == e.img).fields.find(x => x.id == e.id).offsetY = maxY + (maxHeight - currentControlWidth);
          }
      });
    }

  }

  acceptchecked: boolean = false;
  declinechecked: boolean = false;

  OpentoolDetailText(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if(getData[0].fieldName=="AITextBox")
          {

            this.aiAnswer = getData[0].selectedValue;
            this.text=getData[0].aiQuestion
          }
          else
          {
            this.text=getData[0].selectedValue;
          }
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.expression= getData[0].expression==undefined?"":getData[0].expression;
          this.isDollar=(getData[0].isDollar==undefined || getData[0].isDollar==null || getData[0].isDollar=="")?false:getData[0].isDollar;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.editFieldname = getData[0].fieldName;
          this.selectedFolderID = getData[0].folderID;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
          if (this.selectedParticipant != undefined) {
            this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          }
          this.buttonText = getData[0].buttonName;
          this.buttonURL = getData[0].buttonURL;
          this.acceptOrdeclineText = getData[0].buttonText;
          this.brushColor = getData[0].penColor;


          if (this.acceptOrdeclineText == "Approve") {
            this.acceptchecked = true;
            this.declinechecked = false;
          }
          if (this.acceptOrdeclineText == "Decline") {
            this.declinechecked = true;
            this.acceptchecked = false;
          }

          if (this.buttonURL != "" && this.buttonURL != undefined && this.buttonURL != '') {
            const url = this.buttonURL;
            window.open(url, '_blank');
          }
          this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
            if (element.id != id)
              element.ShowtoolDetail = false;
          });
          this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
        }
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }

  isControlKeyPressed: boolean = false;

  OpentoolDetailDropDown(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
      this.isShiftKeyPressed = true;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
        if (element.id != id)
          element.ShowtoolDetail = false;
      });
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if (getData[0].fieldTypeName == "Dropdown") {
            if(getData[0].fieldID>0){
              var findValue:any=[]=[];
              findValue= this.corefieldsDragList.filter(x=>x.fieldID==getData[0].fieldID);
              if(findValue.length>0){
               let drpValue = findValue[0].defaultValue.replace(/,\s*$/, "");
               let fillListArray: any = [];
               var fillList:any=[];
               fillListArray = drpValue.split(',');
               for (let index = 0; index < fillListArray.length; index++) {
               var elementt = fillListArray[index];
               if (elementt == "''") {
                  elementt = "";
                }                            
                 fillList.push({
                 id: 'ctrl-' + index,
                 val: elementt,
                 offsetX: 0,
                 offsetY: 0
                });
               }
               this.dropdownFieldArray=fillList;
               this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fillList = fillList;
              }             
              
            }else{
              this.dropdownFieldArray = getData[0].fillList;
            }           
          }
          if (getData[0].fieldID > 0) {
            this.dropdownddisabled = true;
          } else {
            this.dropdownddisabled = false;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.editFieldname = getData[0].fieldName;
          this.selectedFolderID = getData[0].folderID;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
          if (this.selectedParticipant != undefined) {
            this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          }
        }
        this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }


onSelectMouseDown(event: MouseEvent, data: any, item: any) {
    // Check if the dropdown is about to open (not just a click)
    const selectElement = event.target as HTMLSelectElement;
    
    
    // Use setTimeout to check after the browser's default behavior
    setTimeout(() => {
            this.OpentoolDetailDropDown(data, item.id, event);
            this.OpentoolDetail('Dropdown');
            this.putControlForReplcae(data, item);
    }, 0);
}

  OpentoolDetailMulDropDown(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      this.imagesWithFields.find(x => x.img == data.img).fields.forEach(element => {
        if (element.id != id)
          element.ShowtoolDetail = false;
      });
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          // if(getData[0].fieldTypeName == "MultiSelect" ){
          //   this.dropdownFieldArray= getData[0].fillList;          
          // }
          if (getData[0].fieldID > 0) {
            this.dropdownddisabled = true;
          } else {
            this.dropdownddisabled = false;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.editFieldname = getData[0].fieldName;
          this.selectedFolderID = getData[0].folderID;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
        }
        this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }

  OpentoolDetailBulletList(data: any, id, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if (getData[0].fieldTypeName == "BulletList") {
            this.bulletFieldArray = getData[0].fillList;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
          if (this.selectedParticipant != undefined) {
            this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          }
        }
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
        this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
      }
    }
  }

  OpentoolDetailCheckBox(data: any, id, fillListcontrolId: any, event: any) {
    if ((event.target.checked && event.shiftKey) || (event.target.checked && this.isClickReplaceEnabled == true)) {
      (document.getElementById(id + fillListcontrolId) as HTMLInputElement).checked = false;
    }
    else if (event.shiftKey || (event.target.checked == false && this.isClickReplaceEnabled == true)) {
      (document.getElementById(id + fillListcontrolId) as HTMLInputElement).checked = true;
    }
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if (getData[0].fieldTypeName == "Checkbox") {
            this.checkboxFieldArray = getData[0].fillList;
          }
          if (getData[0].fieldID > 0) {
            this.checkboxdisabled = true;
          } else {
            this.checkboxdisabled = false;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.fillListcontrolId = fillListcontrolId;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.editFieldname = getData[0].fieldName;
          this.isShowChkLabel=getData[0].isShowChkLabel==undefined?false:getData[0].isShowChkLabel;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
          if (this.selectedParticipant != undefined) {
            this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          }
        }
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
        this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
      }
    }
  }

  OpentoolDetailCheckBoxGroup(data: any, id, fillListcontrolId: any, event: any) {
    if (event.target.checked && event.shiftKey || (event.target.checked && this.isClickReplaceEnabled == true)) {
      (document.getElementById(id + fillListcontrolId) as HTMLInputElement).checked = false;
    }
    else if (event.shiftKey || (event.target.checked == false && this.isClickReplaceEnabled == true)) {
      (document.getElementById(id + fillListcontrolId) as HTMLInputElement).checked = true;
    }
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if (getData[0].fieldTypeName == "CheckBoxGroup") {
            this.checkboxGroupFieldArray = getData[0].fillList;
          }
          if (getData[0].fieldID > 0) {
            this.checkboxdisabled = true;
          } else {
            this.checkboxdisabled = false;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.fillListcontrolId = fillListcontrolId;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.editFieldname = getData[0].fieldName;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.isShowChkLabel=getData[0].isShowChkLabel==undefined?false:getData[0].isShowChkLabel;
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
          if (this.selectedParticipant != undefined) {
            this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          }
        }
        this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }

  OpentoolDetailRadioButtonGroup(data: any, id, fillListcontrolId: any, event: any) {
    if (event.shiftKey) {
      this.ShowtoolDetail = false;
    }
    else {
      if (!this.controlAlignArray.find(m => m.id == id)) {

        this.controlAlignArray.push({
          fieldTypeName: this.imagesWithFields.find(x => x.img == data.img).fields.find(n => n.id == id).fieldTypeName,
          img: data.img,
          id: id
        });
      }
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == data.img))
        var getData = FieldsDetails.fields.filter(x => x.id === id);
        if (getData.length > 0) {
          if (getData[0].fieldTypeName == "Radio") {
            this.radioButtonGroupFieldArray = getData[0].fillList;
          }
          this.text = getData[0].selectedValue;
          this.ControlData = FieldsDetails;
          this.ControlId = id;
          this.fillListcontrolId = fillListcontrolId;
          this.isRequired = getData[0].isRequired;
          this.readonly = getData[0].readonly;
          this.characterlimit = getData[0].charLimit;
          this.editFieldname = getData[0].fieldName;
          this.textColor = getData[0].fontColor;
          var size = getData[0].fontSize.substr(0, getData[0].fontSize.length - 2);
          this.fontsize = Number(size);
          this.fontstyle = getData[0].fontstyle;
          this.fontweight = getData[0].fontweight;
          this.textdecoration = getData[0].textdecoration;
          this.fontfamily = getData[0].fontfamily;
          this.textalign = getData[0].textalign;
          this.selectedParticipant = getData[0].selectedParticipant;
          if (this.selectedParticipant != undefined) {
            this.groupRelationParticipantId = this.selectedParticipant?.groupRelationParticipantMappingID;
          }
        }
        this.onclickMenu(this.selectedParticipant?.colourCode, this.selectedParticipant);
        // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      }
    }
  }

  onChangebulletlist(string: any) {
    this.bulletFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.ControlData.img) && this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.length > 0) {
        this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
        this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList = this.bulletFieldArray;
        this.imagesWithFields = this.imagesWithFields;
      }
    }
  }

  onChangedropdownlist(string: any) {
    this.dropdownFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.ControlData.img) && this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.length > 0) {
        this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
        this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList = this.dropdownFieldArray;
        this.imagesWithFields = this.imagesWithFields;
      }
    }
  }

  onChangecheckboxlist(string: any) {
    this.checkboxFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.ControlData.img) && this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.length > 0) {

        var FieldsDetails = (this.imagesWithFields.find(x => x.img == this.ControlData.img))
        var getData = FieldsDetails.fields.filter(x => x.id === this.ControlId);
        if (getData.length > 0) {
          var data = getData[0].fillList[0];
          var objNew = []
          var obj = {
            id: data.id,
            offsetX: data.offsetX,
            offsetY: data.offsetY,
            val: string
          }
        }
        objNew.push(obj);
        this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
        this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList = objNew;
        this.imagesWithFields = this.imagesWithFields;
      }
    }
  }

  onChangecheckboxGrouplist(string: any, row: any) {
    this.checkboxGroupFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.ControlData.img) && this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == this.ControlData.img))
        var getData = FieldsDetails.fields.filter(x => x.id === this.ControlId);
      }
    }
  }

  onChangeRadioButtonGrouplist(string: any, row: any) {
    this.radioButtonGroupFieldArray.forEach((element) => {
      var val = string;
    });
    if (this.ControlId != undefined) {
      if (this.imagesWithFields.find(x => x.img == this.ControlData.img) && this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.length > 0) {
        var FieldsDetails = (this.imagesWithFields.find(x => x.img == this.ControlData.img))
        var getData = FieldsDetails.fields.filter(x => x.id === this.ControlId);
      }
    }
  }


  // numberOnly(event): boolean {
  //   const charCode = event.which ? event.which : event.keyCode;
  //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //     return false;
  //   }
  //   return true;
  // }

  // specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  // //regex: RegExp = new RegExp(/^\d*\.?\d{0,10}$/g);
  // numberOnly(event): boolean {
  //   let value = event.target.value;
  //   if (this.specialKeys.indexOf(event.key) !== -1) {
  //     return;
  //   }
  //   let current: string = value;
  //   const position = event.target.selectionStart;
  //   const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
  //   if (next && !String(next).match(this.regex)) {
  //     event.preventDefault();
  //   }

  // }

  specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

numberOnly(event): boolean {
  // Get the key pressed
  const key = event.key;

  // Allow special keys such as navigation (backspace, arrows, etc.)
  if (this.specialKeys.indexOf(key) !== -1) {
    return true;
  }

  // Get the current value in the input box and the position of the cursor
  const value = event.target.value;
  const position = event.target.selectionStart;

  // Build the string after inserting the new key at the cursor position
  const nextValue = value.slice(0, position) + key + value.slice(position);

  // Regex to allow only dollar sign, numbers, commas, and decimal point
  const regex = /^[\d$,\.]*$/;

  // Allow input if it matches the regex
  if (!regex.test(nextValue)) {
    event.preventDefault();
    return false;
  }

  return true;
}


  addValueFielbullet() {
    this.bulletFieldAttribute = null;
    let tempObject = Object.assign({}, this.bulletFieldAttribute);
    this.bulletFieldArray.push(tempObject);
    this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(m => m.id == this.ControlId).fillList = this.bulletFieldArray;
  }

  addValueFielDropDown() {
    this.dropdownFieldAttribute = null;
    let tempObject = Object.assign({}, this.dropdownFieldAttribute);
    this.dropdownFieldArray.push(tempObject);
  }

  addValueFielCheckBox() {
    this.checkboxFieldAttribute = null;
    let tempObject = Object.assign({}, this.checkboxFieldAttribute);
    this.checkboxFieldArray.push(tempObject);
  }

  deleteField(value, row: any) {
    if (value == 'b') {
      const index = this.bulletFieldArray.indexOf(row);
      if (index >= 0) {
        this.bulletFieldArray.splice(index, 1);
      }
    }
    else if (value == 'd') {
      const index = this.dropdownFieldArray.indexOf(row);
      if (index >= 0) {
        this.dropdownFieldArray.splice(index, 1);
      }
    }
    else if (value == 'c') {
      const index = this.checkboxGroupFieldArray.indexOf(row);
      if (index >= 0) {
        this.checkboxGroupFieldArray.splice(index, 1);
      }
    }
    else if (value == 'r') {
      const index = this.radioButtonGroupFieldArray.indexOf(row);
      if (index >= 0) {
        this.radioButtonGroupFieldArray.splice(index, 1);
      }
    }
  }


  onSelectFile(event, data: any, id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var FileObj = [];
        FileObj.push({
          FullPath: FullPath,
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Base64String: base64String
        });
        if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
          this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
          let fillList = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).FileData = FileObj
          this.imagesWithFields = this.imagesWithFields;
        }
      }
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));    
    }
  }

  onSelectImage(event, data: any, id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];

        var base64String = reader.result;

        var ImageObj = [];
        ImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
          this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
          let fillList = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).ImageData = ImageObj
          this.imagesWithFields = this.imagesWithFields;
        }
      }
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));    
    }

  }

  signOrInitialTextChanges(e: any) {
    if (this.signName !== '' && this.signName !== undefined) {
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      this.signatureBase64 = '';
      this.signOrInitialImageObj = [];
    } else {
      this.SignButtonEnable = false;
      this.InitailButtonEnable = false;
    }
  }

  radioChangeSign() {
    this.SignButtonEnable = false;
  }

  radioChangeInitails() {
    this.InitailButtonEnable = false;
  }

  setSignInitialFontFamilyChange(e: any) {
    this.signInitialFontFamily = e;
  }

  filenameForSign = "";

  onSelectSignImage(event, data: any, id: any) {
    data = this.currentSign.data;
    id = this.currentSign.id;
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++) {
      var ext = filename[i].name.split('.').pop();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg') {
        alert('only image upload');
        return;
      }
      this.SignButtonEnable = true;
      this.InitailButtonEnable = true;
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;

        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        this.filenameForSign = documentName;
        var base64String = reader.result;

        this.signOrInitialImageObj = [];
        this.signOrInitialImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath: filename[i],
          Imageurl: base64String
        });
        this.signatureBase64 = '';
        this.signName = '';
        if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
          this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
          let fillList = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).signatureBase64 = '';
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).signatureText = '';
          this.imagesWithFields = this.imagesWithFields;
        }
      }
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));    
    }
  }

  onChangeXposition(x: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).offsetX = Number(x) == undefined ? '' : Number(x);
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeYposition(y: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).offsetY = Number(y) == undefined ? '' : Number(y);
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  checkBoxRequiredEvent(event) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).isRequired = event.checked == undefined ? '' : event.checked;
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  isShowChkLabelEvent(event) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).isShowChkLabel = event.checked == undefined ? false : event.checked;
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  checkBoxReadOnlyEvent(event) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).readonly = event.checked == undefined ? '' : event.checked;
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeCharLimit(charLimit: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).charLimit = (charLimit == undefined || charLimit == '') ? 0 : (charLimit);
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }
  onChangeFieldName(name: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fieldName = (name != undefined && name != '') ? name : (this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fieldName);
      if (name != undefined && name != '') {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).isFieldNameChanged = true;
      }


      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }
  onChangeFontColor(color: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontColor = color == undefined ? '' : color;
      this.imagesWithFields = this.imagesWithFields;
      this.textColor = color;
    }
  }

  onChangeBackgroundColor(color: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).backgroundColor = this.hexToRGBA(color, 0.6) == undefined ? '' : this.hexToRGBA(color, 0.6);
      this.imagesWithFields = this.imagesWithFields;
      this.highLightColor = this.hexToRGBA(color, 0.2);
    }
  }

  onBrushColorChange(color: any) {
    this.brushColor = color;
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).penColor = color;
      this.imagesWithFields = this.imagesWithFields;
      //  this.highLightColor=this.hexToRGBA(color,0.2);
    }
  }

  onRotationValueChange() {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).rotation = this.rotationByDegree;
      this.imagesWithFields = this.imagesWithFields;
    }
  }
  AddBlurStyles(item:any) {
    if(((item.selectedParticipant!=undefined && item.selectedParticipant.groupRelationParticipantMappingID==0)||item.selectedParticipant==undefined ) && item.selectedValue!='' && item.selectedValue!=null && item.selectedValue!=undefined){
    const element = document.getElementById(item.id) as HTMLElement;
    // Add the 'focused' class to the element when it is focused
    this.renderer.addClass(element, 'blured');
    this.renderer.addClass(element.parentElement, 'blured');
    }
  }
  onParticipantChangeForControl(color: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      var cntrol = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant = this.selectedParticipant;
      if (cntrol.fieldTypeName == "StrikeThrough") {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCode = this.hexToRGBA(color, 0.7) == undefined ? '' : this.hexToRGBA(color, 0.7);
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCodeAlpha = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
        this.imagesWithFields = this.imagesWithFields;
      }
      if (cntrol.fieldTypeName == "HighLight") {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCode = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCodeAlpha = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
        this.imagesWithFields = this.imagesWithFields;
      }
      if (cntrol.fieldTypeName == "WhiteOut") {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCode = this.hexToRGBA(color, 0.7) == undefined ? '' : this.hexToRGBA(color, 0.7);
        this.imagesWithFields = this.imagesWithFields;
      }
      else if ((cntrol.fieldTypeName != "WhiteOut") && (cntrol.fieldTypeName != "StrikeThrough") && (cntrol.fieldTypeName != "HighLight")) {
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCode = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCodeAlpha = this.hexToRGBA(color, 0.7) == undefined ? '' : this.hexToRGBA(color, 0.7);
        this.imagesWithFields = this.imagesWithFields;
      }
    }
  }

  onParticipantCHangeForMultipleControls(color: any) {
    if (this.controlAlignArray.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.controlAlignArray.forEach(ctrl => {
        var data = ctrl;
        let ctrlId = ctrl.id;
        if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {

          var cntrol = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId);
          this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).selectedParticipant = this.selectedParticipant;
          if (cntrol.fieldTypeName == "StrikeThrough") {
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCode = this.hexToRGBA(color, 0.7) == undefined ? '' : this.hexToRGBA(color, 0.7);
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCodeAlpha = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
            this.imagesWithFields = this.imagesWithFields;
          }
          if (cntrol.fieldTypeName == "HighLight") {
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCode = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCodeAlpha = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
            this.imagesWithFields = this.imagesWithFields;
          }
          if (cntrol.fieldTypeName == "WhiteOut") {
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCode = this.hexToRGBA(color, 0.7) == undefined ? '' : this.hexToRGBA(color, 0.7);
            this.imagesWithFields = this.imagesWithFields;
          }
          else if ((cntrol.fieldTypeName != "WhiteOut") && (cntrol.fieldTypeName != "StrikeThrough") && (cntrol.fieldTypeName != "HighLight")) {
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCode = this.hexToRGBA(color, 0.3) == undefined ? '' : this.hexToRGBA(color, 0.3);
            this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == ctrlId).colorCodeAlpha = this.hexToRGBA(color, 0.7) == undefined ? '' : this.hexToRGBA(color, 0.7);
            this.imagesWithFields = this.imagesWithFields;
          }
        }
      });
    }
  }

  onChangeTextAlign(textalign: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).textalign = textalign == undefined ? '' : textalign;
      this.imagesWithFields = this.imagesWithFields;
      this.textalign = textalign;
    }
  }

  onChangeTextBoldFont(bold: any) {
    if (this.fontstyle == "bold") {
      bold = "";
    }
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontstyle = bold == undefined ? '' : bold;
      this.imagesWithFields = this.imagesWithFields;
      this.fontstyle = bold;
    }
  }

  onChangeTextItalicFont(italic: any) {
    if (this.fontweight == "italic") {
      italic = "";
    }
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontweight = italic == undefined ? '' : italic;
      this.imagesWithFields = this.imagesWithFields;
      this.fontweight = italic;
    }
  }

  onChangeTextDecoration(textdecoration: any) {
    if (this.textdecoration == "underline" || this.textdecoration == "line-through") {
      textdecoration = "";
    }
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).textdecoration = textdecoration == undefined ? '' : textdecoration;
      this.imagesWithFields = this.imagesWithFields;
      this.textdecoration = textdecoration;
    }
  }

  onChangeFontSize(event) {
    var data = this.ControlData;
    var size = event.value + "px";
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontSize = size == undefined ? '' : size;
      this.imagesWithFields = this.imagesWithFields;
    }
  }


  onChangeNumberValue(number: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedValue = number == undefined ? '' : number;
      this.imagesWithFields = this.imagesWithFields;
    }

    let finalExpression = this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).finalExpression;

    if(finalExpression && finalExpression!=undefined && finalExpression!=null && finalExpression!="" && finalExpression.length>0)
    {
      finalExpression.forEach(fex => {
        let cleanedfex=this.removeAllWhitespace(fex);
      let excontrols=this.splitExpression(cleanedfex);
      this.evaluateExpression(cleanedfex, excontrols,data);
      });
    }
  }

  onChangeDollarValue(event:any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).isDollar = event.checked == undefined ? '' : event.checked;
      this.imagesWithFields = this.imagesWithFields;
    }
  }

  onChangeFontFamily(event) {
    var data = this.ControlData;
    var family = event.value;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).fontfamily = family == undefined ? '' : family;
      this.imagesWithFields = this.imagesWithFields;
      this.fontfamily = family;
    }
  }

  onChangeImageWidth(widthImage: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).Imagewidth = widthImage == undefined ? '' : widthImage;
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  onChangeImageHeight(heightImage: any) {
    var data = this.ControlData;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).Imageheight = heightImage == undefined ? '' : heightImage;
      this.imagesWithFields = this.imagesWithFields;
      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
    }
  }

  deleteSelectedControl() {
    this.closeDetail();
    var data = this.ControlData;
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {

      var index = this.imagesWithFields.find(x => x.img == data.img).fields.map(x => {
        return x.id;
      }).indexOf(this.ControlId);

      this.imagesWithFields.find(x => x.img == data.img).fields.splice(index, 1);
      this.ShowtoolDetail = false;
    }
    if (this.controlAlignArray.find(x => x.img == data.img)) {
      var index = this.controlAlignArray.map(x => {
        return x.id;
      }).indexOf(this.ControlId);
      this.controlAlignArray.splice(index, 1);
    }
    this.checkAndUpdateFinalExpressions(this.ControlId);
  }

  showTools() {
    this.showToolsLeft = !this.showToolsLeft
  }

  close() {
    this.SignButtonEnable = false;
    this.DrawButtonEnable = false;
    this.reasonToDecline = "";
    this.declineButtonShow = false;
    this.dialog.closeAll();
  }

  saveProject(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    })
  }

  movies = [
    'Rent Agreement Exclusive',
    'Home Agreemnt Of New Property',
    'Patient Report Of Covide',
  ];

  showTemplate() {
    this.TemplateName = !this.TemplateName
  }


  addFolder(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }

  showUploadDocuments() {
    this.savePageContent();
    this._dataSharingService.sendProjectNameAlreadyExist(false);
    this.router.navigate(['/esignature/first']);
  }

  showAllParticipant() {
    this.savePageContent();
    this._dataSharingService.sendProjectNameAlreadyExist(false);
    this.router.navigate(['/esignature/second']);
  }

  showFormFinish() {
    this.savePageContent();
    if (this.stepCompleted > 3)
      this.router.navigate(['/esignature/four']);
  }

  assignUser(templateRef: TemplateRef<any>) {
    this.savePageContent();
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }

  documentPreview(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'docpreview',
    });
  }

  addRelation(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }


  // ==== For Search City/State/Zip === //

  states: string[] = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
    'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
    'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
    'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  cityOption: string[] = [];
  zipOption: any[];
  stateList: any[];
  cityValue: any;
  stateValue: any;
  zipValue: any;

  searchCity(name: any,data: any, id) {    
   var value = name
   if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
    this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
    this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;
    this.imagesWithFields = this.imagesWithFields;

    // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
     this.text = value;
   }

    var ReqModel = {
      databaseID: Number(this.databaseId),
      Name: name,
      userID: this.currentUser.UID
    }
    this.formService.searchTransCities(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.cityOption = [];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });

        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId: any) {
    if (countryId != undefined) {
      this.formService.getStateList(countryId).subscribe(response => {
        if (response != undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.stateList = [];
            if (countryId == 231 || countryId == 38) {
              response.data = response.data.filter((x) => x.abbreviation != null);
              response.data.forEach(e => {
                this.stateList.push(e.abbreviation);
              });
            } else {
              response.data.forEach(e => {
                this.stateList.push(e.stateName);
              });
            }
          }
        }
      });
    }
  }


  searchZip(zip: any, data: any, id) {
    var value = zip;
    if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
      this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
      this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = value == undefined ? '' : value;
      this.imagesWithFields = this.imagesWithFields;

      // sessionStorage.setItem('imagesWithFields',JSON.stringify(this.imagesWithFields));
      this.text = value;
    }

    var ReqModel = {
      databaseID: Number(this.databaseId),
      ZipCodeValue: zip,
      userID: this.currentUser.UID
    }
    this.formService.searchTransZip(ReqModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.zipOption = [];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  todo = [
    {
      role: 'Buyer',
      name: 'Jagdish Singh',
      email: 'jagdishk@smartdatainc.net',
      pic: '../../../../assets/images/avatars/Nancy.jpg'
    }
  ];

  done = [
    {
      role: 'Employee',
      name: 'Surender Kumar',
      email: 'surender.dz@smartdatainc.net',
      pic: '../../../../assets/images/avatars/garry.jpg'
    },
    {
      role: 'Administrator',
      name: 'Matt Maclpin',
      email: 'matt@gmail.com',
      pic: '../../../../assets/images/avatars/Copeland.jpg'
    },

  ];

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    moveItemInArray(this.movies, event.previousIndex, event.currentIndex);
  }


  peoples = [
    {
      name: 'Katina',
      email: 'Katina@gmail.com',
      img: 'Katina.jpg',
      role: 'Buyer'
    },
    {
      name: 'joyce',
      email: 'joyce@gmail.com',
      img: 'joyce.jpg',
      role: 'Doctor'
    },
    {
      name: 'Christy',
      email: 'Christy@gmail.com',
      img: 'Christy.jpg',
      role: 'Patient'
    },
    {
      name: 'garry',
      email: 'garry@gmail.com',
      img: 'garry.jpg',
      role: 'Nurse'
    },
    {
      name: 'Barrera',
      email: 'Barrera@gmail.com',
      img: 'Barrera.jpg',
      role: 'Employee'
    },
  ]


  width: number;
  height: number;
  cavasSize: number
  ImgWidth: number

  onResized1(event: ResizedEvent) {
    this.cavasSize = event.newWidth;
  }

  onResized(event: ResizedEvent) {
    this.ImgWidth = event.newWidth;
    this.width = event.newWidth / 750;
    this.height = event.newHeight;

    if (this.cavasSize < 1306) {
      this.width = 0.9
    }

    if (this.cavasSize < 1242) {
      this.width = 0.8
    }

  }
  GetAIDocuments() {
    this.loaderService.show();
    let reqModel = {
      FormID: sessionStorage.getItem('projectID'),
      FormType: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    }
    this.formService.GetAIDocuments(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.loaderService.hide();
          
          // this.toastr.success('File uploaded successfully.', '', {
          //   timeOut: 3000,
          // });
        }
        else {
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }
  DeleteAIDocuments(document:any) {
    this.loaderService.show();
    let reqModel = {
      DocumentID:document.documentID,
      JSONControlID:this.ControlId,
      FormID: sessionStorage.getItem('projectID'),
      FormType: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    }
    this.formService.DeleteAIDocuments(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
          this.showDocumentsToselectInPopup=this.AIDocuments.filter(m=>!this.selectedAIDocs.find(n=>n.documentID==m.documentID));
          this.loaderService.hide();
          
          this.toastr.success('Document unmapped successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }
  // GetResponseFromAIDocOuterForAll(allDetailsWithDocs:any) {
  //   allDetailsWithDocs.forEach(ml => {
  //     let qa:any;
  //     qa=ml
  //     this.ControlId=qa.id;
  //     this.ControlData={img:qa.img};
  //     this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes( this.ControlId));
  //     this.text=qa.question;
  //     this.GetResponseFromAIDoc([{
  //       documentPath:this.selectedAIDocs[0].documentPath
  //     }])
  //   });
   
  // }
  GetResponseFromAIDocOuter(qa:any) {
    this.ControlId=qa.id;
    this.ControlData={img:qa.img};
    this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes( this.ControlId));
    this.text=qa.question;
    this.GetResponseFromAIDoc([{
      documentPath:this.selectedAIDocs[0].documentPath
    }])
  }
  defaultFont = '14px Arial'; // Adjust this to match your editor's font as closely as possible
  editorWidth = 918; // width of your editor in pixels
  GetResponseFromAIDoc(documents:any) {
    this.loaderService.show();
    let reqModel = {
      Question:this.text,
      docPath:documents.length>0?documents[0].documentPath:'',
      CommaSeparatedListOfPages:this.Pagenumbers,
      JSONControlID:this.ControlId,
      FormID: sessionStorage.getItem('projectID'),
      FormType: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
      AIFieldArray:this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(x => x.id === this.ControlId).aiFieldArray
    }
    this.formService.GetResponseFromAIDoc(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if(this.aiDocListWithDetailForOuter)
        {
          this.aiDocListWithDetailForOuter.find(m=>m.id==this.ControlId).isCompleted=true;
        }
        this.isPasteEvent=true;
        if (response.status == this.statusConstant.statusSuccess) {
          this.aiAnswer=response.data.answer;
          var lineArray= this.formatTextForEditor(this.aiAnswer,this.editorWidth,this.defaultFont);
          this.aieditorLineCount=lineArray.length;
          this.onChangeTextAIAnswer(this.aiAnswer);
          this.toastr.success('AI response fetched successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('Error Occured.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }

  canvas: HTMLCanvasElement;

   measureText(text: string, font: string): number {
    if (!this.canvas) {
      this.canvas = document.createElement('canvas');
    }

    const context = this.canvas.getContext('2d');
    context.font = font;
    return context.measureText(text).width;
  }
  formatTextForEditor(text: string, editorWidth: number, defaultFont: string): string[] {
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';

    words.forEach(word => {
      const testLine = currentLine + word + ' ';
      const testLineWidth = this.measureText(testLine, defaultFont);

      if (testLineWidth > editorWidth && currentLine !== '') {
        lines.push(currentLine);
        currentLine = word + ' ';
      } else {
        currentLine = testLine;
      }
    });

    if (currentLine !== '') {
      lines.push(currentLine);
    }

    return lines;
  }
  
  
  MapDocToControls(doc) {
   let checkifanydocAttached= this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
    if(checkifanydocAttached.length>0)
    {
      this.toastr.warning('Kindly clear the current document mapped to the AI textbox and try mapping again', '', {
        timeOut: 5000,
      });
      return;
    }
    this.loaderService.show();
    this.formData = new FormData();
    this.formData.append('JSONControlID', this.ControlId);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('FormType', sessionStorage.getItem('type')); // 1 for Project and 2 for Template
    this.formData.append('FormID', sessionStorage.getItem('projectID'));
    this.formData.append('DocumentID', doc.documentID);
    this.formService.AddAIDocuments(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
          this.showDocumentsToselectInPopup=this.AIDocuments.filter(m=>!this.selectedAIDocs.find(n=>n.documentID==m.documentID));
          this.loaderService.hide();
          
          this.toastr.success('Document selected successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }
  LoadSelectedAIDocs(ControlId:any){
    this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(ControlId));
  }
  UploadedFilesDragZone: any = [] = [];
  formData: FormData;
  selectDocuments(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.showDocumentsToselectInPopup=this.AIDocuments.filter(m=>!this.selectedAIDocs.find(n=>n.documentID==m.documentID))
  }
  selectFilesFromDragZone(event) {
    if(event.target.files.length>1)
    {
      this.toastr.warning('Kindly upload or drag and drop only one file at a time.', '', {
        timeOut: 5000,
      });
      return;
    }
    let checkifanydocAttached= this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
    if(checkifanydocAttached.length>0)
    {
      this.toastr.warning('Kindly remove the document associated with the AI textbox and proceed with the upload process.', '', {
        timeOut: 5000,
      });
      return;
    }
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');

      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);
    }
    this.formData.append('JSONControlID', this.ControlId);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('FormType', sessionStorage.getItem('type')); // 1 for Project and 2 for Template
    this.formData.append('FormID', sessionStorage.getItem('projectID'));
    this.formService.AddAIDocuments(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          this.AIDocuments=response.data;
          this.selectedAIDocs=this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId));
          this.loaderService.hide();
          
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }

  selectFilesFromDragZoneOuter(event,aicontrolIds:any="") {
    if(event.target.files.length>1)
    {
      this.toastr.warning('Kindly upload or drag and drop only one file at a time.', '', {
        timeOut: 5000,
      });
      return;
    }
    let checkifanydocAttached= this.AIDocuments.filter(m=>m.aiTextControlID?.includes(this.ControlId) && aicontrolIds=="");
    if(checkifanydocAttached.length>0)
    {
      this.toastr.warning('Kindly remove the document associated with the AI textbox and proceed with the upload process.', '', {
        timeOut: 5000,
      });
      return;
    }
    this.loaderService.show();
    this.formData = new FormData();
    this.UploadedFilesDragZone = [];
    this.UploadedFilesDragZone = event.target.files;
    for (let i = 0; i < this.UploadedFilesDragZone.length; i++) {
      if (this.UploadedFilesDragZone[i].name.split('.')[0].length > 120) {
        this.toastr.warning('File name upto 120 characters only supported, please rename file.', '', {
          timeOut: 3000,
        });
        this.loaderService.hide();
        return;
      }
      var documenttype = "";
      var documentName = "";
      var FullPath = this.UploadedFilesDragZone[i].name;
      var newfilename = FullPath.replace(/(_\d+(\.\d+)*|\.\d+)+(?=\.pdf$)/g, '');
      var documentNameSplit = newfilename.split('.');
      documentName = documentNameSplit[0];
      documenttype = documentNameSplit[1];

      // if (documentNameSplit.length > 2) {
      //   this.toastr.warning('Please upload valid file name, please rename file.', '', {
      //     timeOut: 3000,
      //   });
      //   this.loaderService.hide();
      //   return;
      // }
      //documentName = documentName.substring(0, 30);//get first 30 chars

      this.formData.append('files', this.UploadedFilesDragZone[i]);
      this.formData.append('DocumentDetails', documenttype + '|' + '0' + '|' + '1' + '|' + documentName);
    }
    this.formData.append('JSONControlID', this.ControlId);
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('DatabaseID', this.databaseId);
    this.formData.append('FormType', sessionStorage.getItem('type')); // 1 for Project and 2 for Template
    this.formData.append('FormID', sessionStorage.getItem('projectID'));
    let idArray=aicontrolIds.map(m => m.id);
    this.formData.append('JSONControlIDList', idArray.join(','));
    this.formService.AddAIDocuments(this.formData).subscribe((response) => {
      if (response != undefined) {
        this.loaderService.hide();
        this.UploadedFilesDragZone = [];
        if (response.status == this.statusConstant.statusSuccess) {
          //this.AIDocuments=response.data;
          this.selectedAIDocsOUter=response.data;
          this.loaderService.hide();
          this.GetAIDocuments();
          this.toastr.success('File uploaded successfully.', '', {
            timeOut: 3000,
          });
        }
        else {
          this.toastr.error('File Upload failed.', '', {
            timeOut: 3000,
          });
          this.UploadedFilesDragZone = [];
          this.loaderService.hide();
        }
      } else {
        this.UploadedFilesDragZone = [];
        this.loaderService.hide();
      }
    });
  }
  retryPdfToImage(project) {
    let reqModel = {
      projectID: sessionStorage.getItem('projectID'),
      documentID: project.projectDocumentID,
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      filePath: project.documentPath,
      createdBy: this.currentUser.UID,
      // UserID: this.currentUser.UID,
      OrganizationID: Number(this.organizationId),
      DatabaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.formService.retryPdfToImage(reqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        project.pdfToImageStatus = 0;
      }
    });
  }


  savePageContent() {
    if (sessionStorage.getItem('ProjectName') == null || sessionStorage.getItem('ProjectName') == undefined || sessionStorage.getItem('ProjectName') == '') {
      this.toastr.warning('Please enter project name.', '', {
        timeOut: 2000,
      });
      return;
    }

    if (Number(sessionStorage.getItem('stepCompleted')) < 3)
      sessionStorage.setItem('stepCompleted', '3');
    //Prepare Json previously selected participant
    let findPreviouslyparticipant = this.participantArray.find(m =>
      m.documentId == this.selectedDocumentId);
    if (findPreviouslyparticipant) {
      this.participantArray.find(m => m.documentId == this.selectedDocumentId).participantJson = JSON.stringify(this.imagesWithFields);
    } else {
      this.participantArray.push({
        groupRelationParticipantMappingID: this.selectedParticipant !== null && this.selectedParticipant !== undefined ? this.selectedParticipant.groupRelationParticipantMappingID : 0,
        participantJson: JSON.stringify(this.imagesWithFields),
        documentId: this.selectedDocumentId,
        projectParticipantJsonID: 0
      })
    }
    let ReqModel = {
      participantJsons: this.participantArray,
      ProjectName: sessionStorage.getItem('ProjectName'),
      projectID: sessionStorage.getItem('projectID'),
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type: Number(sessionStorage.getItem('type')), // 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.formService.AddParticipantJsonStep3(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  fillForms(templateRef: TemplateRef<any>) {
    this.showDataFrom3C=true;
    this.showDataFromMyDrive=false;
    if (this.showAllRequiredControls) {
      this.highlightRequiredControls(false);
    }
    this.particiantJsonListAutoFill = [];
    this.particiantJsonListAutoFillCore = [];
    this.particiantJsonListAutoFillCom = [];
    this.groupRelationParticipantId = this.selectedParticipant.groupRelationParticipantMappingID;
    let counter = 0;
    // Put non selected docs in array for cancel functionality
    this.nonSelectedDocJsonList = [];
    this.participantArray.forEach(ml => {
      if (this.selectedDocumentId !== ml.documentId) {
        this.nonSelectedDocJsonList.push({ participantJson: JSON.parse(ml.participantJson), documentID: ml.documentId });
      }
    });


    let contactfieldCount = false;
    let contactFolder: any = [];

    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));
    let contactUniqueFields = [];
    this.participantArray.forEach(ml => {
      let currentJsonArray: any = [];
      if (this.selectedDocumentId == ml.documentId)
        currentJsonArray = JSON.parse(JSON.stringify(this.imagesWithFields));
      else
        currentJsonArray = JSON.parse(ml.participantJson);
      currentJsonArray.forEach(page => {
        page.fields = page.fields.filter(x => x.folderID == contactFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID == undefined || x.selectedParticipant?.groupRelationParticipantMappingID == 0 || x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId));
        let fieldHolder: any = [];
        page.fields.forEach(elem => {
          if (fieldHolder.length == 0 && !contactUniqueFields.find(k => k.fieldName == elem.fieldName && elem.folderID == contactFolder[0].folderID)) {
            fieldHolder.push(elem);
            contactUniqueFields.push(elem);
          }
          else if (!contactUniqueFields.find(k => k.fieldName == elem.fieldName && elem.folderID == contactFolder[0].folderID)) {
            fieldHolder.push(elem);
            contactUniqueFields.push(elem);
          }
          contactfieldCount = true;

        });
        page.fields = fieldHolder;
      });
      if (this.particiantJsonListAutoFill.length == 0)
        this.particiantJsonListAutoFill = currentJsonArray;
      else {
        currentJsonArray.forEach(vb => {
          this.particiantJsonListAutoFill.push(vb)
        });

      }
    });
    if (!contactfieldCount) {
      this.particiantJsonListAutoFill = [];
    }

    let corefieldCount = false;
    let coreUniqueFields = [];
    let coretFolder: any = []; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));
    this.participantArray.forEach(ml => {
      let currentJsonArray: any = [];
      if (this.selectedDocumentId == ml.documentId)
        currentJsonArray = JSON.parse(JSON.stringify(this.imagesWithFields));
      else
        currentJsonArray = JSON.parse(ml.participantJson);

      currentJsonArray.forEach(page => {
        page.fields = page.fields.filter(x => x.folderID == coretFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID == undefined || x.selectedParticipant?.groupRelationParticipantMappingID == 0 || x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId));
        let fieldHolder: any = [];
        page.fields.forEach(elem => {
          if (fieldHolder.length == 0 && !coreUniqueFields.find(k => k.fieldName == elem.fieldName && elem.folderID == coretFolder[0].folderID)) {
            fieldHolder.push(elem);
            coreUniqueFields.push(elem);
          }
          else if (!coreUniqueFields.find(k => k.fieldName == elem.fieldName && elem.folderID == coretFolder[0].folderID)) {
            fieldHolder.push(elem);
            coreUniqueFields.push(elem);
          }
          corefieldCount = true;
        });
        page.fields = fieldHolder;
      });
      if (this.particiantJsonListAutoFillCore.length == 0)
        this.particiantJsonListAutoFillCore = currentJsonArray;
      else {
        currentJsonArray.forEach(vb => {
          this.particiantJsonListAutoFillCore.push(vb)
        });

      }
    });

    if (!corefieldCount) {
      this.particiantJsonListAutoFillCore = [];
    }
    //

    //
    let comfieldCount = false;
    let comUniqueFields = [];
    let comFolder: any = [];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Company));
    this.participantArray.forEach(ml => {
      let currentJsonArray: any = [];
      if (this.selectedDocumentId == ml.documentId)
        currentJsonArray = JSON.parse(JSON.stringify(this.imagesWithFields));
      else
        currentJsonArray = JSON.parse(ml.participantJson);

      currentJsonArray.forEach(page => {
        page.fields = page.fields.filter(x => x.folderID == comFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID == undefined || x.selectedParticipant?.groupRelationParticipantMappingID == 0 || x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId));
        let fieldHolder: any = [];
        page.fields.forEach(elem => {
          if (fieldHolder.length == 0 && !comUniqueFields.find(k => k.fieldName == elem.fieldName && elem.folderID == comFolder[0].folderID)) {
            fieldHolder.push(elem);
            comUniqueFields.push(elem);
          }
          else if (!comUniqueFields.find(k => k.fieldName == elem.fieldName && elem.folderID == comFolder[0].folderID)) {
            fieldHolder.push(elem);
            comUniqueFields.push(elem);
          }
          comfieldCount = true;
        });
        page.fields = fieldHolder;
      });
      if (this.particiantJsonListAutoFillCom.length == 0)
        this.particiantJsonListAutoFillCom = currentJsonArray;
      else {
        currentJsonArray.forEach(vb => {
          this.particiantJsonListAutoFillCom.push(vb)
        });

      }
    });
    if (!comfieldCount) {
      this.particiantJsonListAutoFillCom = [];
    }
    //
    this.particiantJsonListAutoFillBeforFill = this.particiantJsonListAutoFill;
    this.particiantJsonListAutoFillCoreBeforFill = this.particiantJsonListAutoFillCore;
    this.particiantJsonListAutoFillComBeforFill = this.particiantJsonListAutoFillCom;
    if (this.particiantJsonListAutoFill.length > 0 && this.groupRelationParticipantId != "0") {
      this.openPanel = 1;
    }
    else if (this.particiantJsonListAutoFillCore.length > 0) {
      this.openPanel = 2;
    }
    else if (this.particiantJsonListAutoFillCom.length > 0) {
      this.openPanel = 3;
    }
    if (this.particiantJsonListAutoFill.length == 0 && this.particiantJsonListAutoFillCore.length == 0) {
     // return;
    }
    if ((contactfieldCount && this.groupRelationParticipantId != "0") || corefieldCount || comfieldCount) {
      this.beforeFillForm = JSON.parse(JSON.stringify(this.imagesWithFields));
      // const dialogRef = this.dialog.open(templateRef, {
      //   panelClass: 'task_template',
      // });
      // this.dialog.open(templateRef, {
      //   panelClass: 'selectParticipants',
      // });
    }
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'autoFill-modalbox',
    });
  }

  onAutoFillChanged(event) {
    this.autoFill = true;
    this.getFieldValuesForAutoFill();
    this.getFieldValuesForAutoFillCore();
  }

  getFieldValuesForAutoFill() {
    let reqModel = {
      groupParticipantRelationId: this.groupRelationParticipantId,
      databaseID: this.databaseId,
      organizationID: this.organizationId,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    };

    let contactFolder: any = []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Contact));
    this.formsService.getFieldValuesForAutoFill(reqModel).subscribe(response => {
      this.autofillvalues = response.data;
      this.particiantJsonListAutoFill.map((entry) => {
        entry.fields.filter(x => x.folderID == contactFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId).forEach((field) => {
          if (field.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.chkSelectedValues.length == 0)
                  field.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName == "radio" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.rbSelectedValues.length == 0)
                  field.rbSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.rbSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName === "MultiSelect") {
            if (
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== undefined &&
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== '') {
              if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.length > 0)
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue?.split(',');
            }
            else {
              field.selectedValue = [];
            }
          }
          else if (field.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 0 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 3 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;

          }
          else if (field.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 2 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 4 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
            field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;

        });
      });

      this.imagesWithFields.map((entry) => {
        entry.fields.filter(x => x.folderID == contactFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId).forEach((field) => {
          if (field.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.chkSelectedValues.length == 0)
                  field.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName == "radio" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.rbSelectedValues.length == 0)
                  field.rbSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.rbSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName === "MultiSelect") {
            if (
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== undefined &&
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== '') {
              if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.length > 0)
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue?.split(',');
            }
            else {
              field.selectedValue = [];
            }
          }
          else if (field.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 0 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 3 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;

          }
          else if (field.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {

            if (field.childFieldType === 2 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 4 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "Date" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
            field.selectedValue = this.autofillvalues.find(d => d.fieldName === "Date" && d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
            field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;

        });
      });
      // auto fill other jsons and save

      this.participantArray.forEach(ml => {
        let jsonelement: any;
        if (this.selectedDocumentId !== ml.documentId) {
          jsonelement = JSON.parse(ml.participantJson);

          jsonelement.map((entry) => {
            entry.fields.filter(x => x.folderID == contactFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId).forEach((field) => {
              if (field.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
                field.defaultValue.split(',').forEach((value, key) => {
                  if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                    this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                    if (field.chkSelectedValues.length == 0)
                      field.chkSelectedValues.push("ctrl-" + (key));
                    else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                      field.chkSelectedValues.push("ctrl-" + (key));
                    }
                  }
                })
              }
              if (field.fieldTypeName == "radio" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
                field.defaultValue.split(',').forEach((value, key) => {
                  if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                    this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                    if (field.rbSelectedValues.length == 0)
                      field.rbSelectedValues.push("ctrl-" + (key));
                    else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                      field.rbSelectedValues.push("ctrl-" + (key));
                    }
                  }
                })
              }
              if (field.fieldTypeName === "MultiSelect") {
                if (
                  this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== undefined &&
                  this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== '') {
                  if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.length > 0)
                    field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
                  else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                    field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue?.split(',');
                }
                else {
                  field.selectedValue = [];
                }
              }
              else if (field.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 0 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 3 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;

              }
              else if (field.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 2 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 4 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
              }
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;

            });
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }

      });
    });
  }



  getFieldValuesForAutoFillCore() {
    let coretFolder: any = []; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n => n.name == ModuleName.Core));

    let reqModel = {
      groupParticipantRelationId: this.projectParticipantsList.find(m => m.groupRelationParticipantMappingID > 0).groupRelationParticipantMappingID,
      databaseID: this.databaseId,
      organizationID: this.organizationId,
      folderID: coretFolder[0].folderID,
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    };
    this.formsService.getFieldValuesForAutoFillCore(reqModel).subscribe(response => {
      this.autofillvalues = response.data;
      this.particiantJsonListAutoFillCore.map((entry) => {
        entry.fields.filter(x => x.folderID == coretFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId || x.selectedParticipant?.groupRelationParticipantMappingID == 0)).forEach((field) => {
          if (field.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.chkSelectedValues.length == 0)
                  field.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName == "radio" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.rbSelectedValues.length == 0)
                  field.rbSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.rbSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName === "MultiSelect") {
            if (
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== undefined &&
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== '') {
              if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.length > 0)
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue?.split(',');
            }
            else {
              field.selectedValue = [];
            }
          }
          else if (field.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 0 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 3 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;

          }
          else if (field.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 2 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 4 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "Company") {
            field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
            field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;

        });
      });

      this.imagesWithFields.map((entry) => {
        entry.fields.filter(x => x.folderID == coretFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId || x.selectedParticipant?.groupRelationParticipantMappingID == 0)).forEach((field) => {
          if (field.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.chkSelectedValues.length == 0)
                  field.chkSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.chkSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName == "radio" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
            field.defaultValue.split(',').forEach((value, key) => {
              if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                if (field.rbSelectedValues.length == 0)
                  field.rbSelectedValues.push("ctrl-" + (key));
                else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                  field.rbSelectedValues.push("ctrl-" + (key));
                }
              }
            })
          }
          if (field.fieldTypeName === "MultiSelect") {
            if (
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== undefined &&
              this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== '') {
              if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.length > 0)
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue?.split(',');
            }
            else {
              field.selectedValue = [];
            }
          }
          else if (field.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 0 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 3 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;

          }
          else if (field.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 2 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
          }
          else if (field.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
            if (field.childFieldType === 4 || field.childFieldType == undefined)
              field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
          }
          else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
            field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;

        });
      });
      // auto fill other jsons and save
      this.participantArray.forEach(ml => {
        let jsonelement: any;
        if (this.selectedDocumentId === ml.documentId) {
          jsonelement = JSON.parse(ml.participantJson);

          jsonelement.map((entry) => {
            entry.fields.filter(x => x.folderID == coretFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId || x.selectedParticipant?.groupRelationParticipantMappingID == 0)).forEach((field) => {
              if (field.fieldTypeName == "Checkbox" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
                field.defaultValue.split(',').forEach((value, key) => {
                  if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                    this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                    if (field.chkSelectedValues.length == 0)
                      field.chkSelectedValues.push("ctrl-" + (key));
                    else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                      field.chkSelectedValues.push("ctrl-" + (key));
                    }
                  }
                })
              }
              if (field.fieldTypeName == "radio" && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '') {
                field.defaultValue.split(',').forEach((value, key) => {
                  if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue != '' &&
                    this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.split(',').find(m => m == value) == value) {
                    if (field.rbSelectedValues.length == 0)
                      field.rbSelectedValues.push("ctrl-" + (key));
                    else if (!field.chkSelectedValues.find(m => m == "ctrl-" + (key))) {
                      field.rbSelectedValues.push("ctrl-" + (key));
                    }
                  }
                })
              }
              if (field.fieldTypeName === "MultiSelect") {
                if (
                  this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== undefined &&
                  this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue !== '') {
                  if (Array.isArray(this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue) && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue.length > 0)
                    field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;
                  else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                    field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue?.split(',');
                }
                else {
                  field.selectedValue = [];
                }
              }
              else if (field.fieldName === "Address" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 0 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 0 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldName === "City" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 3 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 3 && d.fieldValue != "")?.fieldValue;

              }
              else if (field.fieldName === "State" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 2 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 2 && d.fieldValue != "")?.fieldValue;
              }
              else if (field.fieldName === "Zip" && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue !== '') {
                if (field.childFieldType === 4 || field.childFieldType == undefined)
                  field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID && d.childFieldType == 4 && d.fieldValue != "")?.fieldValue;
              }
              else if (this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== undefined && this.autofillvalues.find(d => d.fieldID == field.fieldID)?.fieldValue !== '')
                field.selectedValue = this.autofillvalues.find(d => d.fieldID == field.fieldID && d.folderID == field.folderID)?.fieldValue;

            });
          });

          ml.participantJson = JSON.stringify(jsonelement);
        }
      });
    });
  }

  GetMultiSelectConvertedValue(val, item, multiVal) {
    if (multiVal != "" && !Array.isArray(multiVal) && multiVal != undefined && multiVal.split(',').length > 0) {
      multiVal = multiVal.split(',');
      multiVal.push(val);
    }
    else if ((multiVal == "" || multiVal == undefined) && !Array.isArray(multiVal)) {
      multiVal = []
      multiVal.push(val);
    }
    else if (multiVal != "" && Array.isArray(multiVal) && multiVal != undefined) {
      multiVal.push(val);
    }
    else if (multiVal == "" && Array.isArray(multiVal) && multiVal != undefined) {
      multiVal.push(val);
    }
    return multiVal;

  }

  RemoveMultiSelectConvertedValue(val, item, multiVal) {
    if (multiVal != "" && !Array.isArray(multiVal) && multiVal != undefined && multiVal.split(',').length > 0) {
      multiVal = multiVal.split(',');
      multiVal = multiVal.filter(m => m != val)
    }
    else if (multiVal != "" && Array.isArray(multiVal) && multiVal != undefined) {
      multiVal = multiVal.filter(m => m != val)
    }
    return multiVal;
  }

  AddMultiSelectItem(val, item) {
    let multiVal = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue

    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.GetMultiSelectConvertedValue(val, item, multiVal);
    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.filter(m => m.val != val);
    this.imagesWithFields = JSON.parse(JSON.stringify(this.imagesWithFields));
    this.multiSelectCurrentItem = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id);
    // auto fill other jsons and save
    this.participantArray.forEach(ml => {
      let jsonelement: any;
      if (this.selectedDocumentId === ml.documentId) {
        jsonelement = JSON.parse(ml.participantJson);

        if (jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id) != undefined) {
          let multiValjson = jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.GetMultiSelectConvertedValue(val, item, multiValjson);
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList = jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.filter(m => m.val != val);

          ml.participantJson = JSON.stringify(jsonelement);
        }
      }
    });
  }

  removeMultiSelectItem(val, item) {
    let multiVal = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue;
    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.RemoveMultiSelectConvertedValue(val, item, multiVal);
    this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.push({
      "id": "ctrl-0",
      "val": val,
      "offsetX": 573,
      "offsetY": 387
    });
    this.multiSelectCurrentItem = this.imagesWithFields.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id);
    // auto fill other jsons and save
    this.participantArray.forEach(ml => {
      let jsonelement: any;
      if (this.selectedDocumentId === ml.documentId) {
        jsonelement = JSON.parse(ml.participantJson);
        if (jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id) != undefined) {
          let multiValjson = jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue;
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).selectedValue = this.RemoveMultiSelectConvertedValue(val, item, multiValjson);
          jsonelement.find(x => x.img == this.ctrlImg).fields.find(m => m.id == item.id).fillList.push({
            "id": "ctrl-0",
            "val": val,
            "offsetX": 573,
            "offsetY": 387
          });
          ml.participantJson = JSON.stringify(jsonelement);
        }
      }
    });
  }

  keyPress(event) {
    this.declineButtonShow = true;
  }

  convertRBA2RGB(colourCode) {
    let colorcodes = [];
    if (colourCode == "" || colourCode == undefined || colourCode == null) {
      colourCode = "215, 245, 255, 1";
    }
    if (colourCode != "" || colourCode != undefined || colourCode != null) {
      colorcodes = colourCode.split(',');
      colorcodes.pop();
      return colorcodes.join(',');
    }
    else {
      return colourCode;
    }
  }

  filedsForFillForm(fields) {
    return fields.filter(x => x.folderName != '');
  }

  verifyParticipant(field: any, event: any) {
    let fieldVal = false;
    if (!this.IsSigningComplete) {
      //
      if (field.fieldTypeName == "Checkbox") {
        if (field.chkSelectedValues != undefined && field.chkSelectedValues.length > 0)
          fieldVal = true;
      }
      if (field.fieldTypeName == "radio") {
        if (field.rbSelectedValues != undefined && field.rbSelectedValues.length > 0)
          fieldVal = true;

      }
      if (field.fieldTypeName === "MultiSelect") {
        if (field.selectedValue != "" && !Array.isArray(field.selectedValue) && field.selectedValue != undefined && field.selectedValue.split(',').length > 0)
          fieldVal = true;
        else if (field.selectedValue != "" && Array.isArray(field.selectedValue) && field.selectedValue != undefined && field.selectedValue.length > 0) {
          fieldVal = true;
        }
      }
      else {
        if (field.selectedValue != "" && field.selectedValue != undefined)
          fieldVal = true;
      }
      //
      if (field.selectedParticipant != undefined) {
        if ((field.selectedParticipant?.groupRelationParticipantMappingID != this.groupRelationParticipantId)
          && (field.selectedParticipant?.groupRelationParticipantMappingID != 0)) {
          this.ShowtoolDetail = false;
          field.isControlEnabled = true;
          event.preventDefault();
        }
        else if (field.selectedParticipant?.groupRelationParticipantMappingID == 0) {
          field.isControlEnabled = false;
          if (field.selectedParticipant?.groupRelationParticipantMappingID == 0) {
            if (field.selectedValue === "")
              this.assignFilledUnassignedControls(field);
          }
        }
        else {
          field.isControlEnabled = false;
        }
      }
      else {
        field.isControlEnabled = false;
        if (field.selectedParticipant?.groupRelationParticipantMappingID == 0) {
          if (!fieldVal)
            this.assignFilledUnassignedControls(field);
        }
      }

    } else {
      this.ShowtoolDetail = false;
      field.isControlEnabled = true;
      event.preventDefault();
    }
  }

  openInDevice: boolean = false;

  closeDetail() {
    this.ShowtoolDetail = !this.ShowtoolDetail;
    this.openInDevice = false;
  }

  opentoolDetailDevice() {
    this.openInDevice = true;
  }

  setTabIndex(pageIndex, controlIndex) {
    if (pageIndex > 0) {
      return this.imagesWithFields[pageIndex - 1]?.fields?.length + controlIndex;
    }
    else {
      return controlIndex;
    }
  }

  assignFilledUnassignedControls(fieldentry) {
    if ((fieldentry.fieldTypeName == "Number") || (fieldentry.fieldTypeName == "Textarea") || (fieldentry.fieldTypeName == "Textbox") || (fieldentry.fieldTypeName == "Dropdown")) {
      if (fieldentry.selectedValue != "") {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if ((fieldentry.fieldTypeName == "CheckBoxGroup") || (fieldentry.fieldTypeName == "Checkbox")) {
      if (fieldentry.chkSelectedValues.length > 0) {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if ((fieldentry.fieldTypeName == "Radio")) {
      if (fieldentry.rbSelectedValues.length > 0) {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if (fieldentry.fieldTypeName == "Location") {
      if ((fieldentry.Lat != "") && (fieldentry.Long != "")) {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if (fieldentry.fieldTypeName == "Signature") {
      if (fieldentry.signatureBase64 != "") {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if (fieldentry.fieldTypeName == "Initials") {
      if (fieldentry.ImageData != "") {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if (fieldentry.fieldTypeName == "Image") {
      if (fieldentry.ImageData.lenth) {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if (fieldentry.fieldTypeName == "File") {
      if (fieldentry.FileData != "") {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    else if (fieldentry.fieldTypeName == "Draw") {
      if (fieldentry.drawBase64 != "") {
        fieldentry["selectedParticipant"] = { groupRelationParticipantMappingID: this.groupRelationParticipantId }
      }
    }
    fieldentry["colorCode"] = "215, 245, 255, 1";
  }

  cancelFillForm() {
    if(this.beforeFillForm!=undefined){
      this.particiantJsonListAutoFill = this.beforeFillForm;
      this.imagesWithFields.forEach(element => {
        element.fields.forEach(fe => {
          if (this.beforeFillForm.find(m => m.img === element.img).fields.find(me => me.folderID === fe.folderID && fe.fieldName === me.fieldName)) {
            if (this.beforeFillForm.find(m => m.img === element.img).fields.find(me => me.folderID === fe.folderID && fe.fieldName === me.fieldName && fe.id === me.id) != undefined) {
  
              fe.selectedValue = this.beforeFillForm.find(m => m.img === element.img).fields.find(me => me.folderID === fe.folderID && fe.fieldName === me.fieldName && fe.id === me.id).selectedValue;
              fe.chkSelectedValues = this.beforeFillForm.find(m => m.img === element.img).fields.find(me => me.folderID === fe.folderID && fe.fieldName === me.fieldName && fe.id === me.id).chkSelectedValues;
              fe.rbSelectedValues = this.beforeFillForm.find(m => m.img === element.img).fields.find(me => me.folderID === fe.folderID && fe.fieldName === me.fieldName && fe.id === me.id).rbSelectedValues;
            }
            else {
            }
          }
        });
      });
      this.nonSelectedDocJsonList.forEach(ml => {
        this.participantArray.find(m => m.documentId == ml.documentID).participantJson = JSON.stringify(ml.participantJson);
      });
      this.dialog.closeAll();
    }else{
      this.dialog.closeAll();
    }
    
  }

  isControlHide = false;

  hideControls(){
    let aiDocListWithDetailForOuter1=[];
    this.imagesWithFields.forEach(element => {
      element.fields.forEach(fe => {
           if(fe.fieldTypeName=="AITextBox")
           {
               aiDocListWithDetailForOuter1.push({
                id:fe.id,
                question:fe.aiQuestion,
                img:element.img
                });
           }
      });
    });
    aiDocListWithDetailForOuter1.forEach(element => {
      
    
    let h1= (((document.getElementById(element.id)).childNodes[2]).childNodes[1]).childNodes[0] as HTMLElement
         if(h1.style.display=='' || h1.style.display=='block')
         {
          h1.setAttribute('style', 'display:none');
         }
         else
         {
          h1.setAttribute('style', 'display:block');
         }

    let h2= (((document.getElementById(element.id)).childNodes[2]).childNodes[1]).childNodes[2] as HTMLElement
        if(h2.style.display=='' || h2.style.display=='block')
         {
          h2.setAttribute('style', 'display:none');
         }
         else
         {
          h2.setAttribute('style', 'display:block');
         }
        });
  }







 
  ///============= Bind Feild =======================//

  openbindFieldsDetail: boolean = false;
  @Output() openBindFieldDetail = new EventEmitter<boolean>();  
  openAIDetail: any;
  showBindField:boolean=false;
  folderID:number=0;
  mainModuleNameForms:string="Forms";
  ExtractDocumentField:any=[]=[];

  openAIBinding(){   
    this._dataSharingService.sendSelectedDocForBindAIForms(this.ExtractDocumentField);
    this.openbindFieldsDetail=true;
    this.openBindFieldDetail.emit(true);   
  }

   /* AI DETAL OPEN/CLOSE */
   getAIDetail(message: boolean) {
    this.openAIDetail = message;
  }

  getCloseBindFieldDetail() {
    this.openbindFieldsDetail = false;
  }

  updateFieldMappingJson(result){
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var data = [];
    data = menuModulesList.filter(x => x.mainModuleName === "Core");
    if (data.length > 0) {
      var folderId = data[0].folderID;
    }

    if(result.length>0){
      var check=[];
      check = result.filter(x=> x.fieldID>0);
      if(check.length>0){
        for (let i = 0; i < check.length; i++){
          this.imagesWithFields.find(x => x.img == check[i].imageUrl).fields.find(m => m.id == check[i].id).fieldID= check[i].fieldID;
          this.imagesWithFields.find(x => x.img == check[i].imageUrl).fields.find(m => m.id == check[i].id).folderID= folderId;
          this.imagesWithFields.find(x => x.img == check[i].imageUrl).fields.find(m => m.id == check[i].id).folderName= "Core";
        }
       }
    }
  }

  filterList(event: any) {
    const searchTerm = event.target.value.toLowerCase();
  // this.aICoreFields=this.corefieldsListAI.filter(m=>m.fieldName.toLowerCase().includes(searchTerm));
    
   // Normalize the search term by removing spaces and converting to lowercase
  const normalizedFilterValue = searchTerm.replace(/\s+/g, '').toLowerCase();

  // Assuming 'data' is the array of items you are filtering
  this.aICoreFields = this.corefieldsListAI.filter(item => {
    // Assuming 'healthCardField' is the property you want to search in
    const normalfieldName = item.fieldName.replace(/\s+/g, '').toLowerCase();

    return normalfieldName.includes(normalizedFilterValue);
  });
  }
  
 
  showDropdown: boolean = false;
  cursorPosition: number = 0;
  justTypedCurlyBrace: boolean = false;
  
  onKeyUp(event: KeyboardEvent) {
    this.cursorPosition = (event.target as HTMLTextAreaElement).selectionStart;
    if (event.key === '{') {
      this.justTypedCurlyBrace = true;
      this.showDropdown = true;
    } else {
      this.justTypedCurlyBrace = false;
      this.updateDropdownVisibility();
    }
  }
  
  updateCursorPosition(event: any) {
    this.aifilterfieldSearch="";
    this.aICoreFields = this.corefieldsListAI;
    this.cursorPosition = event.target.selectionStart;
    this.updateDropdownVisibility();
  }
  
  // selectValue(field: any) {
  //   const textBeforeCursor = this.text.substring(0, this.cursorPosition);
  //   const lastCurlyBraceBeforeCursor = textBeforeCursor.lastIndexOf('{');
  //   const textAfterCurlyBrace = this.text.substring(lastCurlyBraceBeforeCursor);
  
  //   const match = textAfterCurlyBrace.match(/\{[\w]*/);
  //   if (match) {
  //     this.text = textBeforeCursor.substring(0, lastCurlyBraceBeforeCursor)
  //                 + '{' + field.fieldName + '}' // Now wraps the value in curly braces
  //                 + this.text.substring(lastCurlyBraceBeforeCursor + match[0].length);
  //   }
  
  //   this.justTypedCurlyBrace = false;
  //   this.showDropdown = false;
  // }

  // selectValue(field: any) {
  //   const textBeforeCursor = this.text.substring(0, this.cursorPosition);
  //   const lastCurlyBraceBeforeCursor = textBeforeCursor.lastIndexOf('{');
  //   const textAfterCurlyBrace = this.text.substring(lastCurlyBraceBeforeCursor);
  
  //   // Match the pattern including the closing brace if it exists
  //   const match = textAfterCurlyBrace.match(/\{[\w]*\}?/);
  //   if (match) {
  //     // Check if there's a closing brace and include it in the replacement if so
  //     const includeClosingBrace = match[0].endsWith('}') ? '}' : '';
  //     this.text = textBeforeCursor.substring(0, lastCurlyBraceBeforeCursor) 
  //                 + '{' + field.fieldName + includeClosingBrace 
  //                 + this.text.substring(lastCurlyBraceBeforeCursor + match[0].length);
  //   }
  
  //   this.justTypedCurlyBrace = false;
  //   this.showDropdown = false;
  // }

  selectValue(field: any) {
if( this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(x => x.id === this.ControlId).aiFieldArray==undefined ||  this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(x => x.id === this.ControlId).aiFieldArray==null)
{
  this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(x => x.id === this.ControlId).aiFieldArray=[];
}
    this.imagesWithFields.find(x => x.img == this.ControlData.img).fields.find(x => x.id === this.ControlId).aiFieldArray.push({
      fieldID:field.fieldID,
      fieldName:field.fieldName
    });

    this.aICoreFields=this.corefieldsListAI;
    const textBeforeCursor = this.text.substring(0, this.cursorPosition);
    const lastCurlyBraceBeforeCursor = textBeforeCursor.lastIndexOf('{');
  
    // Check if there is a closing curly brace after the last '{'
    const indexOfClosingBrace = this.text.indexOf('}', lastCurlyBraceBeforeCursor);
    const textAfterCursor = this.text.substring(this.cursorPosition);
    const cursorInsideBraces = indexOfClosingBrace >= this.cursorPosition;
  
    // Determine the text to replace based on cursor position
    let textToReplace = '';
    if (cursorInsideBraces) {
      // Cursor is between the curly braces
      const textInsideBraces = this.text.substring(lastCurlyBraceBeforeCursor, indexOfClosingBrace + 1);
      textToReplace = textInsideBraces;
    } else {
      // Cursor is after an open curly brace without a closing brace
      const match = /\{[\w]*\}?/.exec(this.text.substring(lastCurlyBraceBeforeCursor));
      if (match) {
        textToReplace = match[0];
      }
    }
  
    // Replace the determined text with the new value
    if (textToReplace) {
      this.text = textBeforeCursor.substring(0, lastCurlyBraceBeforeCursor) +
                  '{' + field.fieldName + '}' +
                  this.text.substring(lastCurlyBraceBeforeCursor + textToReplace.length);
    }
    this.onChangeTextAIQestion(this.text);
    this.justTypedCurlyBrace = false;
    this.showDropdown = false;
  }
  
  
  
  
  private updateDropdownVisibility() {
    if(this.text==undefined)
    {
      this.text="";
    }
    const textBeforeCursor = this.text.substring(0, this.cursorPosition);
    const lastCurlyBraceBeforeCursor = textBeforeCursor.lastIndexOf('{');
    // The dropdown shows if there is an opening curly brace without a closing one
    const hasClosingCurlyBrace = textBeforeCursor.indexOf('}', lastCurlyBraceBeforeCursor) > -1;
    this.showDropdown = lastCurlyBraceBeforeCursor >= 0 && !hasClosingCurlyBrace;
  }

  showMappingDetail = false;
  openMappingSlide(){
    this.showMappingDetail = !this.showMappingDetail;
  }

  ImportMyDriveList() {
    const dialogRef = this.dialog.open(ImportMyDriveListComponent, {     
      data: {
        moduleName: "Forms",
        //selectedRecord: this.selectedRecordDeleteArray,
        panelClass: 'task_template',
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if(result!=null && result!=undefined){
      }
      if(result=="Added"){
        //this.SendtoAttachToTaskList.emit(true);
        //this.recordAddedForTaskList();
      }
    });   
  }


  //======== For My Drive ======//

  activeNode: string = "";
  hierarchyList: any;
  breadCrumMenu: any = [];
  FormsubFolderFolderList: any;
  selectButtonShow: boolean = false;
  isShowForm: any = true;
  isSharedWithMe: any = false;
  SharedWithMeactive: boolean = false;
  menuHeaderMyDrive: any=[]=[];
  menuHeader: any=[]=[];

  FormFolderList: any;
  FormFolderListMiddleSection: any = ([] = []);

  MyDrivefoldersList: any;
  activeNodeFileManager: string = ""; 
  FileManagerFolderListLeft: any;
  fileManagerID: string = "";
  foldersMyDriveListShow: boolean = false;
  selectButtonMyDriveShow: boolean = false;

  isShowMyDrive: any = false;
  isSharedWithMeMyDrive: any = false;
  parentID: number = 0;
  SharedWithMeFormFolderList: any = [] = [];
  SharedWithMeMyDriveFolderList: any = [] = [];
  SharedWithMeMyDriveactive: boolean = false;
  responseHolder: any;

  getFileManagerFolderList() {
    var reqModel = {
      folderID: 0,
      folderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList
    }
    this.settingsService.getFoldersListForFML(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.FileManagerFolderListLeft = this.responseHolder.data.data;
          if (this.FileManagerFolderListLeft != null && this.FileManagerFolderListLeft != undefined) {
            this.dataSourceFileManager.data = this.FileManagerFolderListLeft;
          }
        }
        else {
        }
      }
      else {
      }
    });

  }

  getFileManagerFoldersList(folderId) {
    var reqModel = {
      fileManagerItemID: folderId,
      name: this.searchKey,
      pageIndex: 0,
      pageSize: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
    }
    this.loaderService.show();
    this.settingsService.FileManagerItemsWithHierarchy(reqModel).subscribe(response => {
      this.loaderService.hide();
      if (response.status == this.statusConstant.statusSuccess) {
        this.MyDrivefoldersList = response.data.children;
        this.hierarchyList = response.data.hierarchy;
        if (this.hierarchyList == null || this.hierarchyList == null) {
          this.menuHeaderMyDrive = [];
        } else {
          this.menuHeaderMyDrive = [];
          this.hierarchyList.forEach(e => {
            this.menuHeaderMyDrive.push({ label: e.name, id: e.fileManagerItemID, icon: 'navigate_next' });
          });
        }

        this.MyDrivefoldersList.forEach(e => {
          e.isChecked = false;
        });
        if (this.MyDrivefoldersList == null || this.MyDrivefoldersList.length == 0) {
          this.MyDrivefoldersList = [];
          this.foldersMyDriveListShow = true;
        } else {
          this.foldersMyDriveListShow = false;
        }
      }
    });
  }
  
  GetAllMyDrive() {
    this.searchKey="";
    this.activeNodeFileManager = "";
    this.dataSourceFileManager.data = [];
    this.selectButtonMyDriveShow = false;
    this.isShowMyDrive = true;
    this.isShowForm = false;
    this.isSharedWithMe = false;
    this.isSharedWithMeMyDrive = false;
    this.SharedWithMeactive = false;
    this.SharedWithMeMyDriveactive = false;
    this.menuHeader = [];
    this.menuHeaderMyDrive = [];
    this.getFileManagerFoldersList(0);
    this.getFileManagerFolderList();
  }
 

  showChildFolders(folder) {
    this.isShowMyDrive = true;
    this.isSharedWithMeMyDrive = false;
    this.selectButtonMyDriveShow = false;
    this.SharedWithMeMyDriveactive = false;
    this.activeNodeFileManager = folder.fileManagerItemID;
    this.getFileManagerFoldersList(folder.fileManagerItemID);
  }


  getSharedWithMeMyDrive() {
    var ReqModel = {
      fileManagerItemID: 0,
      name: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      permissionType: 0
    }
    this.settingsService.GetSharedWithMeFileManager(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.SharedWithMeMyDriveFolderList = this.responseHolder.data;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
        else {
          this.selectButtonMyDriveShow = false;
          this.isShowForm = false;
          this.isSharedWithMe = false;
          this.isShowMyDrive = false;
          this.isSharedWithMeMyDrive = true;
          this.SharedWithMeactive = false;
          this.SharedWithMeMyDriveactive = true;
          this.activeNode = "";
          this.activeNodeFileManager = "";
          this.menuHeader = [];
          this.menuHeaderMyDrive = [];
          this.SharedWithMeMyDriveFolderList = [];
          this.foldersMyDriveListShow = false;
          this.parentID = 0;
        }
      }
      else {
      }
    });
  }

  breadCrumbMyDriveMainClick() {
    this.MyDrivefoldersList = [];
    this.FileManagerFolderListLeft = [];
    this.menuHeaderMyDrive = [];
    this.activeNodeFileManager = "";
    this.getFileManagerFoldersList(0);
    //this.getFileManagerFolderList(); 
    this.selectButtonMyDriveShow = false;
    this.foldersMyDriveListShow = false;
  }

  breadCrumbMyDrive(menu, index) {
    this.selectButtonMyDriveShow = false;
    this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
    if (menu[index] && menu[index].items && menu[index].items.length) {
      this.MyDrivefoldersList = menu[index].items;
    }
    this.foldersMyDriveListShow = false;
    var data = this.menuHeaderMyDrive[index];
    this.getFileManagerFoldersList(data.id);
  }

  radioChangeMyDrive(form) {
    if (form.isFile == false) {
      this.MyDrivefoldersList.forEach(e => {
        e.isChecked = false
      });
      this.selectButtonMyDriveShow = false;
      this.showChildFolders(form);
      return;
    }
    if (form.isFile == true) {
      if (form.fileType != null || form.fileType != "" || form.fileType != undefined) {
        if (form.fileType != "pdf") {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
       else 
        {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          //this.PlaceholderName = form.name;
          //this.filePath = form.azureblobPath;
          // if (form.fileSize) {
          //   this.fileSizeFromMyDrive = form.fileSize;
          // } else {
          //   this.fileSizeFromMyDrive = "";
          // }

          this.MyDrivefoldersList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });

          this.fileManagerID = form.fileManagerItemID;
        }
      }
      if (form.fileType == null || form.fileType == "" || form.fileType == undefined) {
        var fileName = form.name.split('.').pop();
        if (fileName != "pdf") {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
        else 
        {
          this.MyDrivefoldersList.forEach(e => {
            e.isChecked = false
          });

          this.selectButtonMyDriveShow = true;
          //this.PlaceholderName = form.name;
          //this.filePath = form.azureblobPath;

          this.MyDrivefoldersList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true
            }
          });
          this.fileManagerID = form.fileManagerItemID;
        }
      }
    }
  }

  getIsFavorite(isFavorite) {
    isFavorite = isFavorite.isFavorite;
    return isFavorite;
  }

    // ===== Shared with me My Drive ======//

    breadCrumbMainSHaredWithMeMyDriveClick() {
      this.selectButtonMyDriveShow = false;
      this.menuHeaderMyDrive = [];
      this.getSharedWithMeMyDrive();
    }
  
    breadCrumbSharedWithMeMyDrive(menu, index) {
      this.selectButtonMyDriveShow = false;
      this.menuHeaderMyDrive.splice(index + 1, this.menuHeaderMyDrive.length - 1);
      if (menu[index] && menu[index].items && menu[index].items.length) {
        this.MyDrivefoldersList = menu[index].items;
      }
      this.foldersMyDriveListShow = false;
      var data = this.menuHeaderMyDrive[index];
      this.showChildFoldersSharedWithMeMyDrive({ type: 1, id: data.id, isFile: data.isFile, name: data.label });
    }

    showChildFoldersSharedWithMeMyDrive(folder) {
      this.isShowMyDrive = false;
      this.isSharedWithMeMyDrive = false;
      this.selectButtonMyDriveShow = false;
      this.isSharedWithMeMyDrive = true;
      this.SharedWithMeMyDriveactive = true;
      var folderId;
      if (folder.isFile == true) {
        this.menuHeaderMyDrive = [];
      }
      if (folder.fileManagerItemID == undefined) {
        folderId = folder.id;
      }
      if (folder.fileManagerItemID != undefined) {
        folderId = folder.fileManagerItemID;
      }
  
      this.menuHeaderMyDrive.push({
        label: folder.name,
        id: folderId,
        icon: 'navigate_next',
        isFile: folder.isFile
      });
      this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
      this.ChildFoldersSharedWithMeMyDrive(folder);
    }

    ChildFoldersSharedWithMeMyDrive(folder) {
      var folderId;
      if (folder.fileManagerItemID == undefined) {
        folderId = folder.id;
      }
      if (folder.fileManagerItemID != undefined) {
        folderId = folder.fileManagerItemID;
      }
      var reqModel = {
        fileManagerItemID: folderId,
        name: "",
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
        officeID: this.myOfficeID,
        permissionType: 0
      }
      this.settingsService.GetSharedWithMeFileManagerWithHierarchy(reqModel).subscribe(response => {
        if (response.status == this.statusConstant.statusSuccess) {
          this.SharedWithMeMyDriveFolderList = response.data;//.children;
          if (this.SharedWithMeMyDriveFolderList != null) {
            this.SharedWithMeMyDriveFolderList.map((res) => {
              if (res.sharedbyFirstName != null) {
                res.sharedbyFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyFirstName);
              }
              if (res.sharedbyLastName != null) {
                res.sharedbyLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.sharedbyLastName);
              }
              return res;
            });
          }
          if (this.SharedWithMeMyDriveFolderList == null || this.SharedWithMeMyDriveFolderList.length == 0) {
            this.SharedWithMeMyDriveFolderList = [];
          }
        } else {
  
        }
      });
    }
  
  
    radioChangeMyDriveSharedWithMe(form) {
      var folderId;
      if (form.isFile == false) {
        if (form.fileManagerItemID == undefined) {
          folderId = form.id;
        }
        if (form.fileManagerItemID != undefined) {
          folderId = form.fileManagerItemID;
        }
        this.menuHeaderMyDrive.push({
          label: form.name,
          id: folderId,
          icon: 'navigate_next',
          isFile: form.isFile
        });
        this.menuHeaderMyDrive = this.menuHeaderMyDrive.filter((thing, i, arr) => arr.findIndex((t) => t.id === thing.id) === i);
        this.ChildFoldersSharedWithMeMyDrive(form);
        return;
      }
  
  
      if (form.isFile == true) {
        if (form.fileType != "pdf") {
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            e.isChecked = false
          });
          this.toastr.warning('please select only pdf file.', '', {
            timeOut: 3000,
          });
          this.selectButtonMyDriveShow = false;
          return;
        }
  
        this.selectButtonMyDriveShow = true;
        
  
        this.SharedWithMeMyDriveFolderList.forEach(e => {
          e.isChecked = false;
        });
  
        if (form.fileManagerItemID == undefined) {
          this.fileManagerID = form.id;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            if (e.id == form.id) {
              e.isChecked = true;
            }
          });
        }
        if (form.fileManagerItemID != undefined) {
          this.fileManagerID = form.fileManagerItemID;
          this.SharedWithMeMyDriveFolderList.forEach(e => {
            if (e.fileManagerItemID == form.fileManagerItemID) {
              e.isChecked = true;
            }
          });
        }
      }
  
    }
    
showDataFrom3C:boolean=false;
showDataFromMyDrive:boolean=false;
searchKey:string="";

    OnChangeFormFill(TypeValue: number) {
     this.searchKey="";
     if(TypeValue==1){
      this.showDataFrom3C=true;
      this.showDataFromMyDrive=false;
     }
     if(TypeValue==2){
      this.showDataFrom3C=false;
      this.showDataFromMyDrive=true;

      this.activeNodeFileManager = "";
      this.MyDrivefoldersList = [];
      this.FileManagerFolderListLeft = [];
      this.isShowMyDrive = true;
      this.isSharedWithMeMyDrive = false;
      this.SharedWithMeMyDriveactive = false;
      this.menuHeaderMyDrive = [];
      this.menuHeader = [];  
      this.getFileManagerFoldersList(0);
      this.getFileManagerFolderList();
     }
    }

    Search(filterKey):void{
      if(filterKey!=="*"){
        this.searchKey = filterKey;
      }     
      if(filterKey!=""){
        if(filterKey=="*"){
          filterKey="";
        }           
        this.getFileManagerFoldersList(0);
    }else{
      this.searchKey="";     
      this.getFileManagerFoldersList(0);
     }    
    }

    SearchFilter(){
      if(this.searchKey!=""){       
       this.getFileManagerFoldersList(0,);
    }else{
      this.searchKey="";
      this.getFileManagerFoldersList(0);
     }  
    }

    processDocumentToVectorDB(form){
      var ReqModel = { 
        modelId: 'prebuilt-document',
        url:form.azureblobPath,
      }
      this.loaderService.show();
      this.settingsService.ExtractTextForFileManagerListProcessIcon(ReqModel).subscribe(async response => {
        if (response != undefined) {
          this.responseHolder = response; 
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
                      
                const userId = this.currentUser.UID;
                const officeId = this.myOfficeID;
                const organizationId = this.organizationId;
                this.loaderService.show();
                this.settingsService.processDocument(form.azureblobPath, userId, officeId, organizationId,this.responseHolder.data.content).subscribe(
                  response => {
                    if (response.success) {        
                      this.toastr.success('Document processed successfully');                 
                      this.AddVectorFileID(response.message,form);
                      this.loaderService.hide();
                     
                    } else {        
                      this.loaderService.hide();
                    }
                  },
                  error => {      
                    this.loaderService.hide();
                  });              

          } else {
            this.loaderService.hide();      
          }
        } else {
            this.loaderService.hide();    
        }
      });
     
    }  

     AddVectorFileID(vectorFileID:any,document) {
      var ReqModel = {
        docFrom: 4,
        documentID: document.fileManagerItemID,
        vectorFileID: vectorFileID,
        userID:this.currentUser.UID,
        organizationID:Number(this.organizationId),
        databaseID:Number(this.databaseId),
        officeID:this.myOfficeID,
       }
       this.settingsService.AddVectorFileID(ReqModel).subscribe(response => {
       if(response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
          }else{        
          }
        }else{      
        }
      });
    } 

    getTabDetailsForFillForm(event) {     
      this.searchKey="";
      if (event.tab.textLabel == "Data From 3C" || event.index == 0) {
        this.showDataFrom3C=true;
        this.showDataFromMyDrive=false;
      }
  
      if (event.tab.textLabel == "Data From My Drive" || event.index == 1) {
        this.showDataFrom3C=false;
        this.showDataFromMyDrive=true;

      this.activeNodeFileManager = "";
      this.MyDrivefoldersList = [];
      this.FileManagerFolderListLeft = [];
      this.isShowMyDrive = true;
      this.isSharedWithMeMyDrive = false;
      this.SharedWithMeMyDriveactive = false;
      this.menuHeaderMyDrive = [];
      this.menuHeader = [];  
      this.getFileManagerFoldersList(0);
      this.getFileManagerFolderList();   
      }
    }

    ClearData(){
      var data = this.ControlData;
      if (this.imagesWithFields.find(x => x.img == data.img) && this.imagesWithFields.find(x => x.img == data.img).fields.length > 0) {
        this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = "";
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = "";
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = "";
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = [];
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedValue=''; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).chkSelectedValues=[]; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).rbSelectedValues=[]; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).FileData=[]; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData=[]; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).Lat=''; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).Long=''; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCode=''; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).colorCodeAlpha=''; 
        this.imagesWithFields.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).isValueFixedFormDesignPage=false; 
        this.cdr.detectChanges();
      }
    }

  //   ClearData(){
  //     var data = this.ControlData;
  //     const imageItem = this.imagesWithFields.find(x => x.img === data.img);

  //     if (imageItem && imageItem.fields.length > 0) {
  //     const field = imageItem.fields.find(m => m.id === this.ControlId);

  //     if (field) {
  //     // Push current state for undo
  //     this.changesForUndo.push(JSON.parse(JSON.stringify(this.imagesWithFields)));

  //      // Reset field properties
  //      field.signatureBase64 = "";
  //      field.signatureText = "";
  //      field.signInitialFontFamily = "";
  //      field.ImageData = [];
  //      field.selectedValue = ""; // or null if using [(ngModel)]
  //      field.chkSelectedValues = [];
  //      field.rbSelectedValues = [];
  //      field.FileData = [];
  //      field.Lat = "";
  //      field.Long = "";
  //      field.colorCode = "";
  //      field.colorCodeAlpha = "";
  //      field.isValueFixedFormDesignPage = false;

  //      // Reset fillList (optional: refresh with same values)
  //      const existingFillList = [...field.fillList]; // clone original
  //      field.fillList = []; // clear
  //      field.fillList.push(...existingFillList); // re-push
  //      this.cdr.detectChanges();
  //    }
  //  }

  //   }

    selectColor: string = '#888';
    onSelectChange(event: any, item: any): void {
        item.selectedValue = event.target.value;
        this.selectColor = (item.selectedValue === '' || item.selectedValue === 'State') ? '#888' : '#333';
      }


}


interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}


interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}


interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}